var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _polygon, _polygon2, _polygon3, _polygon4, _path76, _rect, _rect2, _polygon5, _path77, _path78, _path79, _path80, _path81;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagenot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.61,
    cy: 82.93,
    rx: 63.3,
    ry: 58.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 635.72,
    cy: 424.33,
    rx: 62.46,
    ry: 61.28,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,66.33c-24.38-33-53.15-36.58-91.79-33-27.62,2.53-53.3,17.94-78.17,30.23-28.61,14.13-53.45,3.64-80.87-.61C408.66,58.32,391.77,48.12,362,47.4c-50.76-1.22-91.64,22.36-113.2,51.74-24,32.66-30.58,80.45-66.22,99.7-21.38,11.55-47.59,9.08-70.54,17C77.24,228,54,264.37,52.64,301.14s16.82,72.62,43.85,97.59,62.12,39.89,98,47.94l-8.46-1.05c72.81,16.08,152.59-3.07,210.16-50.46,20.6-17,39.63-37.91,65.38-44.88,30.59-8.29,62.53,5.3,94.21,6.4A120.62,120.62,0,0,0,631,333.37c14.76-10.91,27.6-26.89,27.77-45.24.23-23.64-20.33-44.29-18.14-67.82,2.79-30.12,39.32-44.76,52.52-72C705.24,123.38,709.08,93.63,689,66.33Z",
    style: {
      fill: "#f5f5f5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.89,229.5a1.79,1.79,0,1,0,1.78-1.95A1.86,1.86,0,0,0,384.89,229.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.09,135.2a1.79,1.79,0,1,0,1.78-1.94A1.87,1.87,0,0,0,481.09,135.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.24,218.1a1.79,1.79,0,1,0,1.78-1.94A1.87,1.87,0,0,0,457.24,218.1Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.17,229.5a1.27,1.27,0,1,0,1.26-1.38A1.32,1.32,0,0,0,405.17,229.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,252a.93.93,0,1,0,.92-1A1,1,0,0,0,437,252Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,228.91a.93.93,0,1,0,.92-1A1,1,0,0,0,437,228.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,169.71a.93.93,0,1,0,.93-1A1,1,0,0,0,419.76,169.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.94,210.41a.93.93,0,1,0,.92-1A1,1,0,0,0,368.94,210.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,289a.6.6,0,1,0,.59-.64A.63.63,0,0,0,468,289Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.87,249.71a.32.32,0,0,0,.3.33.31.31,0,0,0,.3-.33.31.31,0,0,0-.3-.32A.31.31,0,0,0,414.87,249.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,254.05a.3.3,0,1,0,.29-.32A.3.3,0,0,0,457,254.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.69,253a.32.32,0,0,0,.3.33.31.31,0,0,0,.3-.33.31.31,0,0,0-.3-.32A.31.31,0,0,0,467.69,253Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.17,260.5a.31.31,0,0,0,.3.32.31.31,0,0,0,.3-.32.32.32,0,0,0-.3-.33A.31.31,0,0,0,415.17,260.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.58,220.69a.59.59,0,1,0,.59-.65A.62.62,0,0,0,418.58,220.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.62,220a.59.59,0,1,0,.59-.64A.62.62,0,0,0,421.62,220Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,182.44a.59.59,0,1,0,.59-.64A.62.62,0,0,0,431.45,182.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.13,183.09a.59.59,0,1,0,.59-.65A.62.62,0,0,0,454.13,183.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.35,146.59a.62.62,0,0,0,.59.65.65.65,0,0,0,0-1.29A.62.62,0,0,0,380.35,146.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,225.53a.59.59,0,1,0,.59-.64A.62.62,0,0,0,438.85,225.53Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.72,181.15a.6.6,0,1,0,.59-.65A.63.63,0,0,0,454.72,181.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.21,181.15a.62.62,0,0,0,.59.65.65.65,0,0,0,0-1.3A.62.62,0,0,0,422.21,181.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.6,155.12a.6.6,0,1,0,.6-.64A.63.63,0,0,0,369.6,155.12Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.34,172.69a.62.62,0,0,0,.59.64.65.65,0,1,0-.59-.64Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.18,160.55a.62.62,0,0,0,.59.65.65.65,0,0,0,0-1.3A.62.62,0,0,0,469.18,160.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.69,139.28a.59.59,0,1,0,.59-.64A.62.62,0,0,0,413.69,139.28Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,158.72a.93.93,0,1,0,1.85,0,.93.93,0,1,0-1.85,0Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.68,138.64a.62.62,0,0,0,.59.65.65.65,0,0,0,0-1.3A.62.62,0,0,0,448.68,138.64Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.58,102.79a.62.62,0,0,0,.59.64.65.65,0,1,0-.59-.64Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.44,137.34a.6.6,0,1,0,.59-.64A.63.63,0,0,0,439.44,137.34Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.16,
    cy: 128.88,
    rx: 0.59,
    ry: 0.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.92,95.48a.62.62,0,0,0,.59.65.65.65,0,0,0,0-1.3A.62.62,0,0,0,430.92,95.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.32,242.85a1.18,1.18,0,0,0-1.78,0,1.46,1.46,0,0,0,0,1.94,1.18,1.18,0,0,0,1.78,0A1.44,1.44,0,0,0,407.32,242.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.22,299.29a1.86,1.86,0,1,0,1.85-2A1.94,1.94,0,0,0,411.22,299.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.46,242.3a1.86,1.86,0,1,0,1.86-2A1.95,1.95,0,0,0,674.46,242.3Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.35,244.51a1.86,1.86,0,1,0,1.86-2A1.94,1.94,0,0,0,555.35,244.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.07,263.65a1.86,1.86,0,1,0,1.86-2A1.94,1.94,0,0,0,413.07,263.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.33,299.29a1.31,1.31,0,1,0,1.31-1.42A1.38,1.38,0,0,0,432.33,299.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.48,292.17a1,1,0,1,0,1-1.05A1,1,0,0,0,379.48,292.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.45,322.72a1,1,0,1,0,1-1.05A1,1,0,0,0,465.45,322.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.45,298.68a1,1,0,1,0,1-1.05A1,1,0,0,0,465.45,298.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.51,237.07a1,1,0,1,0,1-1A1,1,0,0,0,447.51,237.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.7,361.23a.62.62,0,1,0,.62-.67A.65.65,0,0,0,497.7,361.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.64,371.61a.31.31,0,1,0,.31-.34A.32.32,0,0,0,434.64,371.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.35,325.08a.31.31,0,1,0,.61,0,.31.31,0,1,0-.61,0Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.73,
    cy: 320.33,
    rx: 0.31,
    ry: 0.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14,323.06a.31.31,0,1,0,.31-.34A.33.33,0,0,0,380.14,323.06Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.21,324.85a.31.31,0,1,0,.31-.34A.32.32,0,0,0,486.21,324.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.39,323.73a.31.31,0,1,0,.31-.33A.33.33,0,0,0,497.39,323.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.73,331.55a.31.31,0,1,0,.31-.33A.33.33,0,0,0,442.73,331.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.28,290.13a.62.62,0,1,0,.62-.67A.64.64,0,0,0,446.28,290.13Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.44,289.46a.62.62,0,1,0,1.24,0,.62.62,0,1,0-1.24,0Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.67,250.33a.62.62,0,1,0,1.24,0,.62.62,0,1,0-1.24,0Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.27,251a.62.62,0,1,0,.62-.68A.65.65,0,0,0,483.27,251Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.5,213a.62.62,0,1,0,.61-.67A.64.64,0,0,0,406.5,213Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.37,295.17a.62.62,0,1,0,.62-.67A.65.65,0,0,0,467.37,295.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.89,249a.62.62,0,1,0,.62-.67A.65.65,0,0,0,483.89,249Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.06,249a.62.62,0,1,0,.62-.67A.64.64,0,0,0,450.06,249Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.32,221.9a.65.65,0,0,0,.61.68.66.66,0,0,0,.62-.68.65.65,0,0,0-.62-.67A.64.64,0,0,0,395.32,221.9Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.79,240.18a.62.62,0,1,0,.61-.68A.64.64,0,0,0,439.79,240.18Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.94,227.55a.64.64,0,0,0,.61.67.65.65,0,0,0,.62-.67.66.66,0,0,0-.62-.68A.65.65,0,0,0,498.94,227.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.19,205.42a.62.62,0,1,0,.62-.67A.65.65,0,0,0,441.19,205.42Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.57,313.19a1.23,1.23,0,0,0-1.85,0,1.5,1.5,0,0,0,0,2,1.23,1.23,0,0,0,1.85,0A1.52,1.52,0,0,0,434.57,313.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.33,309.46a1.68,1.68,0,0,0,2.51.24,2.06,2.06,0,0,0,.22-2.73,1.68,1.68,0,0,0-2.51-.24A2.05,2.05,0,0,0,478.33,309.46Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.59,184.32a1.68,1.68,0,0,0,2.51.23,2.06,2.06,0,0,0,.22-2.73,1.68,1.68,0,0,0-2.51-.24A2.07,2.07,0,0,0,441.59,184.32Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.51,187.54a1.68,1.68,0,0,0,2.51.24,2.07,2.07,0,0,0,.21-2.74,1.68,1.68,0,0,0-2.51-.24A2.07,2.07,0,0,0,463.51,187.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.2,190.15a1.68,1.68,0,0,0,2.51.24,2.07,2.07,0,0,0,.21-2.74,1.68,1.68,0,0,0-2.51-.24A2.07,2.07,0,0,0,556.2,190.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.65,261.55a1.68,1.68,0,0,0,2.51.23,2.06,2.06,0,0,0,.22-2.73,1.68,1.68,0,0,0-2.51-.24A2.08,2.08,0,0,0,576.65,261.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,79.2a1.68,1.68,0,0,0,2.51.23,2.05,2.05,0,0,0,.22-2.73,1.68,1.68,0,0,0-2.51-.24A2.08,2.08,0,0,0,574,79.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.86,130.68a1.68,1.68,0,0,0,2.51.24,2.07,2.07,0,0,0,.22-2.74,1.68,1.68,0,0,0-2.51-.24A2.08,2.08,0,0,0,604.86,130.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,280.1a1.67,1.67,0,0,0,2.5.23,2,2,0,0,0,.22-2.73,1.68,1.68,0,0,0-2.51-.24A2.06,2.06,0,0,0,458,280.1Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.34,162.68a1.68,1.68,0,0,0,2.51.23,2.05,2.05,0,0,0,.22-2.73,1.68,1.68,0,0,0-2.51-.24A2.08,2.08,0,0,0,537.34,162.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.65,96.08a1.68,1.68,0,0,0,2.51.24,2.08,2.08,0,0,0,.22-2.74,1.68,1.68,0,0,0-2.51-.24A2.08,2.08,0,0,0,277.65,96.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.73,175.92a1.18,1.18,0,0,0,1.77.17,1.48,1.48,0,0,0,.16-1.94,1.19,1.19,0,0,0-1.78-.16A1.45,1.45,0,0,0,571.73,175.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.24,214.58a1.18,1.18,0,0,0,1.77.17,1.46,1.46,0,0,0,.16-1.94,1.19,1.19,0,0,0-1.78-.16A1.45,1.45,0,0,0,600.24,214.58Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.89,209.44a.87.87,0,0,0,1.3.12,1.07,1.07,0,0,0,.11-1.42A.87.87,0,0,0,533,208,1.07,1.07,0,0,0,532.89,209.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.23,226.83a.87.87,0,0,0,1.3.12,1.07,1.07,0,0,0,.11-1.42.87.87,0,0,0-1.3-.12A1.07,1.07,0,0,0,523.23,226.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.18,87.94a.89.89,0,0,0,1.31.13,1.08,1.08,0,0,0,.11-1.43.87.87,0,0,0-1.3-.12A1.06,1.06,0,0,0,665.18,87.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.74,153.15a.87.87,0,0,0,1.3.13,1.07,1.07,0,0,0,.12-1.43.88.88,0,0,0-1.31-.12A1.07,1.07,0,0,0,595.74,153.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.77,105.11a.87.87,0,0,0,1.3.12,1.07,1.07,0,0,0,.11-1.42.87.87,0,0,0-1.3-.12A1.07,1.07,0,0,0,560.77,105.11Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.18,305.12a.56.56,0,0,0,.83.08.68.68,0,0,0,.08-.91.56.56,0,0,0-.84-.08A.69.69,0,0,0,472.18,305.12Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.71,217a.57.57,0,0,0,.84.08.7.7,0,0,0,.07-.92.57.57,0,0,0-.84-.08A.7.7,0,0,0,573.71,217Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.22,229.07a.57.57,0,0,0,.84.08.69.69,0,0,0,.07-.91.56.56,0,0,0-.84-.08A.69.69,0,0,0,582.22,229.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.1,231.44a.57.57,0,0,0,.84.07.69.69,0,0,0,.07-.91.57.57,0,0,0-.84-.08A.7.7,0,0,0,574.1,231.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.19,282.37a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.57.57,0,0,0-.84-.08A.69.69,0,0,0,509.19,282.37Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.75,94.53a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.57.57,0,0,0-.84-.08A.69.69,0,0,0,710.75,94.53Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.49,276.83a.56.56,0,0,0,.83.08.68.68,0,0,0,.08-.91.56.56,0,0,0-.84-.08A.69.69,0,0,0,443.49,276.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.31,225.07a.28.28,0,0,0,.42,0,.35.35,0,0,0,0-.46.29.29,0,0,0-.42,0A.36.36,0,0,0,566.31,225.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.46,286.26a.35.35,0,0,0,.53.05.44.44,0,0,0,0-.57.35.35,0,0,0-.53-.05A.44.44,0,0,0,589.46,286.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.22,235.32a.28.28,0,0,0,.42,0,.34.34,0,0,0,0-.45.28.28,0,0,0-.42,0A.34.34,0,0,0,542.22,235.32Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.89,101.7a.29.29,0,0,0,.42,0,.36.36,0,0,0,0-.46.28.28,0,0,0-.42,0A.35.35,0,0,0,646.89,101.7Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.18,255.54a.28.28,0,0,0,.42,0,.35.35,0,0,0,0-.46.28.28,0,0,0-.42,0A.35.35,0,0,0,513.18,255.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.81,228.58a.28.28,0,0,0,.42,0,.34.34,0,0,0,0-.45.28.28,0,0,0-.42,0A.34.34,0,0,0,546.81,228.58Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.85,158.41a.28.28,0,0,0,.42,0,.35.35,0,0,0,0-.46.29.29,0,0,0-.42,0A.35.35,0,0,0,625.85,158.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.45,150.05a.28.28,0,0,0,.42,0,.35.35,0,0,0,0-.45.28.28,0,0,0-.42,0A.34.34,0,0,0,633.45,150.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.84,226a.29.29,0,0,0,.42,0,.35.35,0,0,0,0-.46.28.28,0,0,0-.42,0A.35.35,0,0,0,572.84,226Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.35,246.68a.29.29,0,0,0,.42,0,.35.35,0,0,0,0-.46.28.28,0,0,0-.42,0A.35.35,0,0,0,537.35,246.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.48,109.75a.29.29,0,0,0,.42,0,.35.35,0,0,0,0-.46.28.28,0,0,0-.42,0A.35.35,0,0,0,653.48,109.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.93,219.54a.56.56,0,0,0,.83.07.68.68,0,0,0,.07-.91.56.56,0,0,0-.83-.08A.69.69,0,0,0,564.93,219.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.67,259.81a.57.57,0,0,0,.84.08.69.69,0,0,0,.07-.91.55.55,0,0,0-.83-.08A.69.69,0,0,0,506.67,259.81Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.79,159.78a.57.57,0,0,0,.84.08.69.69,0,0,0,.07-.91.56.56,0,0,0-.84-.08A.69.69,0,0,0,576.79,159.78Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.29,208.56a.56.56,0,0,0,.83.08.68.68,0,0,0,.07-.91.55.55,0,0,0-.83-.08A.68.68,0,0,0,452.29,208.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.6,262.75a.56.56,0,0,0,.83.07.69.69,0,0,0,.08-.91.57.57,0,0,0-.84-.08A.69.69,0,0,0,534.6,262.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.73,157.15a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.56.56,0,0,0-.83-.08A.69.69,0,0,0,578.73,157.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.07,121.47a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.57.57,0,0,0-.84-.08A.69.69,0,0,0,564.07,121.47Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.82,106.06a.55.55,0,0,0,.83.08.68.68,0,0,0,.07-.91.56.56,0,0,0-.83-.08A.68.68,0,0,0,581.82,106.06Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.79,129.87a.57.57,0,0,0,.84.08.7.7,0,0,0,.07-.92.57.57,0,0,0-.84-.08A.7.7,0,0,0,503.79,129.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.17,149.27a.55.55,0,0,0,.83.08.69.69,0,0,0,.08-.91.56.56,0,0,0-.84-.08A.69.69,0,0,0,595.17,149.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.12,104.16a.57.57,0,0,0,.84.08.69.69,0,0,0,.07-.91.55.55,0,0,0-.83-.08A.69.69,0,0,0,581.12,104.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.23,127a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.56.56,0,0,0-.83-.08A.69.69,0,0,0,556.23,127Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.6,143.93a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.57.57,0,0,0-.84-.08A.69.69,0,0,0,500.6,143.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,230.88a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.56.56,0,0,0-.83-.08A.69.69,0,0,0,494.56,230.88Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.68,127.41a.57.57,0,0,0,.84.07.69.69,0,0,0,.07-.91.57.57,0,0,0-.84-.08A.7.7,0,0,0,543.68,127.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,78.25a.57.57,0,0,0,.84.08.69.69,0,0,0,.07-.91.55.55,0,0,0-.83-.08A.69.69,0,0,0,580,78.25Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.1,200.67a.56.56,0,0,0,.84.08.69.69,0,0,0,.07-.91.56.56,0,0,0-.83-.08A.69.69,0,0,0,485.1,200.67Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.28,249.17a.55.55,0,0,0,.83.08.69.69,0,0,0,.08-.91.57.57,0,0,0-.84-.08A.69.69,0,0,0,469.28,249.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.26,238.5a.61.61,0,0,0-.64.59.63.63,0,0,0,.54.7.61.61,0,0,0,.64-.59A.63.63,0,0,0,415.26,238.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.25,184.64a1.29,1.29,0,0,0-1.36,1.25,1.34,1.34,0,0,0,1.15,1.48,1.29,1.29,0,0,0,1.36-1.25A1.34,1.34,0,0,0,581.25,184.64Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.52,349.27a1.74,1.74,0,0,0,2.61.25,2.14,2.14,0,0,0,.23-2.85,1.75,1.75,0,0,0-2.61-.24A2.13,2.13,0,0,0,536.52,349.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.29,219a1.74,1.74,0,0,0,2.61.25,2.17,2.17,0,0,0,.23-2.85,1.76,1.76,0,0,0-2.62-.24A2.14,2.14,0,0,0,498.29,219Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.55,225.11a1.74,1.74,0,0,0,2.61.25,2.16,2.16,0,0,0,.23-2.85,1.75,1.75,0,0,0-2.61-.24A2.13,2.13,0,0,0,617.55,225.11Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.22,100a1.74,1.74,0,0,0,2.61.25,2.15,2.15,0,0,0,.22-2.85,1.75,1.75,0,0,0-2.61-.24A2.14,2.14,0,0,0,627.22,100Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.19,163.23a1.77,1.77,0,0,0,2.62.25,2.15,2.15,0,0,0,.22-2.85,1.75,1.75,0,0,0-2.61-.25A2.17,2.17,0,0,0,668.19,163.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.38,318.71A1.74,1.74,0,0,0,518,319a2.14,2.14,0,0,0,.23-2.85,1.75,1.75,0,0,0-2.61-.24A2.13,2.13,0,0,0,515.38,318.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.74,113.63a1.76,1.76,0,0,0,2.61.25,2.17,2.17,0,0,0,.23-2.85,1.75,1.75,0,0,0-2.62-.25A2.15,2.15,0,0,0,653.74,113.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.93,372.57a1.24,1.24,0,0,0,1.85.17,1.53,1.53,0,0,0,.16-2,1.24,1.24,0,0,0-1.85-.18A1.53,1.53,0,0,0,522.93,372.57Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.71,210.31a1.24,1.24,0,0,0,1.85.17,1.53,1.53,0,0,0,.16-2,1.24,1.24,0,0,0-1.85-.17A1.52,1.52,0,0,0,633.71,210.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.17,242a1.24,1.24,0,0,0,1.85.17,1.53,1.53,0,0,0,.16-2,1.24,1.24,0,0,0-1.85-.18A1.54,1.54,0,0,0,696.17,242Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.09,318.81a1.23,1.23,0,0,0,1.84.17,1.5,1.5,0,0,0,.16-2,1.24,1.24,0,0,0-1.84-.18A1.52,1.52,0,0,0,551.09,318.81Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.6,302.09a1.24,1.24,0,0,0,1.85.17,1.52,1.52,0,0,0,.16-2,1.24,1.24,0,0,0-1.85-.17A1.53,1.53,0,0,0,453.6,302.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.77,299a.89.89,0,0,0,1.35.13,1.12,1.12,0,0,0,.12-1.48.91.91,0,0,0-1.36-.12A1.1,1.1,0,0,0,548.77,299Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.05,241.92a.91.91,0,0,0,1.36.13,1.12,1.12,0,0,0,.12-1.48.92.92,0,0,0-1.36-.13A1.12,1.12,0,0,0,589.05,241.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.35,164.25a.91.91,0,0,0,1.36.13,1.12,1.12,0,0,0,.12-1.48.92.92,0,0,0-1.36-.13A1.12,1.12,0,0,0,703.35,164.25Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.51,103.72a.9.9,0,0,0,1.35.12,1.1,1.1,0,0,0,.12-1.47.9.9,0,0,0-1.36-.13A1.12,1.12,0,0,0,714.51,103.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.61,152a.92.92,0,0,0,1.36.13,1.12,1.12,0,0,0,.12-1.48.91.91,0,0,0-1.36-.13A1.12,1.12,0,0,0,608.61,152Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.12,344.75a.58.58,0,0,0,.87.08.72.72,0,0,0,.08-.94.59.59,0,0,0-.88-.09A.72.72,0,0,0,530.12,344.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.84,315.4a.58.58,0,0,0,.87.08.71.71,0,0,0,.08-1,.59.59,0,0,0-.87-.08A.73.73,0,0,0,553.84,315.4Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.7,327.93a.58.58,0,0,0,.87.08.7.7,0,0,0,.07-.94.58.58,0,0,0-.87-.09A.72.72,0,0,0,562.7,327.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.25,330.39a.58.58,0,0,0,.87.09.72.72,0,0,0,.07-1,.58.58,0,0,0-.87-.08A.7.7,0,0,0,554.25,330.39Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.63,321.08a.58.58,0,0,0,.87.08.71.71,0,0,0,.08-1,.59.59,0,0,0-.87-.08A.72.72,0,0,0,568.63,321.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.31,211.88a.59.59,0,0,0,.87.08.72.72,0,0,0,.07-1,.59.59,0,0,0-.87-.08A.72.72,0,0,0,720.31,211.88Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.26,315.31a.59.59,0,0,0,.88.09.72.72,0,0,0,.07-.95.58.58,0,0,0-.87-.08A.72.72,0,0,0,500.26,315.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.15,323.77a.29.29,0,0,0,.43,0,.35.35,0,0,0,0-.47.29.29,0,0,0-.43,0A.35.35,0,0,0,546.15,323.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.16,264a.28.28,0,0,0,.43,0,.37.37,0,0,0,0-.48.29.29,0,0,0-.43,0A.35.35,0,0,0,678.16,264Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603,272.12a.29.29,0,0,0,.43,0,.35.35,0,0,0,0-.47.29.29,0,0,0-.43,0A.34.34,0,0,0,603,272.12Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.85,219.33a.29.29,0,0,0,.44,0,.35.35,0,0,0,0-.47.3.3,0,0,0-.44,0A.35.35,0,0,0,653.85,219.33Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.79,293.16a.3.3,0,0,0,.44,0,.36.36,0,0,0,0-.48.29.29,0,0,0-.43,0A.37.37,0,0,0,572.79,293.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.78,265.11a.3.3,0,0,0,.44,0,.35.35,0,0,0,0-.47.28.28,0,0,0-.43-.05A.37.37,0,0,0,607.78,265.11Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690,192.08a.28.28,0,0,0,.43,0,.37.37,0,0,0,0-.48.3.3,0,0,0-.44,0A.35.35,0,0,0,690,192.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.94,183.39a.3.3,0,0,0,.44,0,.35.35,0,0,0,0-.47.28.28,0,0,0-.43,0A.35.35,0,0,0,697.94,183.39Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.94,324.72a.29.29,0,0,0,.44,0,.37.37,0,0,0,0-.48.29.29,0,0,0-.43,0A.35.35,0,0,0,552.94,324.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.94,283.94a.3.3,0,0,0,.44,0,.37.37,0,0,0,0-.48.3.3,0,0,0-.44,0A.37.37,0,0,0,597.94,283.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.72,227.71a.29.29,0,0,0,.43,0,.35.35,0,0,0,0-.47.29.29,0,0,0-.44,0A.35.35,0,0,0,660.72,227.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.7,318a.58.58,0,0,0,.87.08.72.72,0,0,0,.08-.95.59.59,0,0,0-.87-.08A.72.72,0,0,0,544.7,318Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566,297.6a.58.58,0,0,0,.87.09.72.72,0,0,0,.07-.95.58.58,0,0,0-.87-.08A.71.71,0,0,0,566,297.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.79,110.61a.58.58,0,0,0,.87.09.72.72,0,0,0,.07-1,.58.58,0,0,0-.87-.08A.7.7,0,0,0,694.79,110.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.42,244.27a.59.59,0,0,0,.87.09.72.72,0,0,0,.08-1,.58.58,0,0,0-.87-.09A.71.71,0,0,0,509.42,244.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.26,194.31a.59.59,0,0,0,.87.08.72.72,0,0,0,.07-.95.59.59,0,0,0-.87-.08A.72.72,0,0,0,501.26,194.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.07,300.66a.59.59,0,0,0,.87.08.72.72,0,0,0,.08-.95.59.59,0,0,0-.87-.08A.72.72,0,0,0,595.07,300.66Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.81,107.88a.58.58,0,0,0,.87.08.72.72,0,0,0,.08-.95.59.59,0,0,0-.87-.08A.71.71,0,0,0,696.81,107.88Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.74,153.65a.59.59,0,0,0,.87.08.71.71,0,0,0,.08-.95.59.59,0,0,0-.87-.08A.72.72,0,0,0,625.74,153.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.21,137.61a.58.58,0,0,0,.87.09.72.72,0,0,0,.08-.95.58.58,0,0,0-.87-.09A.71.71,0,0,0,644.21,137.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,162.38a.58.58,0,0,0,.87.08.7.7,0,0,0,.07-.94.58.58,0,0,0-.87-.09A.72.72,0,0,0,563,162.38Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.11,185.21a.58.58,0,0,0,.87.08.72.72,0,0,0,.08-.95.6.6,0,0,0-.88-.08A.72.72,0,0,0,513.11,185.21Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.91,99.68a.59.59,0,0,0,.87.08.72.72,0,0,0,.07-1,.58.58,0,0,0-.87-.08A.72.72,0,0,0,713.91,99.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.49,135.63a.59.59,0,0,0,.87.09.72.72,0,0,0,.08-.95.58.58,0,0,0-.87-.09A.71.71,0,0,0,643.49,135.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.59,159.36a.58.58,0,0,0,.87.08.72.72,0,0,0,.08-.95.59.59,0,0,0-.87-.08A.71.71,0,0,0,617.59,159.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.7,177a.58.58,0,0,0,.87.08.71.71,0,0,0,.07-.94.58.58,0,0,0-.87-.09A.72.72,0,0,0,559.7,177Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.42,267.5a.58.58,0,0,0,.87.08.72.72,0,0,0,.07-.95.59.59,0,0,0-.87-.08A.72.72,0,0,0,553.42,267.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.53,159.82a.58.58,0,0,0,.87.08.7.7,0,0,0,.07-.94.58.58,0,0,0-.87-.09A.72.72,0,0,0,604.53,159.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.28,99.76a.59.59,0,0,0,.87.08.72.72,0,0,0,.07-1,.59.59,0,0,0-.87-.08A.72.72,0,0,0,680.28,99.76Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.57,236.07a.59.59,0,0,0,.87.08.72.72,0,0,0,.08-1,.58.58,0,0,0-.87-.08A.72.72,0,0,0,543.57,236.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.09,132.23a.59.59,0,0,0,.87.08.72.72,0,0,0,.07-.95.58.58,0,0,0-.87-.08A.72.72,0,0,0,585.09,132.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681,128.17a1.81,1.81,0,0,0-2,1.66,1.91,1.91,0,0,0,1.52,2.19,1.82,1.82,0,0,0,2-1.66A1.93,1.93,0,0,0,681,128.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,78.42a1.82,1.82,0,0,0-2,1.66,1.93,1.93,0,0,0,1.52,2.19,1.81,1.81,0,0,0,2-1.66A1.93,1.93,0,0,0,395.56,78.42Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.91,83.47a.94.94,0,0,0-1.05.86,1,1,0,0,0,.79,1.13.94.94,0,0,0,1.05-.86A1,1,0,0,0,469.91,83.47Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.9,86.63a.94.94,0,0,0-1,.86,1,1,0,0,0,.79,1.13.94.94,0,0,0,1-.86A1,1,0,0,0,490.9,86.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,197.64a.94.94,0,0,0-1.05.86,1,1,0,0,0,.79,1.14,1,1,0,0,0,1.05-.86A1,1,0,0,0,355.45,197.64Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.33,104.73a.31.31,0,0,0-.34.28.32.32,0,0,0,.25.36.3.3,0,0,0,.34-.27A.33.33,0,0,0,465.33,104.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.83,116.48a.31.31,0,0,0-.34.28.31.31,0,0,0,.26.36.29.29,0,0,0,.33-.27A.33.33,0,0,0,464.83,116.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,101.26a.6.6,0,0,0-.66.55.63.63,0,0,0,.5.73.6.6,0,0,0,.67-.55A.63.63,0,0,0,253.13,101.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.31,104.63a.6.6,0,0,0-.67.55.63.63,0,0,0,.51.73.6.6,0,0,0,.66-.55A.63.63,0,0,0,253.31,104.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.27,208.51a.61.61,0,0,0-.67.56.65.65,0,0,0,.51.73.62.62,0,0,0,.67-.56A.65.65,0,0,0,342.27,208.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.32,86.06a.61.61,0,0,0-.67.55.65.65,0,0,0,.51.73.6.6,0,0,0,.67-.55A.64.64,0,0,0,515.32,86.06Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.72,89.09a.59.59,0,0,0-.67.55.64.64,0,0,0,.5.73.6.6,0,0,0,.67-.55A.63.63,0,0,0,493.72,89.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517,87a.6.6,0,0,0-.67.55.64.64,0,0,0,.5.73.6.6,0,0,0,.67-.55A.63.63,0,0,0,517,87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.71,198.71a.61.61,0,0,0-.67.56.65.65,0,0,0,.51.73.61.61,0,0,0,.67-.56A.65.65,0,0,0,344.71,198.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.75,189.21a.61.61,0,0,0-.67.55.63.63,0,0,0,.51.73.6.6,0,0,0,.67-.55A.65.65,0,0,0,353.75,189.21Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19,133.23a.93.93,0,1,0,1.85,0,.93.93,0,1,0-1.85,0Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.13,106.29a.63.63,0,0,0,.6.65.65.65,0,1,0-.6-.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.81,157.77a1.68,1.68,0,0,0,2.51.24,2.08,2.08,0,0,0,.22-2.74A1.68,1.68,0,0,0,397,155,2.05,2.05,0,0,0,396.81,157.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.7,120.47a.94.94,0,0,0-1.05.86,1,1,0,0,0,.79,1.14,1,1,0,0,0,1.05-.87A1,1,0,0,0,374.7,120.47Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.52,131.34a.61.61,0,0,0-.67.55.65.65,0,0,0,.51.73.61.61,0,0,0,.67-.55A.65.65,0,0,0,361.52,131.34Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,121.54a.61.61,0,0,0-.67.55.64.64,0,0,0,.51.73.6.6,0,0,0,.67-.55A.65.65,0,0,0,364,121.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,112a.61.61,0,0,0-.67.55.65.65,0,0,0,.51.73.6.6,0,0,0,.67-.55A.64.64,0,0,0,373,112Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.91,90.59a.6.6,0,0,0-.67.55.63.63,0,0,0,.51.73.6.6,0,0,0,.67-.55A.65.65,0,0,0,546.91,90.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5,117.58a1.89,1.89,0,0,0-2.09,1.73,2,2,0,0,0,1.59,2.28,1.89,1.89,0,0,0,2.09-1.73A2,2,0,0,0,425.5,117.58Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.92,175.85a1.89,1.89,0,0,0-2.09,1.73,2,2,0,0,0,1.58,2.27,1.88,1.88,0,0,0,2.09-1.72A2,2,0,0,0,386.92,175.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,96.87a1,1,0,0,0-1.08.89,1,1,0,0,0,.82,1.19,1,1,0,0,0,1.08-.9A1,1,0,0,0,482,96.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.33,108.18a.62.62,0,0,0-.69.58.66.66,0,0,0,.52.76.64.64,0,0,0,.7-.58A.66.66,0,0,0,468.33,108.18Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.62,108.24a.63.63,0,0,0-.69.58.66.66,0,0,0,.52.76.64.64,0,0,0,.7-.58A.67.67,0,0,0,449.62,108.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.76,89.26a.64.64,0,0,0-.7.58.66.66,0,0,0,.53.76.63.63,0,0,0,.69-.58A.66.66,0,0,0,261.76,89.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.37,109.19a.63.63,0,0,0-.69.57.66.66,0,0,0,.53.76.62.62,0,0,0,.69-.57A.66.66,0,0,0,451.37,109.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.87,98a.62.62,0,0,0-.69.58.66.66,0,0,0,.52.76.64.64,0,0,0,.7-.58A.67.67,0,0,0,470.87,98Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.28,88.1a.63.63,0,0,0-.7.57.67.67,0,0,0,.53.76.63.63,0,0,0,.7-.57A.66.66,0,0,0,480.28,88.1Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.31,112.3a.64.64,0,0,0-.7.58.66.66,0,0,0,.53.76.62.62,0,0,0,.69-.58A.66.66,0,0,0,490.31,112.3Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.8,69a.62.62,0,0,0-.69.57.66.66,0,0,0,.52.76.64.64,0,0,0,.7-.57A.66.66,0,0,0,496.8,69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.1,286.53a.58.58,0,0,0,.87.09.72.72,0,0,0,.08-.95.59.59,0,0,0-.87-.09A.71.71,0,0,0,527.1,286.53Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.22,253.59a.63.63,0,0,0-.67.61.66.66,0,0,0,.57.73.62.62,0,0,0,.66-.61A.65.65,0,0,0,443.22,253.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.89,275.43a.64.64,0,0,0-.67.61.66.66,0,0,0,.57.73.62.62,0,0,0,.66-.61A.66.66,0,0,0,470.89,275.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.17,353.37a.31.31,0,0,0-.33.31.33.33,0,0,0,.28.36.31.31,0,0,0,.33-.31A.33.33,0,0,0,504.17,353.37Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.41,299.25a.64.64,0,0,0-.67.62.65.65,0,0,0,.56.72A.63.63,0,0,0,471,300,.66.66,0,0,0,470.41,299.25Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.29,289.33a1.35,1.35,0,0,0-1.42,1.3,1.4,1.4,0,0,0,1.2,1.54,1.34,1.34,0,0,0,1.41-1.3A1.38,1.38,0,0,0,449.29,289.33Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.56,282a.31.31,0,0,0-.33.31.31.31,0,1,0,.62.06A.34.34,0,0,0,449.56,282Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.14,286.57a.32.32,0,0,0-.33.31.32.32,0,0,0,.28.36.31.31,0,0,0,.33-.3A.33.33,0,0,0,444.14,286.57Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.32,285a.64.64,0,0,0-.67.61.66.66,0,0,0,.57.73.64.64,0,0,0,.67-.61A.67.67,0,0,0,454.32,285Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.63,219.38a1.34,1.34,0,0,0-1.42,1.3,1.38,1.38,0,0,0,1.19,1.54,1.35,1.35,0,0,0,1.42-1.3A1.4,1.4,0,0,0,643.63,219.38Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.4,339.17a.64.64,0,0,0-.67.62.66.66,0,0,0,.56.73.64.64,0,0,0,.67-.62A.66.66,0,0,0,508.4,339.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.91,321.24a.89.89,0,0,0,1.27.37,1.07,1.07,0,0,0,.34-1.38.89.89,0,0,0-1.27-.37A1.07,1.07,0,0,0,569.91,321.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.72,336.4a.57.57,0,0,0,.81.24.66.66,0,0,0,.22-.88.56.56,0,0,0-.81-.24A.68.68,0,0,0,613.72,336.4Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.7,331.3a.27.27,0,0,0,.4.12.33.33,0,0,0,.11-.44.27.27,0,0,0-.4-.12A.33.33,0,0,0,549.7,331.3Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.13,312.14a.28.28,0,0,0,.4.12.34.34,0,0,0,.11-.45.28.28,0,0,0-.4-.11A.33.33,0,0,0,588.13,312.14Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,305.36a.29.29,0,0,0,.4.12.35.35,0,0,0,.11-.45.29.29,0,0,0-.4-.12A.33.33,0,0,0,597,305.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9,340.48a.28.28,0,0,0,.41.12.33.33,0,0,0,.1-.44.27.27,0,0,0-.4-.12A.34.34,0,0,0,554.9,340.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.26,376.24a1.79,1.79,0,0,0,2.54.74,2.13,2.13,0,0,0,.68-2.76,1.78,1.78,0,0,0-2.54-.74A2.13,2.13,0,0,0,569.26,376.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.05,252a1.77,1.77,0,0,0,2.53.74,2.13,2.13,0,0,0,.68-2.76,1.79,1.79,0,0,0-2.54-.74A2.12,2.12,0,0,0,629.05,252Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.53,344.35a1.77,1.77,0,0,0,2.53.74,2.12,2.12,0,0,0,.68-2.76,1.78,1.78,0,0,0-2.53-.74A2.12,2.12,0,0,0,554.53,344.35Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.55,364.74a1.26,1.26,0,0,0,1.79.52,1.5,1.5,0,0,0,.48-1.95,1.25,1.25,0,0,0-1.79-.53A1.51,1.51,0,0,0,587.55,364.74Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.51,387.36a.93.93,0,0,0,1.32.39,1.11,1.11,0,0,0,.35-1.44.92.92,0,0,0-1.32-.38A1.1,1.1,0,0,0,538.51,387.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627,367a.93.93,0,0,0,1.32.38,1.09,1.09,0,0,0,.35-1.43.92.92,0,0,0-1.31-.39A1.12,1.12,0,0,0,627,367Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,346.16a.92.92,0,0,0,1.32.39,1.11,1.11,0,0,0,.35-1.44.93.93,0,0,0-1.32-.38A1.09,1.09,0,0,0,616,346.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.56,382.77a.59.59,0,0,0,.85.24.71.71,0,0,0,.22-.92.58.58,0,0,0-.84-.24A.7.7,0,0,0,672.56,382.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.21,364.19a.29.29,0,0,0,.42.12.35.35,0,0,0,.11-.46.29.29,0,0,0-.42-.12A.35.35,0,0,0,481.21,364.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.82,348.7a.3.3,0,0,0,.42.13.36.36,0,0,0,.12-.46.31.31,0,0,0-.43-.13A.37.37,0,0,0,463.82,348.7Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.94,377.46a.29.29,0,0,0,.42.12.35.35,0,0,0,.11-.46.29.29,0,0,0-.42-.12A.35.35,0,0,0,605.94,377.46Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.64,342.71a.31.31,0,0,0,.43.12.36.36,0,0,0,.11-.46.29.29,0,0,0-.42-.12A.36.36,0,0,0,469.64,342.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.93,357.51a.29.29,0,0,0,.42.13.35.35,0,0,0,.11-.46.3.3,0,0,0-.42-.13A.35.35,0,0,0,645.93,357.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.11,350.46a.29.29,0,0,0,.42.12.35.35,0,0,0,.11-.46.29.29,0,0,0-.42-.12A.35.35,0,0,0,655.11,350.46Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,359.37a.29.29,0,0,0,.42.13.36.36,0,0,0,.12-.46.31.31,0,0,0-.43-.13A.37.37,0,0,0,456.94,359.37Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.35,387a.29.29,0,0,0,.42.12.36.36,0,0,0,.12-.46.31.31,0,0,0-.43-.12A.37.37,0,0,0,611.35,387Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.43,349.2a.59.59,0,0,0,.84.25.71.71,0,0,0,.23-.92.59.59,0,0,0-.84-.25A.71.71,0,0,0,595.43,349.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.86,346.89a.58.58,0,0,0,.84.25.7.7,0,0,0,.23-.92.59.59,0,0,0-.84-.25A.71.71,0,0,0,597.86,346.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.78,307.43a.6.6,0,0,0,.85.25.71.71,0,0,0,.22-.92.59.59,0,0,0-.84-.25A.71.71,0,0,0,588.78,307.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.53,295.16a.59.59,0,0,0,.85.24.71.71,0,0,0,.22-.92.58.58,0,0,0-.84-.24A.7.7,0,0,0,609.53,295.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,342.07a.58.58,0,0,0,.84.25.71.71,0,0,0,.23-.92.59.59,0,0,0-.84-.25A.71.71,0,0,0,616,342.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.14,293.07a.6.6,0,0,0,.85.25.71.71,0,0,0,.22-.92.58.58,0,0,0-.84-.25A.71.71,0,0,0,609.14,293.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.84,311.5a.59.59,0,0,0,.84.25.71.71,0,0,0,.23-.92.6.6,0,0,0-.85-.25A.71.71,0,0,0,579.84,311.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.86,375.55a1.31,1.31,0,0,0-1.61,1,1.45,1.45,0,0,0,.93,1.75,1.3,1.3,0,0,0,1.61-1A1.46,1.46,0,0,0,595.86,375.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.05,348.48a1.75,1.75,0,0,0,2.29-1.16,2,2,0,0,0-1.07-2.49A1.75,1.75,0,0,0,631,346,2,2,0,0,0,632.05,348.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601,334.11a1.75,1.75,0,0,0,2.29-1.16,2,2,0,0,0-1.07-2.49,1.75,1.75,0,0,0-2.28,1.17A2,2,0,0,0,601,334.11Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.75,315.5a1.24,1.24,0,0,0,1.62-.82,1.41,1.41,0,0,0-.76-1.76,1.23,1.23,0,0,0-1.61.82A1.41,1.41,0,0,0,630.75,315.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.11,300.26a.91.91,0,0,0,1.19-.61,1,1,0,0,0-.56-1.29.9.9,0,0,0-1.18.6A1,1,0,0,0,620.11,300.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.73,348.07a.58.58,0,0,0,.76-.39.64.64,0,0,0-.35-.82.57.57,0,0,0-.76.38A.67.67,0,0,0,624.73,348.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.55,311.22a.58.58,0,0,0,.76-.39A.67.67,0,0,0,632,310a.59.59,0,0,0-.76.39A.67.67,0,0,0,631.55,311.22Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.44,317a.57.57,0,0,0,.76-.38.67.67,0,0,0-.35-.83.59.59,0,0,0-.77.39A.66.66,0,0,0,644.44,317Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.49,323.49a.58.58,0,0,0,.76-.39.66.66,0,0,0-.35-.83.58.58,0,0,0-.76.39A.66.66,0,0,0,638.49,323.49Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.36,308.2a.57.57,0,0,0,.76-.38.67.67,0,0,0-.35-.83.58.58,0,0,0-.76.39A.64.64,0,0,0,646.36,308.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.91,339.2a.58.58,0,0,0,.76-.39.66.66,0,0,0-.35-.83.58.58,0,0,0-.76.39A.67.67,0,0,0,586.91,339.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.83,322.22a.29.29,0,0,0,.38-.2.32.32,0,0,0-.18-.41.29.29,0,0,0-.38.19A.35.35,0,0,0,628.83,322.22Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.52,282.79a.3.3,0,0,0,.38-.2.32.32,0,0,0-.18-.41.29.29,0,0,0-.38.19A.35.35,0,0,0,637.52,282.79Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.9,319.45a.3.3,0,0,0,.39-.19.34.34,0,0,0-.18-.41.28.28,0,0,0-.38.19A.32.32,0,0,0,634.9,319.45Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.39,261.94a.28.28,0,0,0,.38-.19.33.33,0,0,0-.18-.42.3.3,0,0,0-.38.2A.34.34,0,0,0,654.39,261.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.09,318.18a.58.58,0,0,0,.76-.39.67.67,0,0,0-.35-.83.59.59,0,0,0-.77.39A.67.67,0,0,0,625.09,318.18Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.84,290a.57.57,0,0,0,.76-.38.67.67,0,0,0-.35-.83.6.6,0,0,0-.77.38A.67.67,0,0,0,633.84,290Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.37,277.36a.58.58,0,0,0,.76-.38.67.67,0,0,0-.36-.83.58.58,0,0,0-.76.38A.67.67,0,0,0,659.37,277.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.57,301.19a.57.57,0,0,0,.76-.38A.67.67,0,0,0,597,300a.6.6,0,0,0-.77.38A.67.67,0,0,0,596.57,301.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.71,351.26a1.81,1.81,0,0,0,2.37-1.21,2.07,2.07,0,0,0-1.11-2.59,1.81,1.81,0,0,0-2.37,1.21A2.08,2.08,0,0,0,700.71,351.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.39,336.31a1.81,1.81,0,0,0,2.37-1.21,2.07,2.07,0,0,0-1.11-2.59,1.81,1.81,0,0,0-2.37,1.21A2.07,2.07,0,0,0,668.39,336.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.62,378.84a1.28,1.28,0,0,0,1.68-.85,1.48,1.48,0,0,0-.79-1.84,1.29,1.29,0,0,0-1.68.86A1.47,1.47,0,0,0,699.62,378.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.36,316.94a1.29,1.29,0,0,0,1.68-.86,1.48,1.48,0,0,0-.79-1.83,1.28,1.28,0,0,0-1.68.86A1.47,1.47,0,0,0,699.36,316.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.26,355.57a1.29,1.29,0,0,0,1.68-.86,1.48,1.48,0,0,0-.79-1.83,1.29,1.29,0,0,0-1.68.86A1.47,1.47,0,0,0,607.26,355.57Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.28,301.08a1,1,0,0,0,1.23-.63,1.07,1.07,0,0,0-.57-1.35,1,1,0,0,0-1.24.63A1.09,1.09,0,0,0,688.28,301.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.09,350.83a.6.6,0,0,0,.79-.4.68.68,0,0,0-.37-.86.6.6,0,0,0-.79.4A.68.68,0,0,0,693.09,350.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.18,312.48a.6.6,0,0,0,.79-.4.67.67,0,0,0-.37-.86.6.6,0,0,0-.79.4A.69.69,0,0,0,700.18,312.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.6,318.51a.6.6,0,0,0,.79-.4.68.68,0,0,0-.37-.86.6.6,0,0,0-.79.4A.68.68,0,0,0,713.6,318.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.41,325.25a.6.6,0,0,0,.79-.4.7.7,0,0,0-.37-.87.61.61,0,0,0-.79.41A.69.69,0,0,0,707.41,325.25Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.74,341.6a.6.6,0,0,0,.79-.4.71.71,0,0,0-.37-.87.61.61,0,0,0-.79.41A.68.68,0,0,0,653.74,341.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.35,323.93a.31.31,0,0,0,.4-.21.35.35,0,0,0-.18-.43.31.31,0,0,0-.4.2A.35.35,0,0,0,697.35,323.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.67,321.05a.3.3,0,0,0,.4-.2.34.34,0,0,0-.18-.43.31.31,0,0,0-.4.2A.34.34,0,0,0,703.67,321.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.46,319.73a.61.61,0,0,0,.79-.41.69.69,0,0,0-.37-.86.6.6,0,0,0-.79.4A.7.7,0,0,0,693.46,319.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.57,290.44a.61.61,0,0,0,.79-.41.69.69,0,0,0-.37-.86.6.6,0,0,0-.79.4A.7.7,0,0,0,702.57,290.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.85,271.23a.6.6,0,0,0,.79-.4.7.7,0,0,0-.37-.87.61.61,0,0,0-.79.41A.69.69,0,0,0,677.85,271.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.78,302.05a.61.61,0,0,0,.8-.4.71.71,0,0,0-.37-.87.62.62,0,0,0-.8.41A.7.7,0,0,0,663.78,302.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576,319.21a.7.7,0,0,0-.3.9.6.6,0,0,0,.82.32.7.7,0,0,0,.3-.89A.6.6,0,0,0,576,319.21Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,323.05a.7.7,0,0,0-.3.9.6.6,0,0,0,.82.33.71.71,0,0,0,.3-.9A.6.6,0,0,0,610,323.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.57,372.43a.35.35,0,0,0-.15.45.3.3,0,0,0,.41.16.36.36,0,0,0,.15-.45A.3.3,0,0,0,674.57,372.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.51,344a.69.69,0,0,0-.3.89.6.6,0,0,0,.82.33.71.71,0,0,0,.3-.9A.59.59,0,0,0,620.51,344Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.67,346.86a1.48,1.48,0,0,0-.63,1.9,1.26,1.26,0,0,0,1.74.69,1.48,1.48,0,0,0,.63-1.9A1.27,1.27,0,0,0,597.67,346.86Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.55,340.38a.35.35,0,0,0-.15.44.3.3,0,0,0,.41.17.35.35,0,0,0,.15-.45A.29.29,0,0,0,594.55,340.38Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592,347.28a.35.35,0,0,0-.15.45.29.29,0,0,0,.41.16.36.36,0,0,0,.15-.45A.3.3,0,0,0,592,347.28Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,340.35a.69.69,0,0,0-.3.89.6.6,0,0,0,.82.33.7.7,0,0,0,.3-.9A.59.59,0,0,0,600,340.35Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.72,357.84a.69.69,0,0,0-.3.89.6.6,0,0,0,.82.33.7.7,0,0,0,.3-.9A.59.59,0,0,0,671.72,357.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,249.23a1.78,1.78,0,1,0-1.77,1.93A1.85,1.85,0,0,0,372.15,249.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.46,321.25a1.78,1.78,0,1,0-1.78,1.94A1.87,1.87,0,0,0,293.46,321.25Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.2,260.56a1.78,1.78,0,1,0-1.77,1.93A1.85,1.85,0,0,0,300.2,260.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.38,283.29a1.78,1.78,0,1,0-1.77,1.93A1.86,1.86,0,0,0,370.38,283.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,249.23a1.25,1.25,0,1,0-1.25,1.36A1.31,1.31,0,0,0,352,249.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,226.84a.92.92,0,1,0-.92,1A1,1,0,0,0,320.34,226.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,249.82a.92.92,0,1,0-.92,1A1,1,0,0,0,320.34,249.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,308.69a.92.92,0,1,0-.92,1A1,1,0,0,0,337.47,308.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.51,190a.62.62,0,0,0-.59-.64.65.65,0,1,0,.59.64Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.33,229.13a.31.31,0,0,0-.29-.33.33.33,0,0,0,0,.65A.31.31,0,0,0,342.33,229.13Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,224.81a.31.31,0,0,0-.3-.32.32.32,0,0,0,0,.64A.31.31,0,0,0,300.5,224.81Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.81,225.87a.3.3,0,1,0-.3.33A.31.31,0,0,0,289.81,225.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,218.4a.3.3,0,1,0-.3.32A.31.31,0,0,0,342,218.4Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,258a.62.62,0,0,0-.59-.65.65.65,0,0,0,0,1.29A.62.62,0,0,0,338.65,258Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.63,258.63a.59.59,0,1,0-1.18,0,.59.59,0,1,0,1.18,0Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.26,
    cy: 296.02,
    rx: 0.59,
    ry: 0.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,295.37a.59.59,0,1,0-.59.65A.62.62,0,0,0,303.3,295.37Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,331.67a.62.62,0,0,0-.59-.64.64.64,0,0,0,0,1.28A.62.62,0,0,0,376.67,331.67Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,253.17a.6.6,0,1,0-.59.64A.62.62,0,0,0,318.5,253.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,297.31a.59.59,0,1,0-.59.64A.62.62,0,0,0,302.71,297.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,297.31a.59.59,0,1,0-.59.64A.62.62,0,0,0,335,297.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,323.19a.62.62,0,0,0-.59-.65.65.65,0,0,0,0,1.29A.62.62,0,0,0,387.35,323.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,305.72a.62.62,0,0,0-.59-.64.65.65,0,0,0,0,1.29A.63.63,0,0,0,344.86,305.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.33,317.79a.61.61,0,0,0-.59-.64.64.64,0,0,0,0,1.28A.61.61,0,0,0,288.33,317.79Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,338.94a.62.62,0,0,0-.59-.65.65.65,0,0,0,0,1.29A.62.62,0,0,0,343.51,338.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.84,236a1.18,1.18,0,0,0,1.77,0,1.45,1.45,0,0,0,0-1.93,1.18,1.18,0,0,0-1.77,0A1.45,1.45,0,0,0,349.84,236Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,179.82a1.85,1.85,0,1,0-1.85,2A1.94,1.94,0,0,0,346,179.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.07,254.77a1.85,1.85,0,1,0-1.84,2A1.93,1.93,0,0,0,264.07,254.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.09,191.61a1.85,1.85,0,1,0-1.84,2A1.93,1.93,0,0,0,271.09,191.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12,215.27a1.85,1.85,0,1,0-1.84,2A1.93,1.93,0,0,0,344.12,215.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,179.82a1.31,1.31,0,1,0-1.3,1.42A1.37,1.37,0,0,0,325,179.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.53,186.9a1,1,0,1,0-1,1A1,1,0,0,0,377.53,186.9Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,156.52a1,1,0,1,0-1,1A1,1,0,0,0,292.05,156.52Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,180.43a1,1,0,1,0-1,1A1,1,0,0,0,292.05,180.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,241.69a1,1,0,1,0-1,1.05A1,1,0,0,0,309.88,241.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.36,
    cy: 118.23,
    rx: 0.61,
    ry: 0.67,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,107.91a.31.31,0,0,0-.3-.33.34.34,0,0,0,0,.67A.32.32,0,0,0,322.67,107.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.63,154.18a.31.31,0,1,0-.31.33A.33.33,0,0,0,384.63,154.18Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,158.9a.31.31,0,1,0-.31.34A.32.32,0,0,0,314.94,158.9Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,156.19a.31.31,0,1,0-.31.33A.33.33,0,0,0,376.88,156.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,154.41a.32.32,0,0,0-.31-.33.34.34,0,0,0,0,.67A.33.33,0,0,0,271.4,154.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,155.52a.31.31,0,1,0-.31.33A.33.33,0,0,0,260.28,155.52Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,147.74a.31.31,0,1,0-.31.34A.32.32,0,0,0,314.63,147.74Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.11,188.93a.65.65,0,0,0-.62-.67.67.67,0,0,0,0,1.34A.65.65,0,0,0,311.11,188.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,189.6a.64.64,0,0,0-.61-.67.67.67,0,0,0,0,1.34A.64.64,0,0,0,308,189.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.79,228.51a.65.65,0,0,0-.62-.67.67.67,0,0,0,0,1.34A.65.65,0,0,0,297.79,228.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,227.84a.65.65,0,0,0-.62-.67.67.67,0,0,0,0,1.34A.65.65,0,0,0,274.32,227.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,265.61a.61.61,0,1,0-.61.67A.64.64,0,0,0,350.66,265.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,183.92a.62.62,0,1,0-.61.67A.65.65,0,0,0,290.13,183.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.7,229.85a.64.64,0,0,0-.61-.67.67.67,0,0,0,0,1.34A.64.64,0,0,0,273.7,229.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.35,229.85a.65.65,0,0,0-.62-.67.67.67,0,0,0,0,1.34A.65.65,0,0,0,307.35,229.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,256.78a.64.64,0,0,0-.61-.67.67.67,0,0,0,0,1.34A.64.64,0,0,0,361.78,256.78Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.56,238.61a.64.64,0,0,0-.61-.67.67.67,0,0,0,0,1.34A.64.64,0,0,0,317.56,238.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.74,251.17a.64.64,0,0,0-.61-.67.67.67,0,0,0,0,1.34A.64.64,0,0,0,258.74,251.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.17,273.17a.65.65,0,0,0-.62-.67.67.67,0,0,0,0,1.34A.65.65,0,0,0,316.17,273.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,166a1.22,1.22,0,0,0,1.84,0,1.51,1.51,0,0,0,0-2,1.23,1.23,0,0,0-1.84,0A1.51,1.51,0,0,0,322.75,166Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.23,169.71a1.67,1.67,0,0,0-2.49-.24,2.05,2.05,0,0,0-.22,2.72,1.68,1.68,0,0,0,2.5.24A2.05,2.05,0,0,0,279.23,169.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77,294.16a1.68,1.68,0,0,0-2.5-.24,2.05,2.05,0,0,0-.21,2.72,1.67,1.67,0,0,0,2.49.24A2.05,2.05,0,0,0,315.77,294.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,291a1.67,1.67,0,0,0-2.49-.24,2.06,2.06,0,0,0-.22,2.73,1.68,1.68,0,0,0,2.5.23A2,2,0,0,0,294,291Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.8,288.36a1.66,1.66,0,0,0-2.49-.24,2.05,2.05,0,0,0-.22,2.72,1.67,1.67,0,0,0,2.49.24A2.05,2.05,0,0,0,201.8,288.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35,228.58a1.67,1.67,0,0,0-2.5-.24,2.05,2.05,0,0,0-.22,2.72,1.68,1.68,0,0,0,2.5.24A2.06,2.06,0,0,0,125.35,228.58Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,398.69a1.67,1.67,0,0,0-2.49-.24,2.06,2.06,0,0,0-.22,2.73,1.68,1.68,0,0,0,2.5.23A2.06,2.06,0,0,0,184.06,398.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.4,347.49a1.67,1.67,0,0,0-2.49-.23,2,2,0,0,0-.22,2.72,1.68,1.68,0,0,0,2.5.24A2.06,2.06,0,0,0,153.4,347.49Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.43,198.91a1.67,1.67,0,0,0-2.49-.23,2,2,0,0,0-.22,2.72,1.68,1.68,0,0,0,2.5.23A2,2,0,0,0,299.43,198.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.55,315.68a1.67,1.67,0,0,0-2.5-.24,2,2,0,0,0-.21,2.72,1.67,1.67,0,0,0,2.49.24A2.05,2.05,0,0,0,220.55,315.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,264.94a1.68,1.68,0,0,0-2.5-.24,2.05,2.05,0,0,0-.22,2.72,1.67,1.67,0,0,0,2.5.24A2.05,2.05,0,0,0,398.39,264.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,302.51a1.18,1.18,0,0,0-1.77-.17,1.44,1.44,0,0,0-.15,1.92,1.18,1.18,0,0,0,1.76.17A1.45,1.45,0,0,0,186.36,302.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.31,198.82a1.18,1.18,0,0,0-1.76-.17,1.45,1.45,0,0,0-.15,1.93,1.18,1.18,0,0,0,1.76.17A1.45,1.45,0,0,0,265.31,198.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,217.72a.86.86,0,0,0-1.29-.13,1.08,1.08,0,0,0-.12,1.42.87.87,0,0,0,1.3.12A1.06,1.06,0,0,0,267.53,217.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,272.29a.87.87,0,0,0-1.29-.12,1.08,1.08,0,0,0-.12,1.42.88.88,0,0,0,1.3.12A1.07,1.07,0,0,0,229,272.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,307.56a.87.87,0,0,0-1.3-.12,1.06,1.06,0,0,0-.11,1.41.86.86,0,0,0,1.29.12A1.07,1.07,0,0,0,148.92,307.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,325.15a.87.87,0,0,0-1.3-.13,1.07,1.07,0,0,0-.11,1.42.87.87,0,0,0,1.3.12A1.08,1.08,0,0,0,162.48,325.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.34,358.2a.87.87,0,0,0-1.3-.12,1.07,1.07,0,0,0-.11,1.41.87.87,0,0,0,1.3.12A1.06,1.06,0,0,0,210.34,358.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,174a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,285.35,174Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.68,202.08a.56.56,0,0,0-.83-.08.69.69,0,0,0-.08.91.57.57,0,0,0,.84.07A.67.67,0,0,0,262.68,202.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22,190.1a.56.56,0,0,0-.83-.08.69.69,0,0,0-.08.91.57.57,0,0,0,.84.08A.69.69,0,0,0,254.22,190.1Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.29,187.75a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,262.29,187.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,196.65a.57.57,0,0,0-.84-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,248.55,196.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,301a.55.55,0,0,0-.83-.08.67.67,0,0,0-.07.9.55.55,0,0,0,.83.08A.67.67,0,0,0,103.6,301Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,202.16a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,313.88,202.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,194.08a.27.27,0,0,0-.41,0,.34.34,0,0,0,0,.45.28.28,0,0,0,.42,0A.34.34,0,0,0,270,194.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,192.78a.35.35,0,0,0-.52-.05.43.43,0,0,0,0,.57.35.35,0,0,0,.53,0A.42.42,0,0,0,168.72,192.78Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7,243.44a.28.28,0,0,0-.42,0,.34.34,0,0,0,0,.45.27.27,0,0,0,.41,0A.34.34,0,0,0,215.7,243.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.11,293.88a.28.28,0,0,0-.42,0,.34.34,0,0,0,0,.45.27.27,0,0,0,.41,0A.34.34,0,0,0,167.11,293.88Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.57,223.33a.28.28,0,0,0-.41,0,.35.35,0,0,0,0,.46.29.29,0,0,0,.42,0A.35.35,0,0,0,244.57,223.33Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.14,250.14a.28.28,0,0,0-.42,0,.35.35,0,0,0,0,.45.28.28,0,0,0,.42,0A.35.35,0,0,0,211.14,250.14Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,319.92a.27.27,0,0,0-.41,0,.34.34,0,0,0,0,.45.28.28,0,0,0,.42,0A.34.34,0,0,0,132.53,319.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,328.23a.28.28,0,0,0-.42,0,.34.34,0,0,0,0,.45.27.27,0,0,0,.41,0A.34.34,0,0,0,125,328.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.54,193.17a.27.27,0,0,0-.41,0,.33.33,0,0,0,0,.45.28.28,0,0,0,.42,0A.34.34,0,0,0,263.54,193.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.54,232.14a.29.29,0,0,0-.42,0,.35.35,0,0,0,0,.46.28.28,0,0,0,.41,0A.35.35,0,0,0,220.54,232.14Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,285.88a.27.27,0,0,0-.41,0,.33.33,0,0,0,0,.45.27.27,0,0,0,.41,0A.33.33,0,0,0,160.55,285.88Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41,199.58a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,271.41,199.58Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.05,219.08a.57.57,0,0,0-.84-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,251.05,219.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.32,318.56a.55.55,0,0,0-.83-.08.67.67,0,0,0-.07.9.55.55,0,0,0,.83.08A.67.67,0,0,0,181.32,318.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.13,270.05a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.07A.67.67,0,0,0,305.13,270.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.28,216.17a.55.55,0,0,0-.83-.08.67.67,0,0,0-.07.9.55.55,0,0,0,.83.08A.67.67,0,0,0,223.28,216.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.39,321.17a.56.56,0,0,0-.83-.08.69.69,0,0,0-.08.91.57.57,0,0,0,.84.07A.67.67,0,0,0,179.39,321.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,356.65a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,194,356.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,372a.56.56,0,0,0-.83-.07.67.67,0,0,0-.07.9.56.56,0,0,0,.83.08A.69.69,0,0,0,176.32,372Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.91,348.3a.56.56,0,0,0-.83-.07.67.67,0,0,0-.07.9.56.56,0,0,0,.83.08A.69.69,0,0,0,253.91,348.3Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.05,329a.55.55,0,0,0-.83-.08.68.68,0,0,0-.08.9.56.56,0,0,0,.84.08A.67.67,0,0,0,163.05,329Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,373.87a.55.55,0,0,0-.83-.08.67.67,0,0,0-.07.9.55.55,0,0,0,.83.08A.67.67,0,0,0,177,373.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.76,351.19a.56.56,0,0,0-.83-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,201.76,351.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.09,334.31a.57.57,0,0,0-.84-.07.67.67,0,0,0-.07.9.56.56,0,0,0,.83.08A.69.69,0,0,0,257.09,334.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.09,247.85a.56.56,0,0,0-.83-.08.69.69,0,0,0-.08.91.57.57,0,0,0,.84.08A.69.69,0,0,0,263.09,247.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,350.75a.57.57,0,0,0-.84-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.7.7,0,0,0,214.25,350.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,399.63a.57.57,0,0,0-.84-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,178.1,399.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5,277.89a.57.57,0,0,0-.84-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,272.5,277.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.24,229.66a.57.57,0,0,0-.84-.08.69.69,0,0,0-.07.91.56.56,0,0,0,.83.08A.69.69,0,0,0,288.24,229.66Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,240.28a.62.62,0,0,0,.64-.59.63.63,0,0,0-.54-.7.62.62,0,0,0-.64.59A.63.63,0,0,0,342,240.28Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,293.84a1.29,1.29,0,0,0,1.36-1.24,1.34,1.34,0,0,0-1.14-1.48,1.29,1.29,0,0,0-1.36,1.24A1.34,1.34,0,0,0,176.88,293.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,130.12a1.75,1.75,0,0,0-2.6-.25,2.14,2.14,0,0,0-.23,2.83,1.75,1.75,0,0,0,2.6.25A2.14,2.14,0,0,0,221.37,130.12Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39,259.62a1.74,1.74,0,0,0-2.6-.24,2.14,2.14,0,0,0-.23,2.83,1.74,1.74,0,0,0,2.6.24A2.14,2.14,0,0,0,259.39,259.62Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7,256.29a1.74,1.74,0,0,0-2.59-.25,2.14,2.14,0,0,0-.23,2.83,1.75,1.75,0,0,0,2.6.25A2.13,2.13,0,0,0,236.7,256.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79,250.54a1.74,1.74,0,0,0-2.6-.24,2.13,2.13,0,0,0-.22,2.83,1.74,1.74,0,0,0,2.6.24A2.13,2.13,0,0,0,147.79,250.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,377.26a1.73,1.73,0,0,0-2.59-.24,2.14,2.14,0,0,0-.23,2.83,1.74,1.74,0,0,0,2.6.24A2.13,2.13,0,0,0,56.87,377.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,332.49a1.74,1.74,0,0,0-2.59-.25,2.14,2.14,0,0,0-.23,2.83,1.75,1.75,0,0,0,2.6.25A2.13,2.13,0,0,0,76,332.49Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.39,160.51a1.75,1.75,0,0,0-2.6-.25,2.14,2.14,0,0,0-.22,2.84,1.73,1.73,0,0,0,2.59.24A2.14,2.14,0,0,0,242.39,160.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3,282a1.75,1.75,0,0,0-2.6-.24,2.13,2.13,0,0,0-.22,2.83,1.74,1.74,0,0,0,2.59.25A2.15,2.15,0,0,0,160.3,282Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.88,107a1.24,1.24,0,0,0-1.84-.18,1.53,1.53,0,0,0-.16,2,1.24,1.24,0,0,0,1.84.17A1.51,1.51,0,0,0,234.88,107Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.24,260a1.23,1.23,0,0,0-1.84-.17,1.51,1.51,0,0,0-.16,2,1.23,1.23,0,0,0,1.84.17A1.51,1.51,0,0,0,187.24,260Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.61,236.78a1.23,1.23,0,0,0-1.84-.17,1.51,1.51,0,0,0-.16,2,1.23,1.23,0,0,0,1.84.17A1.51,1.51,0,0,0,62.61,236.78Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.88,160.42a1.23,1.23,0,0,0-1.83-.18,1.49,1.49,0,0,0-.16,2,1.22,1.22,0,0,0,1.83.18A1.5,1.5,0,0,0,206.88,160.42Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.82,177a1.22,1.22,0,0,0-1.83-.17,1.49,1.49,0,0,0-.16,2,1.22,1.22,0,0,0,1.83.17A1.51,1.51,0,0,0,303.82,177Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19,180.08a.91.91,0,0,0-1.35-.13,1.11,1.11,0,0,0-.12,1.47.91.91,0,0,0,1.35.13A1.1,1.1,0,0,0,209.19,180.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,225.11a.91.91,0,0,0-1.35-.13,1.1,1.1,0,0,0-.12,1.47.91.91,0,0,0,1.35.13A1.1,1.1,0,0,0,164,225.11Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,293a.91.91,0,0,0-1.35-.13,1.11,1.11,0,0,0-.12,1.47.91.91,0,0,0,1.35.13A1.1,1.1,0,0,0,84.8,293Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25,314.07a.91.91,0,0,0-1.35-.13,1.11,1.11,0,0,0-.11,1.47.91.91,0,0,0,1.35.13A1.11,1.11,0,0,0,38.25,314.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.68,326.27a.9.9,0,0,0-1.35-.13,1.1,1.1,0,0,0-.12,1.47.91.91,0,0,0,1.35.13A1.11,1.11,0,0,0,149.68,326.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,134.62a.58.58,0,0,0-.86-.09.72.72,0,0,0-.08.95.59.59,0,0,0,.87.08A.71.71,0,0,0,227.73,134.62Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.14,163.8a.59.59,0,0,0-.87-.08.72.72,0,0,0-.07.95.57.57,0,0,0,.86.08A.72.72,0,0,0,204.14,163.8Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.33,151.34a.57.57,0,0,0-.86-.08.72.72,0,0,0-.08.94.59.59,0,0,0,.87.09A.72.72,0,0,0,195.33,151.34Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.74,148.89a.59.59,0,0,0-.87-.08.72.72,0,0,0-.07.95.57.57,0,0,0,.86.08A.72.72,0,0,0,203.74,148.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,158.16a.58.58,0,0,0-.86-.09.72.72,0,0,0-.08,1,.59.59,0,0,0,.87.08A.71.71,0,0,0,189.43,158.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,266.75a.59.59,0,0,0-.87-.08.72.72,0,0,0-.08.94.59.59,0,0,0,.87.08A.72.72,0,0,0,38.61,266.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,163.89a.59.59,0,0,0-.87-.08.71.71,0,0,0-.07.94.59.59,0,0,0,.87.08A.72.72,0,0,0,257.42,163.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.79,155.48a.29.29,0,0,0-.43,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.35.35,0,0,0,211.79,155.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.52,214.87a.29.29,0,0,0-.43,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.37.37,0,0,0,80.52,214.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.25,206.84a.29.29,0,0,0-.43,0,.35.35,0,0,0,0,.47.28.28,0,0,0,.43,0A.35.35,0,0,0,155.25,206.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.69,259.34a.3.3,0,0,0-.44,0,.36.36,0,0,0,0,.48.29.29,0,0,0,.43,0A.35.35,0,0,0,104.69,259.34Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,185.92a.29.29,0,0,0-.43,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.35.35,0,0,0,185.3,185.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5,213.82a.29.29,0,0,0-.43,0,.37.37,0,0,0,0,.48.3.3,0,0,0,.44,0A.35.35,0,0,0,150.5,213.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,286.43a.29.29,0,0,0-.43,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.35.35,0,0,0,68.71,286.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,295.08a.3.3,0,0,0-.44,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.35.35,0,0,0,60.85,295.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,154.53a.29.29,0,0,0-.43,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.35.35,0,0,0,205,154.53Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,195.09a.3.3,0,0,0-.44,0,.35.35,0,0,0,0,.47.29.29,0,0,0,.43,0A.35.35,0,0,0,160.29,195.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,251a.28.28,0,0,0-.43,0,.36.36,0,0,0,0,.47.3.3,0,0,0,.44,0A.35.35,0,0,0,97.86,251Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,161.21a.58.58,0,0,0-.87-.08.72.72,0,0,0-.07.94.59.59,0,0,0,.87.08A.71.71,0,0,0,213.23,161.21Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,181.5a.57.57,0,0,0-.86-.08.72.72,0,0,0-.08.94.58.58,0,0,0,.87.08A.7.7,0,0,0,192,181.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,285a.59.59,0,0,0-.87-.08.71.71,0,0,0-.07.94.58.58,0,0,0,.86.09A.72.72,0,0,0,119.48,285Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.32,234.54a.59.59,0,0,0-.87-.09.72.72,0,0,0-.07,1,.57.57,0,0,0,.86.08A.72.72,0,0,0,248.32,234.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.43,284.22a.57.57,0,0,0-.86-.08.71.71,0,0,0-.08.94.59.59,0,0,0,.87.08A.7.7,0,0,0,256.43,284.22Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,178.46a.58.58,0,0,0-.86-.08.72.72,0,0,0-.08,1,.59.59,0,0,0,.87.08A.72.72,0,0,0,163.14,178.46Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47,287.73a.59.59,0,0,0-.87-.08.71.71,0,0,0-.07.94.57.57,0,0,0,.86.08A.71.71,0,0,0,117.47,287.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.64,324.65a.59.59,0,0,0-.87-.08.72.72,0,0,0-.07.94.59.59,0,0,0,.87.09A.72.72,0,0,0,132.64,324.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,340.6a.59.59,0,0,0-.87-.08.71.71,0,0,0-.07.94.57.57,0,0,0,.86.08A.71.71,0,0,0,114.28,340.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,316a.59.59,0,0,0-.87-.08.7.7,0,0,0-.07.94.57.57,0,0,0,.86.08A.71.71,0,0,0,195,316Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.65,293.27a.58.58,0,0,0-.87-.08.7.7,0,0,0-.07.94.57.57,0,0,0,.86.08A.71.71,0,0,0,244.65,293.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.46,295.89a.57.57,0,0,0-.86-.08.71.71,0,0,0-.08.94.59.59,0,0,0,.87.08A.71.71,0,0,0,100.46,295.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,362.72a.57.57,0,0,0-.86-.08.72.72,0,0,0-.08.95.59.59,0,0,0,.87.08A.72.72,0,0,0,87.79,362.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,319a.59.59,0,0,0-.87-.08.71.71,0,0,0-.07.94.58.58,0,0,0,.86.09A.72.72,0,0,0,140.75,319Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.32,301.41a.59.59,0,0,0-.87-.08.71.71,0,0,0-.07.94.57.57,0,0,0,.86.08A.71.71,0,0,0,198.32,301.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57,211.44a.59.59,0,0,0-.87-.09.72.72,0,0,0-.07,1,.57.57,0,0,0,.86.08A.72.72,0,0,0,204.57,211.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,318.51a.59.59,0,0,0-.87-.08.72.72,0,0,0-.07.95.57.57,0,0,0,.86.08A.72.72,0,0,0,153.74,318.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12,369.38a.57.57,0,0,0-.86-.08.71.71,0,0,0-.08.94.58.58,0,0,0,.87.08A.7.7,0,0,0,116.12,369.38Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,242.7a.58.58,0,0,0-.87-.08.7.7,0,0,0-.07.94.57.57,0,0,0,.86.08A.72.72,0,0,0,214.36,242.7Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.07,346a.59.59,0,0,0-.87-.08.72.72,0,0,0-.07.95.57.57,0,0,0,.86.08A.72.72,0,0,0,173.07,346Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.73,192.51a.57.57,0,0,0-.86-.08.71.71,0,0,0-.08.94.58.58,0,0,0,.87.08A.7.7,0,0,0,230.73,192.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.14,225.27a.63.63,0,0,0,.67-.61.65.65,0,0,0-.56-.72.62.62,0,0,0-.66.61A.65.65,0,0,0,314.14,225.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.63,203.55a.62.62,0,0,0,.66-.61.65.65,0,0,0-.56-.72.63.63,0,0,0-.66.61A.65.65,0,0,0,286.63,203.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,126.05a.33.33,0,0,0,.34-.31.33.33,0,0,0-.28-.36.32.32,0,0,0-.34.3A.34.34,0,0,0,253.53,126.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.11,179.86a.64.64,0,0,0,.67-.61.65.65,0,0,0-.56-.72.64.64,0,0,0-.67.61A.65.65,0,0,0,287.11,179.86Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.11,189.73a1.34,1.34,0,0,0,1.41-1.29,1.4,1.4,0,0,0-1.19-1.54,1.34,1.34,0,0,0-1.41,1.29A1.39,1.39,0,0,0,308.11,189.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84,197a.32.32,0,0,0,.33-.31.33.33,0,0,0-.28-.36.31.31,0,0,0-.33.31A.33.33,0,0,0,307.84,197Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.23,192.47a.31.31,0,0,0,.33-.3.33.33,0,0,0-.28-.37.32.32,0,0,0-.33.31A.33.33,0,0,0,313.23,192.47Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11,194.07a.63.63,0,0,0,.66-.61.66.66,0,0,0-.56-.73.63.63,0,0,0-.66.61A.66.66,0,0,0,303.11,194.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,259.29a1.34,1.34,0,0,0,1.41-1.29,1.4,1.4,0,0,0-1.19-1.54,1.35,1.35,0,0,0-1.41,1.29A1.4,1.4,0,0,0,114.86,259.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33,140.16a.64.64,0,0,0,.67-.61.65.65,0,0,0-.56-.72.64.64,0,0,0-.67.61A.65.65,0,0,0,249.33,140.16Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.16,158a.88.88,0,0,0-1.26-.37,1,1,0,0,0-.33,1.37.88.88,0,0,0,1.25.37A1,1,0,0,0,188.16,158Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,142.92a.56.56,0,0,0-.8-.24.68.68,0,0,0-.22.88.57.57,0,0,0,.81.24A.67.67,0,0,0,144.59,142.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,148a.29.29,0,0,0-.4-.12.34.34,0,0,0-.11.44.27.27,0,0,0,.4.12A.33.33,0,0,0,208.26,148Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.05,167.05a.29.29,0,0,0-.41-.12.33.33,0,0,0-.1.44.28.28,0,0,0,.4.12A.34.34,0,0,0,170.05,167.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.28,173.79a.3.3,0,0,0-.41-.12.33.33,0,0,0-.1.44.27.27,0,0,0,.4.12A.34.34,0,0,0,161.28,173.79Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09,138.86a.29.29,0,0,0-.4-.12.34.34,0,0,0-.11.44.27.27,0,0,0,.4.12A.34.34,0,0,0,203.09,138.86Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.81,103.31a1.77,1.77,0,0,0-2.52-.74,2.12,2.12,0,0,0-.68,2.75,1.76,1.76,0,0,0,2.52.73A2.12,2.12,0,0,0,188.81,103.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.36,154.31a1.76,1.76,0,0,0-2.52-.73,2.1,2.1,0,0,0-.67,2.74,1.76,1.76,0,0,0,2.51.74A2.12,2.12,0,0,0,129.36,154.31Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,135a1.76,1.76,0,0,0-2.52-.73,2.1,2.1,0,0,0-.67,2.74,1.76,1.76,0,0,0,2.51.74A2.11,2.11,0,0,0,203.46,135Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.62,114.74a1.25,1.25,0,0,0-1.78-.52,1.5,1.5,0,0,0-.48,1.94,1.25,1.25,0,0,0,1.78.53A1.5,1.5,0,0,0,170.62,114.74Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.39,92.24a.92.92,0,0,0-1.31-.38,1.09,1.09,0,0,0-.35,1.43.91.91,0,0,0,1.31.38A1.12,1.12,0,0,0,219.39,92.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,107.35a.92.92,0,0,0-1.31-.38,1.08,1.08,0,0,0-.35,1.42.92.92,0,0,0,1.31.39A1.12,1.12,0,0,0,112.77,107.35Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.38,133.21a.91.91,0,0,0-1.31-.38,1.1,1.1,0,0,0-.35,1.43.92.92,0,0,0,1.31.38A1.1,1.1,0,0,0,142.38,133.21Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,96.81a.58.58,0,0,0-.84-.24.7.7,0,0,0-.22.91.59.59,0,0,0,.84.25A.71.71,0,0,0,86.08,96.81Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.37,115.29a.3.3,0,0,0-.42-.13.35.35,0,0,0-.11.46.29.29,0,0,0,.42.12A.33.33,0,0,0,276.37,115.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.66,130.69a.3.3,0,0,0-.42-.13.35.35,0,0,0-.11.46.29.29,0,0,0,.42.12A.35.35,0,0,0,293.66,130.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.34,102.09a.3.3,0,0,0-.42-.12.36.36,0,0,0-.12.46.3.3,0,0,0,.42.12A.36.36,0,0,0,152.34,102.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,136.65a.29.29,0,0,0-.42-.12.33.33,0,0,0-.11.45.3.3,0,0,0,.42.13A.37.37,0,0,0,287.87,136.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57,121.93a.29.29,0,0,0-.42-.13.35.35,0,0,0-.11.46.29.29,0,0,0,.42.12A.35.35,0,0,0,112.57,121.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.44,128.94a.29.29,0,0,0-.42-.12.37.37,0,0,0-.11.46.3.3,0,0,0,.42.12A.35.35,0,0,0,103.44,128.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,120.08a.3.3,0,0,0-.42-.13.37.37,0,0,0-.11.46.29.29,0,0,0,.42.12A.33.33,0,0,0,300.5,120.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,92.59a.29.29,0,0,0-.42-.12.37.37,0,0,0-.11.46.3.3,0,0,0,.42.12A.35.35,0,0,0,147,92.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79,130.19A.58.58,0,0,0,162,130a.69.69,0,0,0-.23.91.59.59,0,0,0,.84.25A.71.71,0,0,0,162.79,130.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,132.49a.59.59,0,0,0-.84-.25.71.71,0,0,0-.22.92.58.58,0,0,0,.84.24A.7.7,0,0,0,160.37,132.49Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4,171.73a.59.59,0,0,0-.84-.25.71.71,0,0,0-.23.92.58.58,0,0,0,.84.24A.69.69,0,0,0,169.4,171.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76,183.94a.59.59,0,0,0-.84-.25.71.71,0,0,0-.22.92.58.58,0,0,0,.84.24A.7.7,0,0,0,148.76,183.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,137.28a.58.58,0,0,0-.84-.24.7.7,0,0,0-.22.91.59.59,0,0,0,.84.25A.71.71,0,0,0,142.32,137.28Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,186a.58.58,0,0,0-.84-.24.7.7,0,0,0-.22.91.59.59,0,0,0,.84.25A.71.71,0,0,0,149.15,186Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.29,167.68a.58.58,0,0,0-.84-.24.7.7,0,0,0-.22.91.59.59,0,0,0,.84.25A.71.71,0,0,0,178.29,167.68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,104a1.31,1.31,0,0,0,1.6-1,1.45,1.45,0,0,0-.93-1.74,1.29,1.29,0,0,0-1.59,1A1.43,1.43,0,0,0,162.36,104Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,130.91a1.73,1.73,0,0,0-2.27,1.15,2,2,0,0,0,1.06,2.47,1.73,1.73,0,0,0,2.27-1.15A2,2,0,0,0,126.37,130.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25,145.2a1.73,1.73,0,0,0-2.27,1.15,2,2,0,0,0,1.06,2.47,1.73,1.73,0,0,0,2.27-1.15A2,2,0,0,0,157.25,145.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.66,163.71a1.23,1.23,0,0,0-1.61.81,1.41,1.41,0,0,0,.75,1.75,1.23,1.23,0,0,0,1.61-.81A1.41,1.41,0,0,0,127.66,163.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24,178.86a.91.91,0,0,0-1.18.6,1,1,0,0,0,.55,1.29.9.9,0,0,0,1.18-.6A1,1,0,0,0,138.24,178.86Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,131.32a.57.57,0,0,0-.76.38.68.68,0,0,0,.35.83.59.59,0,0,0,.76-.39A.66.66,0,0,0,133.65,131.32Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,168a.58.58,0,0,0-.76.39.66.66,0,0,0,.36.82.57.57,0,0,0,.75-.38A.67.67,0,0,0,126.87,168Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05,162.2a.58.58,0,0,0-.76.38.67.67,0,0,0,.36.83.57.57,0,0,0,.75-.39A.65.65,0,0,0,114.05,162.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,155.76a.57.57,0,0,0-.75.39.65.65,0,0,0,.35.82.58.58,0,0,0,.76-.38A.67.67,0,0,0,120,155.76Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,171a.58.58,0,0,0-.76.39.66.66,0,0,0,.36.82.57.57,0,0,0,.75-.39A.65.65,0,0,0,112.14,171Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.25,140.14a.57.57,0,0,0-.75.38.67.67,0,0,0,.35.83.58.58,0,0,0,.76-.39A.66.66,0,0,0,171.25,140.14Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,157a.29.29,0,0,0-.38.19.34.34,0,0,0,.18.41.29.29,0,0,0,.38-.19A.34.34,0,0,0,129.57,157Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.93,196.24a.29.29,0,0,0-.38.19.34.34,0,0,0,.18.41.29.29,0,0,0,.38-.19A.34.34,0,0,0,120.93,196.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.53,159.77a.3.3,0,0,0-.38.2.34.34,0,0,0,.18.41.3.3,0,0,0,.38-.19A.35.35,0,0,0,123.53,159.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,217a.28.28,0,0,0-.37.2.33.33,0,0,0,.17.41.3.3,0,0,0,.38-.19A.33.33,0,0,0,104.15,217Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,161a.57.57,0,0,0-.75.39.64.64,0,0,0,.35.82.59.59,0,0,0,.76-.38A.67.67,0,0,0,133.29,161Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,189a.58.58,0,0,0-.76.38.67.67,0,0,0,.36.83.57.57,0,0,0,.75-.39A.65.65,0,0,0,124.59,189Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,201.63a.57.57,0,0,0-.75.38.66.66,0,0,0,.35.83.58.58,0,0,0,.76-.39A.66.66,0,0,0,99.2,201.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65,177.93a.57.57,0,0,0-.75.39.64.64,0,0,0,.35.82.58.58,0,0,0,.76-.38A.67.67,0,0,0,161.65,177.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.35,133.83A1.8,1.8,0,0,0,58,135a2.06,2.06,0,0,0,1.1,2.58,1.81,1.81,0,0,0,2.36-1.21A2.05,2.05,0,0,0,60.35,133.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.24,143a1.82,1.82,0,0,0-2.37,1.21A2.07,2.07,0,0,0,89,146.79a1.81,1.81,0,0,0,2.36-1.2A2.07,2.07,0,0,0,90.24,143Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.18,100.72a1.27,1.27,0,0,0-1.67.85,1.46,1.46,0,0,0,.78,1.82,1.27,1.27,0,0,0,1.67-.85A1.45,1.45,0,0,0,59.18,100.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.53,171.4a1.27,1.27,0,0,0-1.67.85,1.45,1.45,0,0,0,.78,1.82,1.27,1.27,0,0,0,1.67-.85A1.46,1.46,0,0,0,70.53,171.4Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,123.86a1.27,1.27,0,0,0-1.67.85,1.45,1.45,0,0,0,.78,1.82,1.28,1.28,0,0,0,1.67-.85A1.47,1.47,0,0,0,151,123.86Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.24,195.88a.94.94,0,0,0-1.23.62,1.07,1.07,0,0,0,.58,1.34.93.93,0,0,0,1.22-.62A1.07,1.07,0,0,0,63.24,195.88Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,128.57a.6.6,0,0,0-.79.4.7.7,0,0,0,.37.86.6.6,0,0,0,.79-.4A.7.7,0,0,0,65.67,128.57Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.31,185.05a.6.6,0,0,0-.79.4.68.68,0,0,0,.37.85.6.6,0,0,0,.79-.4A.68.68,0,0,0,35.31,185.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,163a.61.61,0,0,0-.79.41.68.68,0,0,0,.37.85.6.6,0,0,0,.79-.4A.7.7,0,0,0,25,163Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.41,120a.59.59,0,0,0-.78.4.69.69,0,0,0,.37.86.61.61,0,0,0,.78-.4A.68.68,0,0,0,24.41,120Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81,137.75a.6.6,0,0,0-.79.4.69.69,0,0,0,.37.86.59.59,0,0,0,.78-.4A.68.68,0,0,0,104.81,137.75Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.18,157.65a.3.3,0,0,0-.39.2.34.34,0,0,0,.18.43.29.29,0,0,0,.39-.2A.35.35,0,0,0,41.18,157.65Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9,160.51a.31.31,0,0,0-.4.2.34.34,0,0,0,.19.43.3.3,0,0,0,.39-.2A.34.34,0,0,0,34.9,160.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.05,161.83a.59.59,0,0,0-.78.4.68.68,0,0,0,.36.86.6.6,0,0,0,.79-.4A.69.69,0,0,0,45.05,161.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,216.73a.6.6,0,0,0-.79.4.7.7,0,0,0,.37.86.61.61,0,0,0,.79-.4A.7.7,0,0,0,30.57,216.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83,207.73a.6.6,0,0,0-.79.4.69.69,0,0,0,.37.86.61.61,0,0,0,.78-.4A.69.69,0,0,0,80.83,207.73Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.81,177.08a.59.59,0,0,0-.78.4.68.68,0,0,0,.36.86.6.6,0,0,0,.79-.4A.69.69,0,0,0,94.81,177.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,160a.69.69,0,0,0,.3-.89.6.6,0,0,0-.82-.32.7.7,0,0,0-.3.89A.59.59,0,0,0,182.08,160Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.29,156.19a.69.69,0,0,0,.3-.89.6.6,0,0,0-.82-.32.7.7,0,0,0-.3.89A.6.6,0,0,0,148.29,156.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,107.09a.35.35,0,0,0,.15-.44.31.31,0,0,0-.41-.17.36.36,0,0,0-.15.45A.3.3,0,0,0,84.09,107.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,135.41a.7.7,0,0,0,.29-.89.59.59,0,0,0-.81-.33.7.7,0,0,0-.3.89A.6.6,0,0,0,137.85,135.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.56,132.52a1.49,1.49,0,0,0,.63-1.89,1.27,1.27,0,0,0-1.74-.69,1.48,1.48,0,0,0-.62,1.89A1.26,1.26,0,0,0,160.56,132.52Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,139a.36.36,0,0,0,.15-.45.3.3,0,0,0-.41-.16.36.36,0,0,0-.15.45A.3.3,0,0,0,163.66,139Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.25,132.1a.35.35,0,0,0,.15-.44.31.31,0,0,0-.41-.17.36.36,0,0,0-.15.45A.3.3,0,0,0,166.25,132.1Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,139a.7.7,0,0,0,.3-.89.6.6,0,0,0-.82-.33.7.7,0,0,0-.3.89A.6.6,0,0,0,158.21,139Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,121.61a.7.7,0,0,0,.3-.89.6.6,0,0,0-.82-.33.69.69,0,0,0-.29.89A.59.59,0,0,0,86.92,121.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,370.59a1.53,1.53,0,0,0,2.28.21,1.88,1.88,0,0,0,.2-2.48,1.53,1.53,0,0,0-2.29-.22A1.88,1.88,0,0,0,309,370.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,480.09a1.52,1.52,0,0,0,2.28.22,1.88,1.88,0,0,0,.2-2.49,1.53,1.53,0,0,0-2.28-.22A1.87,1.87,0,0,0,235.25,480.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,421.94a1.53,1.53,0,0,0,2.28.21,1.88,1.88,0,0,0,.2-2.48,1.53,1.53,0,0,0-2.29-.22A1.88,1.88,0,0,0,220.36,421.94Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,451a1.52,1.52,0,0,0,2.28.22,1.87,1.87,0,0,0,.2-2.49,1.53,1.53,0,0,0-2.28-.21A1.86,1.86,0,0,0,159,451Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,463.08a1.1,1.1,0,0,0,1.62.15,1.33,1.33,0,0,0,.14-1.76,1.07,1.07,0,0,0-1.61-.15A1.33,1.33,0,0,0,190.22,463.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,370.52a.78.78,0,0,0,1.18.11,1,1,0,0,0,.1-1.29.78.78,0,0,0-1.18-.11A1,1,0,0,0,274.33,370.52Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,458.46a.81.81,0,0,0,1.19.11,1,1,0,0,0,.1-1.29.8.8,0,0,0-1.19-.12A1,1,0,0,0,224.46,458.46Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.06,442.37a.79.79,0,0,0,1.19.11,1,1,0,0,0,.1-1.29.79.79,0,0,0-1.19-.11A1,1,0,0,0,212.06,442.37Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,376.77a.51.51,0,0,0,.76.07.62.62,0,0,0,.06-.83.51.51,0,0,0-.76-.07A.64.64,0,0,0,402.69,376.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.46,438.87a.31.31,0,0,0,.48,0,.4.4,0,0,0,0-.52.31.31,0,0,0-.48,0A.4.4,0,0,0,306.46,438.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.51,392.55a.25.25,0,0,0,.38,0,.31.31,0,0,0,0-.41.26.26,0,0,0-.38,0A.32.32,0,0,0,263.51,392.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.83,471a.25.25,0,0,0,.38,0,.32.32,0,0,0,0-.42.25.25,0,0,0-.38,0A.31.31,0,0,0,207.83,471Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79,447.79a.26.26,0,0,0,.38,0,.33.33,0,0,0,0-.42.25.25,0,0,0-.38,0A.3.3,0,0,0,273.79,447.79Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.68,386.42a.25.25,0,0,0,.38,0,.32.32,0,0,0,0-.42.25.25,0,0,0-.38,0A.31.31,0,0,0,267.68,386.42Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44,447.15a.25.25,0,0,0,.38,0,.32.32,0,0,0,0-.42.25.25,0,0,0-.38,0A.31.31,0,0,0,239.44,447.15Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,439.55a.25.25,0,0,0,.38,0,.3.3,0,0,0,0-.41.25.25,0,0,0-.38,0A.31.31,0,0,0,246.35,439.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,358.6a.25.25,0,0,0,.38,0,.3.3,0,0,0,0-.41.25.25,0,0,0-.38,0A.32.32,0,0,0,332.35,358.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62,390.6a.26.26,0,0,0,.38,0,.33.33,0,0,0,0-.42.25.25,0,0,0-.38,0A.3.3,0,0,0,350.62,390.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.83,448.4a.51.51,0,0,0,.76.07.63.63,0,0,0,.07-.83.51.51,0,0,0-.76-.07A.63.63,0,0,0,194.83,448.4Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.84,373.21a.51.51,0,0,0,.76.08.63.63,0,0,0,.07-.83.51.51,0,0,0-.76-.07A.61.61,0,0,0,329.84,373.21Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,446a.51.51,0,0,0,.76.07.62.62,0,0,0,.06-.83.51.51,0,0,0-.76-.07A.63.63,0,0,0,196.6,446Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,438.84a.52.52,0,0,0,.76.08.62.62,0,0,0,.06-.83.52.52,0,0,0-.76-.08A.64.64,0,0,0,211.54,438.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.93,407.5a.51.51,0,0,0,.76.08.63.63,0,0,0,.07-.83.51.51,0,0,0-.76-.07A.61.61,0,0,0,125.93,407.5Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,419a.51.51,0,0,0,.76.07.63.63,0,0,0,.07-.83.51.51,0,0,0-.76-.07A.63.63,0,0,0,164.72,419Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.9,387.27a1.18,1.18,0,0,0-1.24,1.13,1.23,1.23,0,0,0,1,1.35,1.17,1.17,0,0,0,1.24-1.13A1.23,1.23,0,0,0,339.9,387.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.47,357.2a1.6,1.6,0,0,0,2.38.22,2,2,0,0,0,.2-2.59,1.59,1.59,0,0,0-2.37-.22A2,2,0,0,0,261.47,357.2Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.66,453.36a1.58,1.58,0,0,0,2.37.22,1.93,1.93,0,0,0,.21-2.58,1.59,1.59,0,0,0-2.37-.23A2,2,0,0,0,471.66,453.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41,433.72a1.59,1.59,0,0,0,2.37.23,2,2,0,0,0,.21-2.59,1.6,1.6,0,0,0-2.38-.23A2,2,0,0,0,115.41,433.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.74,363.85a1.59,1.59,0,0,0,2.37.23,2,2,0,0,0,.21-2.59,1.6,1.6,0,0,0-2.38-.23A2,2,0,0,0,414.74,363.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,414.39a1.59,1.59,0,0,0,2.37.23A2,2,0,0,0,347,412a1.6,1.6,0,0,0-2.38-.23A2,2,0,0,0,344.41,414.39Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.38,406.66a1.13,1.13,0,0,0,1.68.16,1.39,1.39,0,0,0,.15-1.83,1.13,1.13,0,0,0-1.68-.16A1.38,1.38,0,0,0,383.38,406.66Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.18,435.49a1.12,1.12,0,0,0,1.67.16,1.38,1.38,0,0,0,.15-1.83,1.13,1.13,0,0,0-1.68-.16A1.38,1.38,0,0,0,440.18,435.49Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.46,450.48a.82.82,0,0,0,1.23.12,1,1,0,0,0,.11-1.34.83.83,0,0,0-1.24-.12A1,1,0,0,0,269.46,450.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.09,398.55a.82.82,0,0,0,1.23.12,1,1,0,0,0,.11-1.35.82.82,0,0,0-1.23-.11A1,1,0,0,0,306.09,398.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,401.85a.82.82,0,0,0,1.23.12,1,1,0,0,0,.11-1.34.83.83,0,0,0-1.24-.12A1,1,0,0,0,419,401.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.1,385.12a.83.83,0,0,0,1.24.11,1,1,0,0,0,.1-1.34.82.82,0,0,0-1.23-.12A1,1,0,0,0,406.1,385.12Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.77,441.35a.82.82,0,0,0,1.23.12,1,1,0,0,0,.11-1.35.84.84,0,0,0-1.24-.12A1,1,0,0,0,223.77,441.35Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.12,408.09a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.07A.64.64,0,0,0,462.12,408.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.91,431.61a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.27.27,0,0,0-.4,0A.32.32,0,0,0,391.91,431.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,426a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.27.27,0,0,0-.4,0A.32.32,0,0,0,318.78,426Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.7,414.87a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.27.27,0,0,0-.4,0A.32.32,0,0,0,401.7,414.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,434.85a.27.27,0,0,0,.4,0,.32.32,0,0,0,0-.43.26.26,0,0,0-.39,0A.32.32,0,0,0,347.17,434.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.12,419.63a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.27.27,0,0,0-.4,0A.32.32,0,0,0,323.12,419.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.6,390.09a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.27.27,0,0,0-.4,0A.32.32,0,0,0,434.6,390.09Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,382.19a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.28.28,0,0,0-.4,0A.33.33,0,0,0,441.79,382.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.17,436.76a.28.28,0,0,0,.4,0,.32.32,0,0,0,0-.43.27.27,0,0,0-.39,0A.34.34,0,0,0,314.17,436.76Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.94,422.49a.26.26,0,0,0,.39,0,.32.32,0,0,0,0-.43.28.28,0,0,0-.4,0A.33.33,0,0,0,407.94,422.49Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,426.51a.54.54,0,0,0,.8.08.66.66,0,0,0,.06-.86.53.53,0,0,0-.79-.08A.67.67,0,0,0,280,426.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.17,391.39a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.07A.64.64,0,0,0,388.17,391.39Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.56,452a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.07A.64.64,0,0,0,311.56,452Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,388.9a.53.53,0,0,0,.79.08.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.65.65,0,0,0,390,388.9Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,442.83a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,239.34,442.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.13,428.24a.54.54,0,0,0,.8.08.67.67,0,0,0,.06-.87.53.53,0,0,0-.79-.07A.64.64,0,0,0,256.13,428.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,450.77a.53.53,0,0,0,.79.07.66.66,0,0,0,.07-.86.54.54,0,0,0-.8-.08A.67.67,0,0,0,182.31,450.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92,471.52a.54.54,0,0,0,.8.08.66.66,0,0,0,.06-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,136.92,471.52Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.56,381.45a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,405.56,381.45Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48,426.44a.53.53,0,0,0,.79.08.66.66,0,0,0,.07-.87.53.53,0,0,0-.79-.07A.64.64,0,0,0,255.48,426.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93,448a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.07A.64.64,0,0,0,231.93,448Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29,464.08a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,179.29,464.08Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,377.54a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.54.54,0,0,0-.8-.07A.65.65,0,0,0,347,377.54Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,448.44a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,220.05,448.44Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.45,401.93a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,254.45,401.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.73,393.23a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,264.73,393.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,423.35a.52.52,0,0,0,.79.07.65.65,0,0,0,.06-.86.53.53,0,0,0-.79-.08A.67.67,0,0,0,202.38,423.35Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,394.85a.53.53,0,0,0,.79.07.64.64,0,0,0,.07-.86.53.53,0,0,0-.79-.08A.66.66,0,0,0,323,394.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4,414.91a1.22,1.22,0,0,0-1.29,1.18,1.26,1.26,0,0,0,1.08,1.41,1.23,1.23,0,0,0,1.29-1.18A1.27,1.27,0,0,0,392.4,414.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27,456.23a.26.26,0,0,0,.37.11.31.31,0,0,0,.1-.4.26.26,0,0,0-.37-.11A.3.3,0,0,0,313.27,456.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.89,361.71a.53.53,0,0,0,.76.22.64.64,0,0,0,.21-.83.54.54,0,0,0-.77-.23A.64.64,0,0,0,365.89,361.71Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.71,447a.54.54,0,0,0,.77.22.65.65,0,0,0,.21-.84.54.54,0,0,0-.77-.22A.65.65,0,0,0,324.71,447Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,445.06a.53.53,0,0,0,.76.22.63.63,0,0,0,.21-.83.53.53,0,0,0-.77-.23A.64.64,0,0,0,324.36,445.06Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.37,355.18a.82.82,0,0,0,1.08-.54,1,1,0,0,0-.5-1.18.83.83,0,0,0-1.08.55A.94.94,0,0,0,394.37,355.18Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,414.22a.52.52,0,0,0,.69-.35.61.61,0,0,0-.33-.75.52.52,0,0,0-.69.35A.61.61,0,0,0,365.4,414.22Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2,339.3a.28.28,0,0,0,.35-.18.29.29,0,0,0-.16-.37.26.26,0,0,0-.35.17A.31.31,0,0,0,410.2,339.3Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.54,320.35a.28.28,0,0,0,.35-.18.31.31,0,0,0-.16-.38.28.28,0,0,0-.35.18A.31.31,0,0,0,425.54,320.35Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,345.89a.53.53,0,0,0,.69-.35.61.61,0,0,0-.32-.76.54.54,0,0,0-.7.35A.61.61,0,0,0,406.86,345.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.82,443.72a.53.53,0,0,0,.69-.35.6.6,0,0,0-.32-.76.53.53,0,0,0-.69.36A.6.6,0,0,0,374.82,443.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,452.45a.53.53,0,0,0,.69-.36.61.61,0,0,0-.33-.75.53.53,0,0,0-.69.35A.61.61,0,0,0,312.93,452.45Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.51,441.76a.86.86,0,0,0,1.12-.57,1,1,0,0,0-.53-1.22.86.86,0,0,0-1.12.57A1,1,0,0,0,481.51,441.76Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.1,455.61a.56.56,0,0,0,.72-.37.61.61,0,0,0-.34-.78.54.54,0,0,0-.71.36A.63.63,0,0,0,414.1,455.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,438.14a.55.55,0,0,0,.72-.36A.65.65,0,0,0,392,437a.56.56,0,0,0-.72.37A.61.61,0,0,0,391.63,438.14Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.84,466.17a.56.56,0,0,0,.72-.37.63.63,0,0,0-.34-.78.55.55,0,0,0-.72.36A.63.63,0,0,0,378.84,466.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57,140.19a1.53,1.53,0,0,0-2.28-.22,1.88,1.88,0,0,0-.2,2.49,1.53,1.53,0,0,0,2.28.22A1.87,1.87,0,0,0,350.57,140.19Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.32,30.69a1.52,1.52,0,0,0-2.28-.22,1.87,1.87,0,0,0-.2,2.49,1.53,1.53,0,0,0,2.28.21A1.87,1.87,0,0,0,424.32,30.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.21,88.84a1.53,1.53,0,0,0-2.28-.22,1.88,1.88,0,0,0-.2,2.49,1.53,1.53,0,0,0,2.28.22A1.87,1.87,0,0,0,439.21,88.84Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.61,59.74a1.53,1.53,0,0,0-2.28-.21,1.87,1.87,0,0,0-.2,2.49,1.53,1.53,0,0,0,2.28.21A1.89,1.89,0,0,0,500.61,59.74Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.34,47.7a1.08,1.08,0,0,0-1.61-.15,1.32,1.32,0,0,0-.14,1.76,1.08,1.08,0,0,0,1.61.15A1.32,1.32,0,0,0,469.34,47.7Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.24,140.26a.78.78,0,0,0-1.18-.11,1,1,0,0,0-.11,1.29.79.79,0,0,0,1.19.11A1,1,0,0,0,385.24,140.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.11,52.32a.79.79,0,0,0-1.19-.11,1,1,0,0,0-.1,1.29.79.79,0,0,0,1.19.11A1,1,0,0,0,435.11,52.32Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.51,68.41a.8.8,0,0,0-1.19-.12,1,1,0,0,0-.1,1.3.8.8,0,0,0,1.18.11A1,1,0,0,0,447.51,68.41Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,134a.51.51,0,0,0-.76-.07.63.63,0,0,0-.07.83.51.51,0,0,0,.76.07A.63.63,0,0,0,256.88,134Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,71.91a.32.32,0,0,0-.48,0,.41.41,0,0,0,0,.53.33.33,0,0,0,.48,0A.4.4,0,0,0,353.11,71.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,118.23a.25.25,0,0,0-.38,0,.32.32,0,0,0,0,.42.25.25,0,0,0,.38,0A.31.31,0,0,0,396.06,118.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.74,39.81a.25.25,0,0,0-.38,0,.31.31,0,0,0,0,.41.25.25,0,0,0,.38,0A.32.32,0,0,0,451.74,39.81Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.78,63a.25.25,0,0,0-.38,0,.32.32,0,0,0,0,.42.25.25,0,0,0,.38,0A.31.31,0,0,0,385.78,63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89,124.36a.25.25,0,0,0-.38,0,.31.31,0,0,0,0,.41.25.25,0,0,0,.38,0A.31.31,0,0,0,391.89,124.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.13,63.63a.27.27,0,0,0-.39,0,.32.32,0,0,0,0,.41.25.25,0,0,0,.38,0A.31.31,0,0,0,420.13,63.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.22,71.22a.25.25,0,0,0-.38,0,.31.31,0,0,0,0,.41.25.25,0,0,0,.38,0A.32.32,0,0,0,413.22,71.22Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.22,152.17a.25.25,0,0,0-.38,0,.31.31,0,0,0,0,.41.25.25,0,0,0,.38,0A.32.32,0,0,0,327.22,152.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,120.18a.25.25,0,0,0-.38,0,.32.32,0,0,0,0,.42.25.25,0,0,0,.38,0A.31.31,0,0,0,309,120.18Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.74,62.38a.51.51,0,0,0-.76-.07.63.63,0,0,0-.07.83.51.51,0,0,0,.76.07A.63.63,0,0,0,464.74,62.38Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.72,137.56a.51.51,0,0,0-.76-.07.63.63,0,0,0-.06.83.51.51,0,0,0,.76.07A.62.62,0,0,0,329.72,137.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,64.77a.52.52,0,0,0-.76-.08.63.63,0,0,0-.07.83.51.51,0,0,0,.76.08A.63.63,0,0,0,463,64.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,71.93a.51.51,0,0,0-.76-.07.63.63,0,0,0-.07.83.51.51,0,0,0,.76.07A.63.63,0,0,0,448,71.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.64,103.27a.52.52,0,0,0-.77-.07.64.64,0,0,0-.06.83.51.51,0,0,0,.76.07A.63.63,0,0,0,533.64,103.27Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.84,91.82a.52.52,0,0,0-.76-.08.64.64,0,0,0-.06.83.52.52,0,0,0,.76.08A.62.62,0,0,0,494.84,91.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.66,123.51a1.18,1.18,0,0,0,1.24-1.13,1.22,1.22,0,0,0-1-1.36,1.18,1.18,0,0,0-1.24,1.14A1.22,1.22,0,0,0,319.66,123.51Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.09,153.58a1.58,1.58,0,0,0-2.37-.22,2,2,0,0,0-.21,2.59,1.6,1.6,0,0,0,2.38.22A2,2,0,0,0,398.09,153.58Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,57.42a1.6,1.6,0,0,0-2.38-.23,2,2,0,0,0-.2,2.59,1.59,1.59,0,0,0,2.37.23A2,2,0,0,0,187.91,57.42Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.16,77.05a1.59,1.59,0,0,0-2.37-.22,2,2,0,0,0-.21,2.59,1.58,1.58,0,0,0,2.37.22A2,2,0,0,0,544.16,77.05Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.83,146.92a1.59,1.59,0,0,0-2.37-.22,2,2,0,0,0-.21,2.59,1.6,1.6,0,0,0,2.38.22A2,2,0,0,0,244.83,146.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.16,96.39a1.59,1.59,0,0,0-2.37-.23,2,2,0,0,0-.21,2.59A1.59,1.59,0,0,0,315,99,1.94,1.94,0,0,0,315.16,96.39Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.19,104.11a1.13,1.13,0,0,0-1.68-.15,1.38,1.38,0,0,0-.15,1.83A1.13,1.13,0,0,0,276,106,1.39,1.39,0,0,0,276.19,104.11Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.39,75.28a1.12,1.12,0,0,0-1.68-.15,1.38,1.38,0,0,0-.14,1.83,1.13,1.13,0,0,0,1.68.15A1.38,1.38,0,0,0,219.39,75.28Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.11,60.29a.82.82,0,0,0-1.23-.11,1,1,0,0,0-.11,1.34.82.82,0,0,0,1.23.12A1,1,0,0,0,390.11,60.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,112.23a.83.83,0,0,0-1.24-.12,1,1,0,0,0-.1,1.34.82.82,0,0,0,1.23.12A1,1,0,0,0,353.48,112.23Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,108.92a.82.82,0,0,0-1.23-.11,1,1,0,0,0-.11,1.34.82.82,0,0,0,1.23.12A1,1,0,0,0,240.56,108.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.47,125.66a.84.84,0,0,0-1.24-.12,1,1,0,0,0-.11,1.35.84.84,0,0,0,1.24.11A1,1,0,0,0,253.47,125.66Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.8,69.43a.82.82,0,0,0-1.23-.12,1,1,0,0,0-.11,1.35.83.83,0,0,0,1.24.11A1,1,0,0,0,435.8,69.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.44,102.69a.53.53,0,0,0-.79-.08.67.67,0,0,0-.07.87.54.54,0,0,0,.8.07A.65.65,0,0,0,197.44,102.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,79.17a.27.27,0,0,0-.4,0,.33.33,0,0,0,0,.43.27.27,0,0,0,.4,0A.33.33,0,0,0,267.66,79.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.79,84.77a.27.27,0,0,0-.4,0,.32.32,0,0,0,0,.43.26.26,0,0,0,.39,0A.32.32,0,0,0,340.79,84.77Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,95.91a.27.27,0,0,0-.4,0,.33.33,0,0,0,0,.43.27.27,0,0,0,.4,0A.33.33,0,0,0,257.87,95.91Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,75.92a.27.27,0,0,0-.4,0,.32.32,0,0,0,0,.43.26.26,0,0,0,.39,0A.32.32,0,0,0,312.4,75.92Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.45,91.14a.27.27,0,0,0-.4,0,.32.32,0,0,0,0,.43.26.26,0,0,0,.39,0A.32.32,0,0,0,336.45,91.14Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,120.69a.26.26,0,0,0-.39,0,.32.32,0,0,0,0,.43.27.27,0,0,0,.4,0A.32.32,0,0,0,225,120.69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.78,128.59a.27.27,0,0,0-.39,0,.34.34,0,0,0,0,.44.27.27,0,0,0,.4,0A.32.32,0,0,0,217.78,128.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,74a.27.27,0,0,0-.39,0,.34.34,0,0,0,0,.44.27.27,0,0,0,.4,0A.32.32,0,0,0,345.39,74Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,88.29a.27.27,0,0,0-.39,0,.34.34,0,0,0,0,.44.27.27,0,0,0,.4,0A.32.32,0,0,0,251.63,88.29Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.58,84.26a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.08A.66.66,0,0,0,379.58,84.26Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,119.39a.55.55,0,0,0-.8-.08.67.67,0,0,0-.06.87.53.53,0,0,0,.79.07A.66.66,0,0,0,271.4,119.39Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,58.82a.53.53,0,0,0-.79-.08.66.66,0,0,0-.07.87.54.54,0,0,0,.8.07A.65.65,0,0,0,348,58.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.56,121.87a.54.54,0,0,0-.8-.07.65.65,0,0,0-.06.86.53.53,0,0,0,.79.08A.67.67,0,0,0,269.56,121.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.22,68a.53.53,0,0,0-.79-.07.66.66,0,0,0-.07.86.55.55,0,0,0,.8.08A.67.67,0,0,0,420.22,68Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,82.53a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.54.54,0,0,0,.8.08A.67.67,0,0,0,403.43,82.53Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.26,60a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,477.26,60Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.64,39.25a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.08A.66.66,0,0,0,522.64,39.25Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,129.33a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,254,129.33Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.09,84.34a.53.53,0,0,0-.79-.08.64.64,0,0,0-.07.86.53.53,0,0,0,.79.08A.65.65,0,0,0,404.09,84.34Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,62.76a.53.53,0,0,0-.79-.08.66.66,0,0,0-.07.87.53.53,0,0,0,.79.07A.64.64,0,0,0,427.64,62.76Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.28,46.7a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,480.28,46.7Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.61,133.24a.53.53,0,0,0-.79-.08.66.66,0,0,0-.07.87.53.53,0,0,0,.79.07A.64.64,0,0,0,312.61,133.24Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.52,62.34a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,439.52,62.34Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.12,108.85a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,405.12,108.85Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.83,117.55a.53.53,0,0,0-.79-.07.66.66,0,0,0-.07.86.55.55,0,0,0,.8.08A.67.67,0,0,0,394.83,117.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.19,87.43a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,457.19,87.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,115.93a.53.53,0,0,0-.79-.07.64.64,0,0,0-.07.86.53.53,0,0,0,.79.07A.64.64,0,0,0,336.54,115.93Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17,95.87a1.23,1.23,0,0,0,1.29-1.18,1.27,1.27,0,0,0-1.08-1.41,1.22,1.22,0,0,0-1.29,1.18A1.27,1.27,0,0,0,267.17,95.87Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.3,54.55a.26.26,0,0,0-.37-.11.31.31,0,0,0-.1.4.26.26,0,0,0,.37.11A.31.31,0,0,0,346.3,54.55Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.68,149.07a.54.54,0,0,0-.77-.22.63.63,0,0,0-.2.83.54.54,0,0,0,.77.23A.65.65,0,0,0,293.68,149.07Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.85,63.82a.53.53,0,0,0-.76-.22.64.64,0,0,0-.21.83.54.54,0,0,0,.77.23A.64.64,0,0,0,334.85,63.82Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,65.72a.54.54,0,0,0-.77-.23.64.64,0,0,0-.2.84.53.53,0,0,0,.76.22A.63.63,0,0,0,335.21,65.72Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.19,155.59a.82.82,0,0,0-1.07.55.94.94,0,0,0,.5,1.18.83.83,0,0,0,1.08-.55A1,1,0,0,0,265.19,155.59Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.17,96.56a.52.52,0,0,0-.69.35.6.6,0,0,0,.32.75.53.53,0,0,0,.69-.35A.59.59,0,0,0,294.17,96.56Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,171.48a.25.25,0,0,0-.34.18.29.29,0,0,0,.16.37.26.26,0,0,0,.35-.17A.31.31,0,0,0,249.36,171.48Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,190.43a.27.27,0,0,0-.34.18.31.31,0,0,0,.16.38.27.27,0,0,0,.34-.18A.3.3,0,0,0,234,190.43Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,164.89a.53.53,0,0,0-.69.35.61.61,0,0,0,.32.76.53.53,0,0,0,.69-.36A.59.59,0,0,0,252.71,164.89Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75,67.06a.54.54,0,0,0-.7.35.6.6,0,0,0,.33.75.52.52,0,0,0,.69-.35A.6.6,0,0,0,284.75,67.06Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,58.33a.53.53,0,0,0-.69.35.61.61,0,0,0,.32.76.53.53,0,0,0,.69-.36A.59.59,0,0,0,346.64,58.33Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,69a.86.86,0,0,0-1.12.57,1,1,0,0,0,.52,1.22.87.87,0,0,0,1.13-.57A1,1,0,0,0,178.06,69Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.47,55.17a.54.54,0,0,0-.72.37.62.62,0,0,0,.33.78.55.55,0,0,0,.72-.37A.62.62,0,0,0,245.47,55.17Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.94,72.63a.56.56,0,0,0-.72.37.65.65,0,0,0,.34.79.56.56,0,0,0,.72-.37A.65.65,0,0,0,267.94,72.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.73,44.61A.55.55,0,0,0,280,45a.64.64,0,0,0,.34.78.55.55,0,0,0,.72-.37A.63.63,0,0,0,280.73,44.61Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Moon--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.88,
    cy: 247.2,
    rx: 115.03,
    ry: 116.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,131.19l1.87,0,2.3,0c.91,0,2,0,3.17.14l4,.3c1.48.15,3.09.38,4.84.59A120.92,120.92,0,0,1,428,134.61c1.12.25,2.24.62,3.4.94s2.37.63,3.56,1.06l3.7,1.26c1.27.41,2.52,1,3.82,1.47a110.45,110.45,0,0,1,16.24,8,116.71,116.71,0,0,1,32.77,29.46,116.11,116.11,0,0,1,21.58,48.9,119,119,0,0,1-.49,45.53c-.6,2.59-1.15,5.21-1.93,7.79s-1.6,5.16-2.45,7.75a116.87,116.87,0,0,1-15.68,29.45,128.08,128.08,0,0,1-11.2,13.11,124.13,124.13,0,0,1-13.28,11.49,113.71,113.71,0,0,1-15.12,9.48l-2,1c-.67.35-1.34.69-2,1l-4.12,1.88-4.22,1.68-1.06.42-1.08.37-2.16.74-2.16.74-2.2.63c-1.47.4-2.93.89-4.43,1.2l-4.49,1-4.54.82a114,114,0,0,1-37.1,0l-4.55-.82-4.49-1c-1.5-.32-2.95-.81-4.43-1.21l-2.2-.63-2.16-.73-2.16-.74-1.08-.37-1.06-.42L355,354.26l-4.12-1.88c-.69-.3-1.36-.64-2-1l-2-1a113.82,113.82,0,0,1-15.13-9.48,124.13,124.13,0,0,1-13.28-11.49,125.9,125.9,0,0,1-11.2-13.12,122.33,122.33,0,0,1-9-14.32,125,125,0,0,1-6.7-15.13c-.85-2.59-1.78-5.14-2.45-7.75s-1.33-5.2-1.93-7.79a118.83,118.83,0,0,1-.48-45.54,116.3,116.3,0,0,1,21.57-48.89A116.59,116.59,0,0,1,341,147.39a109.48,109.48,0,0,1,16.24-8c1.3-.5,2.55-1.06,3.81-1.47l3.7-1.26c1.2-.43,2.41-.71,3.56-1.06s2.29-.69,3.4-.94a121.06,121.06,0,0,1,11.94-2.32c1.74-.21,3.35-.44,4.83-.59l4-.3c1.2-.11,2.26-.12,3.17-.14l2.3,0,1.86,0-1.86.06-2.3.07c-.91,0-2,.05-3.17.17l-4,.31c-1.47.16-3.08.4-4.83.61-3.48.5-7.47,1.26-11.91,2.36-1.11.25-2.23.62-3.39.94s-2.36.63-3.56,1.07L361.15,138c-1.27.42-2.51,1-3.81,1.48a110.73,110.73,0,0,0-16.2,8.06A116.77,116.77,0,0,0,308.48,177,116,116,0,0,0,287,225.8a118.67,118.67,0,0,0,.51,45.4c.59,2.59,1.14,5.2,1.93,7.77s1.59,5.14,2.45,7.72A116.13,116.13,0,0,0,307.54,316a127.24,127.24,0,0,0,11.16,13.07A123.21,123.21,0,0,0,332,340.55,112,112,0,0,0,347,350l2,1c.66.35,1.33.69,2,1l4.11,1.87,4.2,1.67,1.06.42,1.07.37,2.15.73,2.16.73,2.2.63c1.46.4,2.91.89,4.41,1.2l4.47,1,4.54.82A122.09,122.09,0,0,0,399.89,363a123.4,123.4,0,0,0,18.48-1.51l4.53-.82,4.48-1c1.49-.3,2.94-.8,4.41-1.19l2.19-.63,2.16-.74,2.15-.73,1.07-.37,1.06-.42,4.2-1.67,4.11-1.87c.69-.3,1.36-.64,2-1l2-1a112.9,112.9,0,0,0,15.07-9.44,123.33,123.33,0,0,0,13.24-11.45A125,125,0,0,0,492.21,316a116.3,116.3,0,0,0,15.64-29.34c.86-2.58,1.78-5.12,2.45-7.72s1.34-5.18,1.93-7.76a118.92,118.92,0,0,0,.52-45.4A116.13,116.13,0,0,0,491.28,177a116.35,116.35,0,0,0-32.67-29.44,109.76,109.76,0,0,0-16.19-8.07c-1.3-.5-2.55-1.06-3.81-1.47l-3.69-1.27c-1.19-.44-2.4-.72-3.55-1.07s-2.28-.69-3.4-.94c-4.44-1.1-8.43-1.86-11.91-2.36-1.75-.21-3.35-.45-4.83-.61l-4-.31c-1.2-.12-2.26-.15-3.17-.17l-2.3-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.32,175.46l-3.23-2.5a2.79,2.79,0,0,1-.91-1,4.59,4.59,0,0,1-.27-1.43,3.64,3.64,0,0,0-3.92-2.94c-.69-1.77-.85-3.71-1.48-5.51s-1.91-3.56-3.78-3.89a9.24,9.24,0,0,1-2.17-.31,10.14,10.14,0,0,1-1.89-1.53c-2.17-1.66-5.95-.76-7.32-3.12a18.6,18.6,0,0,0-.83-1.74,4.17,4.17,0,0,0-2-1.23c-2.72-1-5.74-2-8.41-.87a14.22,14.22,0,0,1-2.83,1.2c-1.14.18-2.37-.25-3.42.21-.63.28-1.15.87-1.83.9a2.66,2.66,0,0,1-1.36-.48,14,14,0,0,0-8.76-2,5.21,5.21,0,0,1,1.11-.61c.3-.11.62-.15.93-.24a3.86,3.86,0,0,0,2-1.26l-.19-.35c-.41.28-1,0-1.34-.29a2.1,2.1,0,0,0-1.27-.66,4.62,4.62,0,0,0-.71.18c-1,.23-2-.64-3-.66a3.47,3.47,0,0,0-1,.19,12,12,0,0,0-4,2.24,1.28,1.28,0,0,0-.34.39,1.05,1.05,0,0,0-.08.68,2.54,2.54,0,0,0,1.34,1.89,4.07,4.07,0,0,0,2.54.19,2.1,2.1,0,0,1,.24-.06,5.07,5.07,0,0,0-1.34,1.64,3.62,3.62,0,0,0,.32,3.85c-1,.67-2.09-.9-3.29-1-.88-.08-1.6.64-2.19,1.3l-2.41,2.72-2.85-.8a2.25,2.25,0,0,0-1.4-.09c-.44.17-.73.6-1.1.91a2.47,2.47,0,0,1-3.44-.39,1.79,1.79,0,0,1-.22-.38,1.72,1.72,0,0,0,.87-.95,1,1,0,0,0-1-.62,2.41,2.41,0,0,1,.95-1.5c.69-.47,1.67-.65,2-1.4l1.54-1a1.45,1.45,0,0,0,.48-.44.48.48,0,0,0-.05-.57c.94-1-.21-3.39.81-4.62.66-.8,1.94-.66,2.88-.22a8.72,8.72,0,0,0,2.86,1.2c1.56.12,2.84-1.14,4-2.16s2.69-1.77,4.24-1.17c-.43-.16.81-2.13,1.54-2.07.44,0,.48.73.81.92,2.12,1.16,4.81-.38,7.12-.64a28.75,28.75,0,0,1,8.83.34c.19-.77-.67-1.35-1.39-1.67a41.65,41.65,0,0,0-8-2.88A24.21,24.21,0,0,0,381,141a7.82,7.82,0,0,1-3.53,1c-.61,0-1.2-.24-1.81-.24a4.2,4.2,0,0,0-2.81,1.36,4.76,4.76,0,0,0-2.53.78c-.34.21-.67.43-1,.67.22.29.66.11,1-.06a5.65,5.65,0,0,1,1.79-.6l-.37.42c-.74.86-1.8.64-2.92.77a5.62,5.62,0,0,0-1.15.18,2.6,2.6,0,0,0-1,.7l1.09-1.28a1.35,1.35,0,0,0,.45-1,3.51,3.51,0,0,0,2.81-1.54,1.14,1.14,0,0,1,.37-.41c.32-.17.73.06,1.06-.07s.4-.43.55-.68a4.31,4.31,0,0,1,1.81-1.42l3.41-1.77-1.35-.2a5,5,0,0,0-1,.12h-.1a26.72,26.72,0,0,0-10.77,3,7.63,7.63,0,0,1-.87.41c-.28.1-.58.16-.88.24a26.49,26.49,0,0,0-5.35,2.15l-9.72,4.76c-.35.17-.76.46-.66.84l2,.22a10.79,10.79,0,0,0-4.1,2,3,3,0,0,1-1.24.73c-.28.06-.56,0-.83.08a2.74,2.74,0,0,0-1.05.56l-10.08,7.45a35.49,35.49,0,0,0-5.41,4.59c-1.8,2-4.1,3.74-5.56,6-1.19,1.87-1.94,4-3.25,5.79l2.81-2.23a8.55,8.55,0,0,0,1.22-1.11,12.14,12.14,0,0,0,.78-1.1,25.36,25.36,0,0,1,2.19-2.66,5.89,5.89,0,0,1,1.2-1.09c.29-.18.62-.31.9-.51s.62-.63.95-.92a1.25,1.25,0,0,1,1.19-.35c-.34.61-.71,1.2-1.11,1.78a1.62,1.62,0,0,1-.5.51,2.88,2.88,0,0,1-.73.17c-1.06.24-1.63,1.37-2.05,2.37l1.27-.09a.8.8,0,0,1-.1.68,30.9,30.9,0,0,1-3.7,6.06,8.82,8.82,0,0,0,1.79-4.47,17.15,17.15,0,0,0-3.85,3.76,4.64,4.64,0,0,1-2.85,1.83,2.78,2.78,0,0,1,.46-1.42c-1.18-.05-2,1.17-2.5,2.23l-3.23,6.43-2.06,4.12-1.62,3.21a1.5,1.5,0,0,0-.2,1.3,27.86,27.86,0,0,0,4.12-5.12A7,7,0,0,1,313,189c.28-.29.63-.52.93-.79,1.17-1,1.69-2.76,3-3.64-.08,1.29-1.22,2.2-2.08,3.15a9,9,0,0,0-1.93,3.44,5.13,5.13,0,0,1-.43,1.21c-.22.37-.56.67-.79,1a4.38,4.38,0,0,0-.31,2.71.23.23,0,0,0,0,.14c.08.11.24,0,.36,0l2.45-1.56a5.74,5.74,0,0,0,.28,2.24,2.49,2.49,0,0,1-.27,2.17c-1.34,1.62-2.35,2.54-2.52,4.81-.12,1.55-.23,3.3-1.42,4.27-.26.2-.58.39-.67.71a1.92,1.92,0,0,0,.13.94c.24,1.19-.76,2.21-1.47,3.19a2.3,2.3,0,0,0-.45.93,4.06,4.06,0,0,0,0,.92,4.16,4.16,0,0,1-.42,2.08l1.58.94a2.08,2.08,0,0,1,.69.55,7.52,7.52,0,0,1,.4.92c.24.45.72.77.85,1.26a2.42,2.42,0,0,1,0,.76,6.88,6.88,0,0,0,.85,3.9,4.29,4.29,0,0,1,.54,1.12c.2.92-.39,1.92-.06,2.79-.32,0-.15.6.09.84a1.45,1.45,0,0,0,.92.29,1.16,1.16,0,0,1,.88.36c.36.49-.14,1.14-.32,1.72a1.66,1.66,0,0,0,.42,1.66c.23.23.57.45.53.78s-.51.47-.84.64c-1,.5-.95,1.91-.52,2.91s1.14,1.93,1.13,3a2.34,2.34,0,0,1,2,1.6c.09.28.17.62.44.72s.65-.24.78-.58c.44-1.2,0-2.64.7-3.73a10.34,10.34,0,0,1,1.19-1.29,1.57,1.57,0,0,0,.4-1.62c-.15-.31-.46-.53-.63-.84s-.09-.81.26-.85a2.76,2.76,0,0,1,1,1.49h1.34c0,.71,0,1.42,0,2.13a2.48,2.48,0,0,0-.86,2.67,1.19,1.19,0,0,0,.58.76c.2.1.43.1.64.19,1.13.45.7,2.71,1.9,2.93.49.1,1-.26,1.46-.22s.85.27,1.09,0,.07-.52,0-.77a4.13,4.13,0,0,1,0-2.46,11.07,11.07,0,0,1-.85-3.3l.34-.18a5,5,0,0,1,1.45,1.66c.2.44.26.94.5,1.36a1,1,0,0,0,1.18.58,1.12,1.12,0,0,0,.52-1.15,5.05,5.05,0,0,1-.07-1.34c.18-.88,1.13-1.33,2-1.64.09.31-.29.52-.55.71a2.21,2.21,0,0,0-.51,2,5.79,5.79,0,0,0,1.12,3.12,2.57,2.57,0,0,0,3,.8c1.23-.64,1.43-2.29,1.45-3.68.38-.2.95-.35,1.16,0s0,.6,0,.9c0,.57.72.92.77,1.49a1.49,1.49,0,0,1-.32.89c-.46.75-.75,1.89,0,2.35a2.87,2.87,0,0,0,.64.23,2.72,2.72,0,0,1,1.83,2.48.87.87,0,0,1-.06,1.7c-.17,0-.37,0-.49.14-.27.27.09.83-.2,1.08a1.16,1.16,0,0,1-.34.14c-.62.22-.53,1.1-.47,1.76a4.48,4.48,0,0,1-1.73,3.94,2.47,2.47,0,0,1-2.94.25,8.17,8.17,0,0,1-.94-1.17,1.26,1.26,0,0,0-1.32-.52,1.52,1.52,0,0,0-.51.37,6.78,6.78,0,0,0-2.2,3.24A4.71,4.71,0,0,1,329,261a6.68,6.68,0,0,1-1.09,1.23,2.51,2.51,0,0,0-.56,1.93c.37.45-.18,1.06-.42,1.59s-.63,1-.84,1.55a5.3,5.3,0,0,0,.38,3.57,9.39,9.39,0,0,0,2.34,4.22,11.74,11.74,0,0,0,1,.73,9.77,9.77,0,0,1,3.55,3.47c.84.22,1.82-.52,2.56,0a1.78,1.78,0,0,1,.59.78l1.2,2.41a4.15,4.15,0,0,0,1.26,1.7,1.41,1.41,0,0,0,1.91-.22c.48-.74-.11-1.75.18-2.58.39-1.11,2.14-1.38,2.28-2.55.06-.5-.18-1.1.18-1.44a1.8,1.8,0,0,1,.54-.26,1.46,1.46,0,0,0,.81-1.68c1.44-.12,3.2-.07,3.9,1.2.16.28.45.65.69.44a14.64,14.64,0,0,1-.1-4.76,3.28,3.28,0,0,0,.11-1.32c-.27-1.28-2.11-1.54-2.71-2.7-.71-1.36.58-3.26-.35-4.48-.57-.74-1.77-.86-2.19-1.7a8.88,8.88,0,0,0-.36-.9,2.87,2.87,0,0,0-.78-.59c-1-.74-1.21-2.22-1.09-3.5a9,9,0,0,0,0-3.8,6,6,0,0,1-.46-1.35,1.55,1.55,0,0,1,1.47-1.65,1.44,1.44,0,0,1,1.33,1.7,3.83,3.83,0,0,1-.93,1.38,1.38,1.38,0,0,0-.27,1.55,1.13,1.13,0,0,1,.49,1.93,6.84,6.84,0,0,0-.65.37A1.38,1.38,0,0,0,343,259c.35.55.9.93,1.3,1.45.22.27.4.59.72.72a1.35,1.35,0,0,0,.53.1l1.46.08a1.7,1.7,0,0,0,.55,0,2,2,0,0,0,.72-.52,9.49,9.49,0,0,1,2.7-1.58,2.29,2.29,0,0,1,1.05-.28c.86,0,1.37.93,1.94,1.57a8.58,8.58,0,0,0,3.2,1.94c.55-2,1.09-4.25.3-6.21-.63-1.54-2-2.64-3.05-3.91s-1.87-2.89-1.37-4.43l.81-.42a4.67,4.67,0,0,1,2.53,2.73,28.43,28.43,0,0,1,.53,2.9,7.53,7.53,0,0,0,2.1,3.78c0-1.13-.05-2.26-.07-3.39a1.21,1.21,0,0,1,.25-.92,1.1,1.1,0,0,1,.89-.16,12.18,12.18,0,0,1,2.73.64,1.77,1.77,0,0,1,.73.42,1.86,1.86,0,0,1,.32,1c.16,1.38.18,3.06-1,3.81-.85.54-2.12.39-2.71,1.22-.39.55-.32,1.4-.84,1.84-.29.25-.72.33-.93.65-.32.5.13,1.17,0,1.76-.09.37-.41.72-.28,1.09.07.22.29.34.46.5.82.71.64,2,.4,3.07-.21.87-.41,1.74-.61,2.61a7.44,7.44,0,0,0-1.35-5,5.69,5.69,0,0,1-2.79-.47,2,2,0,0,0-2.81,2.74,6.38,6.38,0,0,1,.57,2.32c-.06,1-.72,2-.2,2.85l1.16.5c.62.27,1.36,1,.91,1.48s-1.49.27-1.41.86a.69.69,0,0,0,.23.38c.87.93,1.87,2.14,1.43,3.34a2.47,2.47,0,0,1,1.95.57,12.06,12.06,0,0,1,3.68,3.94c.29.48.54,1,.83,1.47.65.06.84-.88.76-1.54-.11-1-.23-2-.34-3a14.24,14.24,0,0,0-.39-2.26c-.31-1-.87-2-1.24-3a3.9,3.9,0,0,1,0-3.14,5.25,5.25,0,0,1,2.38,3.65c.08.53.08,1.06.16,1.59.27,1.66,1.35,3.1,1.55,4.77a4.3,4.3,0,0,0,.33,1.68,3.06,3.06,0,0,0,.74.74l3.21,2.49c.27.21.46.66.77.52-.42-1.42-.84-2.83-1.25-4.25l2.62,2.23a2.52,2.52,0,0,1,.39-2,1.55,1.55,0,0,1,1.85-.51,1.17,1.17,0,0,1,.36,1.76,4.21,4.21,0,0,1,4.94-.48,3.15,3.15,0,0,0,1.21.61c.83.1,1.68-.7,2.43-.32s.91,1.8,1.76,1.72c.51,0,.89-.69,1.38-.54l.18,1.23c1.35-.13,3-.56,3.24-1.91a4.32,4.32,0,0,1,.11-.72,1.93,1.93,0,0,1,.68-.77,5.93,5.93,0,0,0,2.26-3.27,3,3,0,0,0-1.57-3.39c-.33-.29,0-.83.33-1.1s.75-.67.57-1.07c-.12-.24-.41-.34-.57-.55-.45-.55.21-1.49-.22-2.06-.2-.25-.55-.32-.82-.48a1.78,1.78,0,0,1-.23-2.51,5.09,5.09,0,0,1,2.39-1.44l2.59-1c.68-.25,1.47-.66,1.49-1.39,0-.52-.37-1.16,0-1.47.23-.18.57-.09.85-.16.69-.16.79-1.09.75-1.8,0-.52-.07-1-.11-1.55a1.87,1.87,0,0,1,.05-.67c.15-.42.58-.64.92-.92s.63-.76.39-1.13l-3.51.15a2.66,2.66,0,0,1-1.51-.22,1,1,0,0,1-.37-1.33l-.85-.29c0-.66,0-1.33.05-2a1.26,1.26,0,0,1,.11-.55,1.11,1.11,0,0,1,.44-.42l1.65-1.1a1.44,1.44,0,0,0,.79,1.52c.51,0,.6-.75.36-1.2s-.64-.94-.43-1.41a4.63,4.63,0,0,1,.31-.46c.43-.83-.83-1.74-.58-2.64l-2.86-.76a8.29,8.29,0,0,0-.74-1,38.21,38.21,0,0,1-8.4.94l-.68,0a8.83,8.83,0,0,0,.14,2.24l1.37-1.15a12,12,0,0,0,.44,4.26,1.31,1.31,0,0,1,0,1.08c-.19.3-.59.39-.83.66-.7.79.66,2.1.18,3-1,0-1.93-1.47-2.87-1-.21.11-.38.33-.62.4-.52.16-1-.5-.92-1.06s.35-1,.42-1.6a7.77,7.77,0,0,0-.52-2.38,17.19,17.19,0,0,0-.36-2.28c-.27-.73-1.13-1.33-1.79-.94a3.15,3.15,0,0,0-.68-1.87A38.12,38.12,0,0,1,358.72,240a2,2,0,0,0-.23.18,3.69,3.69,0,0,0-.59,2.66c0,.93-.28,2.06-1.17,2.32-.77-.6-.63-1.95-1.42-2.53-.37-.27-.87-.31-1.25-.57a2.6,2.6,0,0,1-.77-2c-.1-1.2-.12-2.58.76-3.39a3,3,0,0,1,.5-.35c-6.88-7,27.43-3,27.43-13.68,0-7.37-1.71-11-3.09-12.67,1.67.58,4.73,1.17,9.9,1.17,12.95,0,17.56-34.56,24.54-24.68a3.05,3.05,0,0,1,2.77-.86c3.1.68,3.34,5.4,6,7.08l3.61-.08a3.26,3.26,0,0,0,3.17,1.57,4,4,0,0,0,3.58-3.2,3.38,3.38,0,0,0-2.69-3.79,7.68,7.68,0,0,1-1.6-.15c-.51-.16-1-.71-.78-1.21.89-1.22,2.85-.77,4,.18s2.11,2.3,3.55,2.73c.78-2.1,4-2.64,4.37-4.85a7.18,7.18,0,0,1,.17-1.69c.48-1.14,2.31-1.3,2.6-2.5a4.12,4.12,0,0,0-.15-1.55A2.79,2.79,0,0,1,443.32,175.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.29,193a5.23,5.23,0,0,0-1.58-.8,39,39,0,0,1,2.6,7.24,5.75,5.75,0,0,0,.91-.75C420.14,196.62,419.92,194.27,418.29,193Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,197.82a.42.42,0,0,0,.22.05,1.43,1.43,0,0,0,.22-.08c.27-.09.53.12.75.3s.53.34.76.19a.62.62,0,0,0,.11-.74,2.17,2.17,0,0,1-.27-.76c0-.12,0-.24.06-.37a1.15,1.15,0,0,0-.54-1.12,1.12,1.12,0,0,0-1.24.1,1.5,1.5,0,0,1,.36.71.52.52,0,0,1-.4.59c-.19,0-.36-.13-.55-.18a.63.63,0,0,0-.7.35A2.94,2.94,0,0,0,351.52,197.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.14,151.61a4.47,4.47,0,0,0,5.83,1.57,1.14,1.14,0,0,0,.31-.23c.39-.46,0-1.15-.38-1.61A6.13,6.13,0,0,0,420.14,151.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.26,144l3,.36c.49.06,1.16.45.9.87-.7-.13-1.27.73-1.11,1.43a2.45,2.45,0,0,0,1.45,1.47c4.23,2,9.34-1.34,13.76.11,2.35.77,4.14,2.79,6.47,3.64.95.34,2.21.74,2.26,1.77,0,.26-.07.52-.07.78a1.8,1.8,0,0,0,1.6,1.54,10.66,10.66,0,0,0,2.39-.1,6.74,6.74,0,0,1,4.62,1.52c.36.31-.25.77-.58,1.11-.75.76.09,2.16,1.14,2.35a6.07,6.07,0,0,0,3.07-.73,8.31,8.31,0,0,1,5.79-.15,5.75,5.75,0,0,1,3.68,4.32.82.82,0,0,1-.86,1.12,6.17,6.17,0,0,1-5.86-3.61,1.46,1.46,0,0,0-.48-.72A1.05,1.05,0,0,0,450,161c-1.46-.05-2.19,2-1.47,3.32s2.19,1.88,3.56,2.39a25.87,25.87,0,0,0,5,1.48,26.2,26.2,0,0,0,6.32,0,68.53,68.53,0,0,0,11.43-1.6l-1.73-2.4a11.63,11.63,0,0,0-3.29-3.44c-2.66-1.56-6.33-.84-8.7-2.81a11.19,11.19,0,0,0-2-1.74,5,5,0,0,0-1.89-.37,66.88,66.88,0,0,0-9.39.11,6.06,6.06,0,0,1-3.14-.29c-1.63-.83-2.07-2.94-3.18-4.41a10.71,10.71,0,0,0-3.59-2.67l-2.25-1.23a7.47,7.47,0,0,0-1.5-.67c-1.07-.3-2.22-.09-3.32-.29a9.22,9.22,0,0,1-2.83-1.27L422.71,142a4.46,4.46,0,0,0-1.79-.74c-1.37-.13-2.71,1-4,.62a5.55,5.55,0,0,1-1.3-.73,6.09,6.09,0,0,0-7.42.91,1.34,1.34,0,0,0-.47.94C407.74,143.68,408.59,143.94,409.26,144Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.27,279.33A7.81,7.81,0,0,0,505,276.9a12,12,0,0,0-2-1.55,12.44,12.44,0,0,1-4.65-6.57,3.56,3.56,0,0,0,1.51-2.54,20.85,20.85,0,0,0-.12-8.49c-.79-3.14-2.62-5.53-6.26-4.54a3.81,3.81,0,0,1-1.25.21c-1.65-.11-3-2.56-4.41-1.73-1.26-.58-.1-2.72-.87-3.88-.35-.53-1.09-.86-1.06-1.49,0-.36.29-.64.42-1a1.65,1.65,0,0,0-1.38-2,3.54,3.54,0,0,0-2.58.88,14,14,0,0,1-2.25,1.67,7.54,7.54,0,0,1,1.85,6.64c-1.6.09-3.35.14-4.62-.85a2.79,2.79,0,0,0-.91-.59,1.66,1.66,0,0,0-.93.12,11.27,11.27,0,0,0-4.29,3.55c-.1.11-.19.23-.28.34a9.31,9.31,0,0,0-3.58-4.05c-1.2.16-1.74,1.67-1.56,2.88s.84,2.31,1,3.52c-.52,1.38-3,.22-4,1.32a1.84,1.84,0,0,0,0,2.1c.39.65,1,1.16,1.33,1.82q-1.41,2.26-2.81,4.55c-.19-.64-.49-1.38-1.13-1.51-.88-.18-1.46.9-1.64,1.78s-.46,2-1.34,2.16c.36,1.12,2.21.46,3.11,1.21.69.56.52,1.64.59,2.53s.95,1.95,1.66,1.41a1.57,1.57,0,0,0,.45-1.08,17.52,17.52,0,0,1,3.58-8.27,3.89,3.89,0,0,0,1.15-2.23c0-.73-.45-1.48-.18-2.16.38-.95,1.67-.86,2.64-1.25a4.73,4.73,0,0,1-.77,1.1,5,5,0,0,0-1.44,1.71c-.27.84.15,1.85-.29,2.61a4.55,4.55,0,0,1-1,.95,6,6,0,0,0-1.39,3.64c-.4,2.73-.78,5.61.27,8.16.55,1.36,1.5,2.58,1.78,4-.75.59-1.84,0-2.52-.7s-1.53-1.49-2.45-1.23c-.72.2-1.34,1-2,.73a4.59,4.59,0,0,0-2.3-5.1,1.14,1.14,0,0,1-.69-1.16c-1,0-1.51,1.27-1.72,2.29s-.8,2.32-1.83,2.15c-.35-.05-.66-.28-1-.27-.78,0-1,1.16-1.7,1.53s-1.29.05-1.85.35-.65.73-1,1c-.93.75-2.28,0-3.25-.65s-2.37-1.35-3.26-.55c-.71.65-.57,1.84-1.13,2.62-.69,1-2.35,1.2-2.51,2.39a1.86,1.86,0,0,0-2.64.18,6.76,6.76,0,0,0,1.23,3.79,7,7,0,0,1-2.61,1.8,17.87,17.87,0,0,0,1.57,3.12c-1,.62-.67,2.29-1.59,3-.54.39-1.28.29-1.93.44s-1.29.91-.88,1.43a1.44,1.44,0,0,1-2.28.75c-.59-.72-.77-1.74-1.47-2.36-1-.9-2.63-.54-3.88-1.08a7.39,7.39,0,0,0-1.15-.52c-1.31-.33-2.49,1.07-2.63,2.42a15.37,15.37,0,0,0,.63,4c.22,1.34,0,2.95-1.12,3.67-.57.36-1.31.45-1.75,1-.88,1.05.25,2.55.49,3.91a5.91,5.91,0,0,1-.4,2.74c-.47,1.49-1.36,3.3-2.92,3.19-1.22-.08-2-1.37-2.38-2.54s-.78-2.51-1.85-3.11c-1.95-1.1-4.42,1.1-6.53.38l.51,1.43c-1,.23-1.22,1.54-1,2.53s.62,2,.25,3c-.44,1.12-1.78,1.53-2.95,1.8a8.55,8.55,0,0,1,.2,4c.44.46-.54,1.64-1.17,1.76a7.62,7.62,0,0,1-1.89-.22A2.86,2.86,0,0,0,395,328l3.92,1.12a2.74,2.74,0,0,0,1.41.16,3.15,3.15,0,0,0,1.25-.8c3-2.58,7.73-3.75,10.95-1.42.65.47,1.31,1.1,2.11,1a2.66,2.66,0,0,0,1.36-.72c1.35-1.09,2.82-2.46,2.75-4.2a4.85,4.85,0,0,1,0-1.37c.24-1,1.47-1.34,2.22-2,1.78-1.65.52-4.6-.82-6.63l5-3.12a2.67,2.67,0,0,1,1.41-.54,3.88,3.88,0,0,1,1.48.53c2.89,1.26,6.08-.87,8.3-3.12a6.6,6.6,0,0,0,7.79,1.89,2.49,2.49,0,0,1,.25,3.41,7.06,7.06,0,0,1-3.12,2.07,7.82,7.82,0,0,1,1.67,3.39,2.68,2.68,0,0,1-1.74,3l.73,1.31a5.19,5.19,0,0,1,3,.19,2.32,2.32,0,0,1,1.44,2.44c-1.67.93-3.73.24-5.58-.25s-4.2-.58-5.26,1a8.7,8.7,0,0,1-3.43,4,3,3,0,0,0-.46-3.61c-1.34-.77-2.9.59-3.79,1.87s-2.18,2.79-3.67,2.35c-.52-.16-1-.56-1.53-.53a2,2,0,0,0-1.37,1c-.87,1-1.77,2.29-1.6,3.64s2.12,2.35,2.92,1.24c-.37-1.34-.56-3.14.66-3.8s2.87,1,2.54,2.47a4.29,4.29,0,0,1-3.2,2.77,28.09,28.09,0,0,0-4.28,1.14c-.55.26-1.08,1.09-.54,1.38a2.38,2.38,0,0,0,1.77.25,3,3,0,0,1-.93,3.3,2.91,2.91,0,0,1-3.41,0c-2.09-1.54-1.3-5-2.84-7.13a3.73,3.73,0,0,0-2.74-1.48c-2.21-.11-4,1.79-5.05,3.78a3.41,3.41,0,0,1-.82,1.21c-.87.69-2.11.29-3.18,0s-2.53-.13-2.81.95a21.63,21.63,0,0,0,8.54,6.23,1.48,1.48,0,0,1,.82.58c.18.34,0,.76,0,1.15A4,4,0,0,0,408.6,351a5.34,5.34,0,0,0,2.55,1.77,1.87,1.87,0,0,0,2.31-1.49c0-1.95-3.63-2.26-3.56-4.21a4.75,4.75,0,0,1,4.34.12,6,6,0,0,0,8.69,1.85c1.15-.94,2-2.36,3.42-2.78,2.26-.66,4.23,1.53,6.37,2.52,2.72,1.27,5.9.53,8.81-.22l7.38-1.91-4.15-.52a21.55,21.55,0,0,0,6.35-3.06,2.6,2.6,0,0,0-2.23-2.3c3.14-.62,4-4.93,6.73-6.6a17.73,17.73,0,0,0,2.69-1.44,5.09,5.09,0,0,0,1.36-4,12.64,12.64,0,0,0-4.27-9,12.51,12.51,0,0,0,6.36,1c0,1.32.93,3.2,2,2.46a1.9,1.9,0,0,0,.61-1l1.86-5a8.57,8.57,0,0,1,1.89-3.39c1.58-1.49,4.17-1.68,5.45-3.44-.19.78.82,1.41,1.57,1.17a3.11,3.11,0,0,0,1.61-1.69c.92-1.76,1.26-4.51-.58-5.22-1.65-.63-4.25.85-4.91-.81a2.29,2.29,0,0,1,0-1.37,16.13,16.13,0,0,1,8.91-10.72c1.47-.66,3.32-1.48,3.33-3.1a2,2,0,0,1,1.54,2.35,4.45,4.45,0,0,0,3.23-.86c-.78-.55-.55-1.84.11-2.53s1.58-1.07,2.29-1.71c2-1.81,2.27-5.67,4.93-6.1,2,.8,1.74,3.76.9,5.77s-1.84,4.55-.35,6.14a5.17,5.17,0,0,1,3.31-2.92,5.83,5.83,0,0,0-.57,6.2,10.66,10.66,0,0,1,5-5.29c-.12-.64-.25-1.27-.37-1.9,1.76.41,3.45-1.29,3.75-3.09A10.26,10.26,0,0,0,506.27,279.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.69,317.79c-.87-.63-1.89-1.2-2.16-2.26-.14-.5-.1-1.11-.47-1.45s-1.14-.33-1.82-.32a10.22,10.22,0,0,1-5.2-1.25,5.13,5.13,0,0,0-1.43-.69,4.26,4.26,0,0,0-1.7,0,10.51,10.51,0,0,0-7.24,6,5.14,5.14,0,0,1-1.23,2.45,5.39,5.39,0,0,0-1,.9,1.14,1.14,0,0,0-.08,1,4.84,4.84,0,0,0,3,3.16c.55.21,1.18.38,1.33.91a7.58,7.58,0,0,1-.09,1.41c.05,1.18,1.53,1.4,2.38,2.07,1.1.88,1.12,2.58,2.11,3.55a6.34,6.34,0,0,0,3.23,1.21l3.26.6c2.36.43,5.42.65,7.84-1.38a6.12,6.12,0,0,0,2.21-4.24,8.22,8.22,0,0,0-.86-3.69,2.69,2.69,0,0,0,1.77-1.72,2.57,2.57,0,0,0-.27-1.87A11.07,11.07,0,0,0,346.69,317.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.22,345.92a4.45,4.45,0,0,0,4.4-1.21,1.21,1.21,0,0,0,.4-.73.54.54,0,0,0-.45-.61c-1.35,1-3.64.45-4.62,1.84a.51.51,0,0,0-.12.43A.55.55,0,0,0,456.22,345.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.74,348.48a2.08,2.08,0,0,0-.72.26c-.93.39-2,.35-2.93.7a7.49,7.49,0,0,0-1.68,1l-3,2.15,6.54-1.39a7.81,7.81,0,0,0,1.65-.48c.87-.41,1.58-1.12,2.42-1.59l-1.66-.52A1.72,1.72,0,0,0,448.74,348.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.3,169.47a1.62,1.62,0,0,0-1.37-1,4.1,4.1,0,0,0-1.76.26,21,21,0,0,0-4.88,2.27,4.22,4.22,0,0,0-1.07.86,5,5,0,0,0-.65,3.48l3.66-.12a5,5,0,0,1,1,0,9.4,9.4,0,0,1,1.86.72,5.87,5.87,0,0,0,2.52.41,1.39,1.39,0,0,0,.05-1.59,4.62,4.62,0,0,1-.67-1.55C470.91,171.86,472.7,170.77,472.3,169.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.61,188.7a24.5,24.5,0,0,1,2.55.38,4,4,0,0,0,2.51-.34,1.91,1.91,0,0,0,.91-2.21,3,3,0,0,0-1.52-1.3l-1.57-.81a1.79,1.79,0,0,1-.88-.72c-.29-.6.14-1.3.58-1.81s.93-1.14.75-1.79a1.79,1.79,0,0,0-.67-.85,12,12,0,0,0-2.85-1.76,3.6,3.6,0,0,0-1.27-.35,4.14,4.14,0,0,0-1.68.4l-2.6,1a2.07,2.07,0,0,0-1.32,1c-.21.53.35,1.28.84,1,.42,1.07-.77,2.06-1.06,3.18a6.27,6.27,0,0,0,2.31,5.14,3.18,3.18,0,0,0,1,.2C465,189.11,466.28,188.66,467.61,188.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.4,172.66a2.15,2.15,0,0,0,.92.48.72.72,0,0,0,.82-.49,1.08,1.08,0,0,0-.24-.72l-1-1.61a4.26,4.26,0,0,0-1.05-1.29,1.54,1.54,0,0,0-1.57-.25,2.58,2.58,0,0,0,.43,2.25A7.57,7.57,0,0,0,485.4,172.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.32,181.71a8.56,8.56,0,0,1,1.5,1,5.27,5.27,0,0,1,.62,1.05,7,7,0,0,0,2.43,2.65,6.11,6.11,0,0,0-.14-2.17,1.83,1.83,0,0,0-.34-.75,2.71,2.71,0,0,0-.85-.55,4.25,4.25,0,0,1-1.63-1.6c-.17-.29-.3-.6-.5-.88-.56-.76-1.54-1.1-2.18-1.8a12.49,12.49,0,0,0-.8-1,1,1,0,0,0-1.15-.24l1.36,2.2A6.58,6.58,0,0,0,492.32,181.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.81,308.66a1.1,1.1,0,0,0-.93-.21.52.52,0,0,0-.27.79,5.3,5.3,0,0,1-1.59.27c-.54.09-1.13.42-1.17,1a2,2,0,0,1,0,.55c-.11.35-.6.49-.66.86a.55.55,0,0,0,.54.55,1.33,1.33,0,0,0,.8-.29,4.26,4.26,0,0,1,1.57-.86c.59-.1,1.32.32,1.26.92a1.9,1.9,0,0,0,1.59-1.43A2.68,2.68,0,0,0,485.81,308.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,219.75a7.33,7.33,0,0,0,.39,2.89c.22.83.44,1.66.67,2.48s.51,1.66,1.26,1.92a11,11,0,0,0,1.3.16c.93.2,1.57,1.2,2.52,1.28s1.88-1.12,2-2.22-.21-2.21,0-3.31a3.11,3.11,0,0,1,2.53-2.69,4,4,0,0,0,1.38-.2,2.23,2.23,0,0,0,.9-1.65,5.73,5.73,0,0,0,.07-3.15c-.35-.94-1.19-1.66-1.41-2.64a1.67,1.67,0,0,0-2,1.07,4.83,4.83,0,0,0-.11,2.48c-.07-.49-1.88.92-2,1-1.42.95-2.34,1.3-3.87.93S474.36,217.27,474,219.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.07,253.17a2.68,2.68,0,0,0,.83-1.62,6.76,6.76,0,0,0-.19-3.86,5.06,5.06,0,0,0-5.55-3,2.49,2.49,0,0,1-1.8,0c-.46-.29-.61-.9-1-1.26-.71-.63-1.83-.24-2.57.35a6.93,6.93,0,0,1-2.27,1.64,1.88,1.88,0,0,0-2.1-1,1.91,1.91,0,0,0-1.42,1.87c0,1.1,1,1.92,1.47,2.91a4.46,4.46,0,0,1-.27,3.94,8.72,8.72,0,0,1-2.83,2.9,2.78,2.78,0,0,0-.83.73,2.53,2.53,0,0,0,0,2c.42,1.62.91,3.21,1.47,4.79.87-.54,1.92.41,2.37,1.34s.9,2.07,1.91,2.25,2.21-.8,3-.15c.26.21.42.55.73.68a1.1,1.1,0,0,0,.85-.07,4.09,4.09,0,0,0,1.42-6.13,7.52,7.52,0,0,1,3.09-3.18,2.71,2.71,0,0,0,.95-.68c.65-.89-.16-2.31.48-3.21C461.29,253.64,462.38,253.71,463.07,253.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.05,211.7c-.91-6-5.67-13.3-13.21-14.56-5.28-1.64-11.44,1.11-14.16,6a14.92,14.92,0,0,0,1.26,15.76,17.58,17.58,0,0,0,14.49,6.75c3.45-.1,7-1.26,9.28-3.9S467.58,215.2,467.05,211.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.72,312.4c-5.41.16-11.28.18-15.64-3-2.59-1.91-4.32-4.74-6.6-7s-5.64-4-8.65-2.88c-3.45,1.28-5.47,5.92-9.14,5.69-2.69-.16-4.42-2.94-6.9-4-2.75-1.15-8.07-.35-10.16,1.76s-4.52,4.83-5.64,7.59c6.13,7.84,16.89,10.1,26.78,11.28,17.81,2.12,22.8,1.48,40.68,0,4.32-.35,20.37-5.22,24.34-6.95s10.78-1.8,12-4.36C381.78,311,366.76,312,353.72,312.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.29,172.09c-2-6.14-6.87-11.81-13.25-12.8s-13.55,4.57-12.55,11c-3.52-2.18-7.15-4.41-11.22-5.15s-8.75.33-11.18,3.68c-1.42,2-2.15,4.7-4.39,5.62-3.34,1.37-5-2.56-11.46-.54s-9.67,8.9-9.8,9.61c0,0-17.78.28-23.16,10h0a185.29,185.29,0,0,1,74.16-4c3.92.59,7.88,1.3,11.82.91s7.95-2.09,10.18-5.36C507,181.32,506.7,176.34,505.29,172.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.13,207.08c-4.67-1.14-6.11-5.15-13.12-5-2.71.06-8.16,2.78-8.16,2.78L324,198.58a8.29,8.29,0,0,0-15.84,2.86c-.33-2.42-3.36-4.19-5.91-3.68a12.55,12.55,0,0,0-7.56,5.13c-1.61,2.48-2.26,2.73-4.44,7.38L289,213.52q29.7-.32,59.29-3.27c1.41-.14,3.26-.78,3.1-2.19C351.24,207,349.17,207.33,348.13,207.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,342.29c-4.68-1.14-6.12-5.15-13.12-5-2.71.06-8.17,2.78-8.17,2.78s-1.87-4.16-2.81-6.28a8.29,8.29,0,0,0-15.85,2.86c-.33-2.43-3.36-4.2-5.91-3.68a12.48,12.48,0,0,0-7.55,5.12c-1.61,2.48-2.27,2.74-4.45,7.38l-1.32,3.25q29.7-.32,59.29-3.27c1.41-.14,3.26-.78,3.11-2.19C483.1,342.21,481,342.54,480,342.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,128.76c-4.67-1.14-6.11-5.15-13.12-5-2.71.06-8.16,2.79-8.16,2.79l-2.82-6.29A8.29,8.29,0,0,0,389,123.12c-.32-2.42-3.35-4.19-5.91-3.68a12.55,12.55,0,0,0-7.55,5.13c-1.61,2.48-2.26,2.73-4.45,7.37l-1.31,3.26q29.7-.31,59.29-3.27c1.41-.14,3.25-.78,3.1-2.19C432.09,128.68,430,129,429,128.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 625.33,
    cy: 84.29,
    r: 40.96,
    transform: "translate(205.13 555.01) rotate(-55.92)",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.13
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.8,70.21c-.1-.27-.2-.54-.31-.81l0-.12c-.11-.28-.22-.56-.34-.83s-.24-.57-.37-.85-.32-.71-.49-1.07c-.41-.85-.85-1.68-1.31-2.49a105.64,105.64,0,0,0-19,7.76c-12,6.53-15.93,16.13-30.1,22.33s-21.17-.78-18.43-5.27,20.17-13.37,38.8-20.15C645,64.08,654,61.36,658.39,60.09a37.57,37.57,0,0,0-2.38-3l-.62-.69L655,56l-.11-.12c-.31-.33-.64-.66-1-1l-.43-.4-.45-.43a196.79,196.79,0,0,1-37.3,17.78c-14.84,5.27-25.24,8.48-31.37,10.25-.05.92-.07,1.86-.05,2.79,0,.51,0,1,0,1.52l0,.53c0,.11,0,.23,0,.34h0c.06.65.12,1.3.2,2,0,.25.06.49.1.74h0c0,.42.12.83.2,1.26,0,.16.05.31.08.46.07.39.15.77.23,1.16h0c.09.39.17.78.27,1.17s.14.56.22.84c.17.67.37,1.33.59,2,0,.12.07.22.11.34s.15.45.23.67c.13.4.28.79.43,1.17a6.25,6.25,0,0,0,.24.6c.06.16.12.32.19.48.22.52.44,1,.68,1.53s.41.87.63,1.3a41,41,0,0,0,5.12,7.73c9.39-4.77,33.78-17.1,45.49-22.3,8.67-3.86,19.57-6.75,26.68-8.39-.12-1.22-.32-2.44-.55-3.66,0-.14-.06-.28-.1-.42s0-.28-.08-.42-.12-.52-.19-.79-.11-.47-.17-.7-.09-.32-.13-.48c-.1-.36-.2-.7-.3-1s-.17-.57-.27-.86-.22-.67-.34-1ZM589.86,82.33a2,2,0,1,1-1.2,2.52A2,2,0,0,1,589.86,82.33Zm7.09,22a2.59,2.59,0,1,1,1.58-3.31A2.59,2.59,0,0,1,597,104.34Zm42.4-22.88a2,2,0,1,1,1.2-2.52A2,2,0,0,1,639.35,81.46Zm5.49,3.17a1,1,0,1,1,.61-1.26A1,1,0,0,1,644.84,84.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633,103.71a271.94,271.94,0,0,1-36.45,9.84,1.8,1.8,0,0,1,.2.19,3.71,3.71,0,0,0,.29.27l.08.08.32.29c.23.23.49.45.73.67.83.73,1.68,1.41,2.55,2.07l.14.1c.82.6,1.65,1.17,2.5,1.71.15.11.31.2.46.3a43.38,43.38,0,0,0,4.87,2.55,40,40,0,0,0,5.34,1.94h0l.84.25h.07c.58.16,1.17.3,1.76.41a4,4,0,0,0,.47.11h0l.18,0,.34.07,1.26.22c.79.12,1.59.23,2.39.3,8.11-3.44,15.35-6.3,17.57-6.55,2.57-.29-1.95,2.79-7.82,6.34a41.5,41.5,0,0,0,7.8-1.92,40.8,40.8,0,0,0,10-5.13c.25-.18.52-.36.77-.56s.63-.47,1-.72.72-.57,1.08-.87a40.37,40.37,0,0,0,5.2-5.26h0a41.4,41.4,0,0,0,3.4-4.74l.51-.88c-2,.94-4.77,2.25-8.81,4.09-12.18,5.55-33.46,11.43-33.48,9.71s11.49-8.5,27.13-13.49C653,102.82,659,101,663.3,99.71c.27-.67.52-1.34.76-2a42.3,42.3,0,0,0,1.35-4.84c.08-.4.16-.79.24-1.2s.18-1.06.25-1.6c.14-.9.23-1.81.29-2.72a.53.53,0,0,0,0-.13A147.34,147.34,0,0,1,633,103.71Zm-19.67,12.67c-3.62,1.27-6.85,1.46-7.21.44s2.28-2.9,5.9-4.17,6.85-1.47,7.21-.44S616.94,115.11,613.32,116.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.13
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.72,47.68a98,98,0,0,1-26.51,13.61c-12,4-23.22,6.88-30.27,8.54a39.33,39.33,0,0,1,2.5-5.39c7-.8,15.18-2,21.45-4,13.69-4.23,26.24-12.72,23.29-13.46s-12.35,5.06-25.35,8.91a157.08,157.08,0,0,1-16.33,3.81,39.13,39.13,0,0,1,4.87-5.43l.06-.06.11-.1a124.59,124.59,0,0,0,20.44-6c5-1.89,8.78-3.38,11.72-4.54.45,0,.89.1,1.34.16h0c.74.11,1.47.23,2.21.39,0,0,0,0,.07,0q1.93.39,3.84,1h0l.58.18h0l.33.11c.4.13.79.26,1.19.41l.64.24.44.18c1,.39,2,.82,2.92,1.29h0l.36.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.78,70.15l-.3-.81-.05-.12,0-.08c-.11-.27-.22-.55-.34-.82s-.22-.53-.33-.78l-.53-1.14c-.45-.94-.93-1.86-1.46-2.75-.06-.12-.14-.25-.21-.37l-.21-.35c-.19-.32-.38-.63-.58-.94A41.3,41.3,0,0,0,656,57l-1-1.09c-.49-.5-1-1-1.49-1.48s-.81-.75-1.23-1.12-1-.84-1.49-1.23c-.19-.17-.39-.32-.59-.47h0l-.45-.34-.22-.15c-.3-.23-.61-.44-.91-.65-.1-.08-.21-.14-.32-.22l-.22-.15-.44-.28c-.59-.39-1.21-.77-1.82-1.12l-.09-.06c-.52-.3-1.05-.58-1.58-.85l-.48-.25-.37-.18h0c-1-.47-1.93-.9-2.92-1.29l-.45-.17-.64-.24c-.39-.15-.79-.28-1.19-.42l-.32-.11h0l-.58-.18h0a41.38,41.38,0,0,0-4.8-1.15l.92.25a.07.07,0,0,1,.06,0l1,.28h0l.58.18h0l.32.11c.4.13.8.26,1.19.41l.64.24.45.18c1,.39,2,.82,2.92,1.28h0l.37.18c.69.35,1.38.71,2.06,1.11l.09,0,.23.14c.69.4,1.37.82,2,1.27.07,0,.15.09.22.15l.32.21.63.45.5.36.45.34h0q.45.34.9.72c.39.31.78.63,1.15,1s1,.88,1.47,1.34.84.84,1.26,1.27.68.72,1,1.1l.49.57a39.37,39.37,0,0,1,3.86,5.37l.21.34c.06.1.12.2.17.3.35.59.68,1.18,1,1.79.18.34.35.68.52,1,.3.63.59,1.27.86,1.92.12.27.22.53.33.8v0c.13.33.26.66.38,1l.15.43c0,.12.09.23.12.35s.15.44.22.66c.27.8.5,1.61.7,2.41.12.47.23.93.33,1.39a2.3,2.3,0,0,1,.06.28c.17.78.32,1.56.44,2.34l.09.69a40.81,40.81,0,0,1,0,11.15.17.17,0,0,0,0,.07c-.08.54-.17,1.07-.26,1.6a41.84,41.84,0,0,1-1,4.29,40.29,40.29,0,0,1-1.48,4.16c-.35.83-.72,1.64-1.11,2.45h0a39.91,39.91,0,0,1-2.84,4.85h0a41.19,41.19,0,0,1-5.51,6.52h0c-.64.62-1.31,1.21-2,1.79q-.54.45-1.08.87c-.56.44-1.14.87-1.72,1.28a39.72,39.72,0,0,1-3.9,2.42,41.09,41.09,0,0,1-18.92,5c-.92,0-1.83,0-2.75,0-.73,0-1.46-.08-2.19-.16s-1.45-.17-2.17-.29c-.32,0-.63-.1-.95-.16.52.13,1,.25,1.54.35l.65.14.13,0,.22,0c.41.09.83.16,1.25.22a39.76,39.76,0,0,0,4.36.45c.92.05,1.83.06,2.75,0a41.24,41.24,0,0,0,22.82-7.44l.57-.41c.39-.28.77-.57,1.15-.87s.72-.58,1.08-.88a41,41,0,0,0,8.54-9.91,40.67,40.67,0,0,0,2.9-5.65c.32-.78.63-1.56.9-2.35a39.92,39.92,0,0,0,1.37-4.84c.09-.43.18-.87.26-1.3s.18-1.06.26-1.6c.12-.87.22-1.75.28-2.62h0a40.81,40.81,0,0,0-.66-11c0-.14,0-.28-.08-.43s-.07-.33-.11-.49-.1-.48-.16-.72L665,74l-.12-.48c-.1-.36-.2-.7-.3-1s-.17-.57-.27-.86-.22-.67-.34-1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M608,48h0a3.88,3.88,0,0,1-.69.41c-.46.23-1.13.61-2,1.11a41.9,41.9,0,0,0-6.72,5,40.25,40.25,0,0,0-12.78,24.44l-.13-.26h0l.14.09,0,.19c-.1,1-.21,1.94-.32,2.94s0,2-.08,3.05A36.3,36.3,0,0,0,586.73,94l.28,1.07.35,1,.71,2,.85,1.94.42,1c.16.3.32.61.49.91a42.83,42.83,0,0,0,8.72,11.5,44.86,44.86,0,0,0,7.86,5.82c1,.58,1.82,1,2.35,1.25s.82.45.82.46a4.45,4.45,0,0,1-.86-.36c-.55-.27-1.39-.61-2.41-1.17a41.7,41.7,0,0,1-16.93-17.27c-.17-.3-.33-.61-.5-.92s-.28-.64-.43-1l-.86-2c-.24-.68-.48-1.37-.73-2.06l-.36-1.06-.29-1.08a36.88,36.88,0,0,1-1.3-9.2c0-1,0-2.09.09-3.1s.22-2,.33-3l.12.27h0L585.3,79l0-.17a40.12,40.12,0,0,1,13.07-24.65,39.34,39.34,0,0,1,6.87-4.89c.87-.47,1.56-.83,2-1A7.71,7.71,0,0,1,608,48h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.46,
    cy: 64.42,
    r: 28.01,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.62,78.65a9.37,9.37,0,0,0-1.07,3.71A5.65,5.65,0,0,1,194,85.83c-1,.83-2.76.76-3.27-.43a10.12,10.12,0,0,1-.28-2.08,19.11,19.11,0,0,0-1.2-2.45,6.66,6.66,0,0,1-.28-2.32c-.08-4.27-1.05-8.74-3.87-11.91a2.77,2.77,0,0,0-1.24-.91,1.57,1.57,0,0,0-1.65.56,5.73,5.73,0,0,1-.64,1,1.43,1.43,0,0,1-2.07-.6,4.31,4.31,0,0,1-.26-2.47c.1-1,.2-2.08.29-3.12a2.72,2.72,0,0,1,.47-1.54c.51-.58,1.4-.6,2-1.05.81-.61.93-1.77,1.44-2.64s2.1-1.23,2.32-.24c1.71-3.62,5.34,1.83,7.54,1.45a6,6,0,0,1,1.9-.31c1.13.17,1.7,1.45,2.08,2.55.62,1.83,1.23,3.66,1.85,5.48a2.64,2.64,0,0,0,1.22,1.75c.51.21,1.11.06,1.63.26,1.37.53.9,2.73-.22,3.69s-2.68,1.56-3.22,3c-.41,1-.11,2.28-.55,3.31A11.91,11.91,0,0,1,196.62,78.65Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.06,86.35h0l.86.67.7.51.71.48.51.32a.91.91,0,0,1-.07-.14c-.6-1.39-.61-3.38.72-4a2.9,2.9,0,0,0,.76-.4c.6-.56.13-1.74.72-2.31.34-.31.86-.28,1.27-.47a2.13,2.13,0,0,0,.95-2.14,12.9,12.9,0,0,1-.2-2.48c.16-1.25,1.13-2.51.59-3.65s-2.4-1.09-3.66-1.67c-1.76-.81-2.28-3-3.42-4.64-1-1.43-3.41-3-5.26-2.6a2.26,2.26,0,0,0-2,2.09l-.17,0c-.49-.06-1.07-.1-1.34-.51s0-1.21-.31-1.69a2.47,2.47,0,0,0-.69-.54c-.24-.17-.44-.5-.29-.76s.43-.27.59-.47a.45.45,0,0,0,0-.56c-.5-.62-1.08.62-1.36.91a2.09,2.09,0,0,1-.23.21h0a.81.81,0,0,0,0,.16c0,.17,0,.34,0,.51s0,.35,0,.52v1a29.66,29.66,0,0,0,1.63,9.19,25.6,25.6,0,0,0,1.63,3.71c.27.53.56,1,.87,1.55s.88,1.31,1.31,1.9.82,1.07,1.27,1.6a27.66,27.66,0,0,0,2,2.08c.61.59,1.27,1.12,1.93,1.66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.77,54.82a7.76,7.76,0,0,1-.28-.9c-1.06-3.1-3.77-4.53-5.46-7-.55-.79-1-1.44-2-1.61-1.46-.24-2.21.6-3.24-.83-.27-.38-.76-.74-1.17-.52.1.3.21.61.31.92a.44.44,0,0,1,0,.2c0,.21-.33.26-.51.14a1.62,1.62,0,0,1-.38-.51,1.42,1.42,0,0,0-2.11-.2.82.82,0,0,0-.46-.68,1,1,0,0,1-1.22.78c-.08-.28.41-.32.58-.55s0-.53-.23-.72a3,3,0,0,0-1.92-.79,2.55,2.55,0,0,1-1.32-.17c-.23-.14-.38-.37-.61-.5a1.7,1.7,0,0,0-1.62.24,3.16,3.16,0,0,0-1.64,1.6c-.25.75.28,1.78,1,1.69a1.34,1.34,0,0,1,.59-.06.73.73,0,0,1,.42.7,2,2,0,0,0,.12.84c.13.26.53.39.69.15a1.57,1.57,0,0,0,.24-1.44,2,2,0,0,1,.12-1.48c.3-.41,1.15-.27,1.08.24,0,.29-.37.51-.36.81s.37.48.68.47a3,3,0,0,1,.9,0c.3.08.53.47.31.69-.37.42-1.32-.32-1.52.21a1.29,1.29,0,0,0,0,.44c0,.44-.59.6-1,.65a2.45,2.45,0,0,1-1.29-.11.85.85,0,0,1-.42-1.11.49.49,0,0,0-.69.25,1.51,1.51,0,0,0-.06.82c-.46-.11-.87.28-1.14.67s-.53.86-1,1-1.07-.06-1.32.35.57,1.24.26,1.78c-.19.3-.61.29-1,.38a1.49,1.49,0,0,0-.62,2.29,1.72,1.72,0,0,0,2.47,0,8.37,8.37,0,0,0,1-1.67c.33-.56.95-1.06,1.56-.87a1.88,1.88,0,0,1,.63.42l.89.77a.83.83,0,0,1,.37.62,2.09,2.09,0,0,1-.24.55c-.2.55.58,1.08,1.07.79a1.12,1.12,0,0,0,.22-1.54c-.45-.65-1.49-1-1.46-1.8.54-.43,1.38,0,1.68.68s.31,1.37.56,2,1,1.23,1.6.92c-.16-.56-.3-1.12-.46-1.68.4-.29.83.58,1.3.44.29-.08.33-.5.21-.78a3.84,3.84,0,0,1-.39-.82.93.93,0,0,1,1.07-.95,1.41,1.41,0,0,1,1,1.18,2.36,2.36,0,0,0,.14.65c.19.44.72.58,1.15.76s.89.64.7,1.08c-.08.2-.29.38-.22.58s.32.26.32.45-.13.21-.25.26c-.29.12-.61.15-.9.29a.82.82,0,0,0-.53.73c0,.45.56.67.8,1.05a5.12,5.12,0,0,1,.34,1.25,4.62,4.62,0,0,0,.66,1,11.29,11.29,0,0,1,1.23,3.57c.16.55.44,1.17,1,1.28A1.73,1.73,0,0,0,202,65a5.39,5.39,0,0,0,2.2-1.3,1.91,1.91,0,0,0,.2-2.38.46.46,0,0,0-.27-.17.81.81,0,0,0-.42.14,1.17,1.17,0,0,1-1.24-.29,3.41,3.41,0,0,1-.72-1.13c-.22-.45-.43-.91-.65-1.36a.75.75,0,0,1,.95.1,4.63,4.63,0,0,1,.64.82,4.13,4.13,0,0,0,2.79,1.37,2.67,2.67,0,0,1,.79.18c.78.38,1,1.56,1.82,1.82.23.08.49.07.71.17a1.33,1.33,0,0,1,.58.91,13.6,13.6,0,0,0,.5,2,1.82,1.82,0,0,0,1.48,1.24,1.32,1.32,0,0,0,1-.41l0-.08c0-.63.13-1.15.14-1.79,0-.13,0-.3,0-.43,0-.41,0-.8,0-1.21s-.08-.9-.11-1.31-.07-.58-.11-.9-.11-.69-.17-1c-.15-1-.58-2.82-.84-3.8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.84,79.9c-.46.06-1-.17-1.34.13a1.53,1.53,0,0,0-.33.73,1.53,1.53,0,0,1-.65.88,1,1,0,0,1-1.05,0,.74.74,0,0,1-.13-1,4.31,4.31,0,0,1,.4-.32c.6-.57.2-1.65.67-2.33.27-.4.7-.81,1-1.22s.32-.56.74-.64C203,75.76,203.76,79.65,201.84,79.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.06,43.23a6.3,6.3,0,0,0-1.3,1.46c-.44.49-1.21.83-1.71.41a1.17,1.17,0,0,1-.37-.84A2.22,2.22,0,0,1,175,43c.25-.4.62-.71.83-1.13s.18-1-.24-1.24c-.22-.11-.51-.07-.71-.22-.36-.28-.09-.92.33-1.08a3.36,3.36,0,0,1,1.34,0c1.62.13,2.83-.95,4.06-1.83,1-.69,3-1.5,4.09-.77a.88.88,0,0,1,.18,1.35c-.18.14-.44.17-.61.33s-.24.5-.37.76c-.31.66-1.2.9-1.5,1.58-.17.4-.1.91-.37,1.27a1.58,1.58,0,0,1-.92.45l-2.13.49A3,3,0,0,0,178.06,43.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.31,55.79a1.27,1.27,0,0,1,1.83.08,2,2,0,0,1,.13,1.46l-.33,2a1,1,0,0,0,0,.6c.19.43.87.36,1.14,0a1.87,1.87,0,0,0,.18-1.36,2.62,2.62,0,0,1,0-1.39c.46-1.07,2-.89,2.95-1.58a5,5,0,0,0,1.18-1.79c.35-.64.92-1.27,1.63-1.23.24,0,.48.11.72.1a1,1,0,0,0,.63-1.57c-.1-.11-.24-.19-.31-.33a.6.6,0,0,1,.23-.71,1.78,1.78,0,0,1,.75-.23l1.8-.27c.67-.1,1.52-.44,1.43-1.11s-.85-.86-.95-1.44a1.94,1.94,0,0,0-.07-.42c-.18-.38-.73-.23-1.08,0a.86.86,0,0,0-1.32-.44c-.36.29-.41.81-.54,1.26a6.05,6.05,0,0,1-2,2.65,1.64,1.64,0,0,1-.95.54c-.37,0-.75-.4-.58-.73s.44-.35.41-.6-.58-.3-.68-.61c.22-.89,1.23-1.25,2-1.72a5,5,0,0,0,2.07-2.53.7.7,0,0,0,0-.53c-.11-.22-.41-.26-.66-.27-.6,0-1.34.06-1.56.62a7.79,7.79,0,0,0-.12,1c-.22.94-1.48,1-2.26,1.58a9.4,9.4,0,0,1-.88.68,3.37,3.37,0,0,1-1.19.18l-.21,0q-.37.51-.72,1.05c-.23.35-.45.72-.67,1.08a29.22,29.22,0,0,0-2.5,5.51c-.22.67-.42,1.36-.6,2.05s-.32,1.4-.44,2.12a8.14,8.14,0,0,0,.52-1.8A3.32,3.32,0,0,1,158.31,55.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5,64.54c0-.19,0-.39,0-.58v-.14l0-.61c0-.19,0-.39,0-.57s0-.57-.08-.85c-.08-.71-.18-1.4-.32-2.09a2.93,2.93,0,0,0-.05-.29l-.06-.27c0-.24-.1-.49-.16-.73a26.18,26.18,0,0,0-1.29-4l-.39-.92c-.2-.44-.4-.87-.62-1.29s-.35-.66-.53-1-.44-.76-.68-1.13c-.09-.15-.18-.29-.28-.43h0l-.21-.32-.11-.15c-.14-.21-.29-.41-.44-.62a2.12,2.12,0,0,0-.15-.21.76.76,0,0,0-.11-.14,3,3,0,0,0-.22-.28c-.29-.39-.6-.77-.91-1.13l-.05-.06c-.26-.31-.54-.61-.81-.9l-.26-.27-.19-.2h0c-.51-.51-1-1-1.58-1.48l-.25-.21-.35-.3c-.22-.19-.45-.36-.67-.54a2.31,2.31,0,0,1-.19-.14h0l-.33-.25h0a27.68,27.68,0,0,0-2.82-1.82l.54.36,0,0,.56.4h0l.33.24h0l.18.15c.23.17.45.35.67.53l.36.3.24.21c.55.47,1.08,1,1.58,1.48h0l.2.2c.36.38.72.77,1.07,1.17l0,.06a.81.81,0,0,1,.12.14c.35.41.69.84,1,1.27l.11.15.15.21c.1.14.21.28.31.43l.23.33.22.32h0l.42.66c.18.29.35.58.52.88s.43.78.64,1.19.35.72.52,1.1.27.61.4.93l.18.47a26.37,26.37,0,0,1,1.27,4.31,2.56,2.56,0,0,1,.05.27c0,.08,0,.16.05.23.09.46.17.91.22,1.37,0,.26.08.52.1.78.06.47.1.94.12,1.42,0,.2,0,.39,0,.59v0c0,.24,0,.48,0,.73v.56c0,.15,0,.31,0,.47,0,.57,0,1.14-.09,1.7,0,.33-.06.65-.1,1l0,.19c-.07.54-.15,1.07-.25,1.6l-.09.46a27.69,27.69,0,0,1-2.53,7.14l0,0c-.17.33-.35.65-.53,1a27.68,27.68,0,0,1-1.62,2.52,28.41,28.41,0,0,1-1.89,2.34c-.41.45-.83.89-1.26,1.31h0a27.51,27.51,0,0,1-2.91,2.47h0a28.14,28.14,0,0,1-5,2.94h0c-.54.25-1.1.48-1.67.7-.3.11-.59.22-.89.31-.46.16-.92.31-1.39.44a27.51,27.51,0,0,1-3.05.66,26.71,26.71,0,0,1-4.5.37,27.9,27.9,0,0,1-8.76-1.4c-.59-.2-1.17-.41-1.75-.65s-.92-.39-1.37-.6-.89-.44-1.32-.67L169.2,88c.3.2.6.39.91.57l.38.24.08,0,.13.08.75.42a25.6,25.6,0,0,0,2.7,1.27c.57.24,1.16.45,1.75.65a28,28,0,0,0,16.3.36l.46-.13q.47-.14.93-.3c.3-.1.6-.2.89-.32a28.07,28.07,0,0,0,4.42-2.12,28.92,28.92,0,0,0,3.29-2.3,27.48,27.48,0,0,0,3.13-3c.38-.43.76-.86,1.11-1.31a26.9,26.9,0,0,0,2-2.79c.16-.26.32-.52.47-.78s.35-.64.52-1c.28-.53.54-1.07.77-1.62h0a27.94,27.94,0,0,0,2.06-7.19c0-.09,0-.19,0-.29s0-.23,0-.34l.06-.5c0-.16,0-.32,0-.49l0-.34c0-.24,0-.49,0-.73s0-.41,0-.61,0-.48,0-.73C212.51,64.75,212.51,64.65,212.5,64.54Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 647.02,
    cy: 414.09,
    r: 21.94,
    transform: "translate(-117.84 342.73) rotate(-27.29)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M645.14,392.17c.1.43.17.81.25,1.09a4.39,4.39,0,0,0-3,1.33c-.67.9-.55,2.15-.83,3.23a1.15,1.15,0,0,1-.53.82,1.32,1.32,0,0,1-.81,0c-1.59-.35-3.42-.87-4.71.13-.74.58-1.22,1.63-2.16,1.75s-1.7-.9-2-1.87A22,22,0,0,1,645.14,392.17Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M636.27,403.22a.28.28,0,0,1-.15,0c-2-1,.8-4.41,2.44-4.11a1.29,1.29,0,0,1,.73,2.08c-.66,1-2.06,1.1-2.86,2A.28.28,0,0,1,636.27,403.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M630.81,406.25c-.28.09-.56-.13-.74-.36a2.52,2.52,0,0,1-.09-2.84c1-1.45,3.7-1.6,4.06.43a1.62,1.62,0,0,1-1,1.78c-.38.13-.81.09-1.19.24a3.2,3.2,0,0,0-.8.58A.9.9,0,0,1,630.81,406.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M630.81,412.57c-.3,0-.59-.26-.87-.14s-.33.45-.58.48-.39-.24-.44-.46a2.88,2.88,0,0,1,.27-2.17.81.81,0,0,1,.25-.3,2,2,0,0,1,.89-.24,1.11,1.11,0,0,1,.92.69,2.54,2.54,0,0,1,.16,1.19C631.39,412,631.22,412.55,630.81,412.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M633.44,409.36c1.17-.92,3,.12,3.7,1.12.57.79,1,3.15-.72,2.93a2,2,0,0,1-1.41-.89,4,4,0,0,0-.64-1l-.08-.06c-.33-.24-.79-.3-1.07-.61A1,1,0,0,1,633.44,409.36Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M633.69,413a.63.63,0,0,1-.19.53.55.55,0,0,1-.43.1.86.86,0,0,1-.67-1,.87.87,0,0,1,.87-.58A1.41,1.41,0,0,1,633.69,413Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M633.5,412.1a.59.59,0,0,0-.23,0l-.08-.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M627.43,406.9a2,2,0,0,1,.18,1.48,8.32,8.32,0,0,1-.63,1.07c-.61,1.23.21,2.94-.7,4a2.2,2.2,0,0,1-1.17.63,21.92,21.92,0,0,1,1.58-8.19A3.19,3.19,0,0,1,627.43,406.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M626.64,422.07a22.64,22.64,0,0,1-1.42-5.85c1.13-1,2.14-1.86,3.87-1.58a2.32,2.32,0,0,1,2,1.75,3.47,3.47,0,0,1-.19,1.39c-.13.48-.27,1-.41,1.46a1.17,1.17,0,0,1-.25.54c-.43.45-1.18.05-1.8.12a1.62,1.62,0,0,0-1.12.77,9.19,9.19,0,0,0-.59,1.27A1.39,1.39,0,0,1,626.64,422.07Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M633.44,420.2a3.36,3.36,0,0,1-.09-.9,6.56,6.56,0,0,0-.39-1.21,1.26,1.26,0,0,1,.14-1.21.49.49,0,0,1,.35-.17.58.58,0,0,1,.37.19,6.86,6.86,0,0,1,1.44,2.08l-.21-.26a1.57,1.57,0,0,1,.28.86,1.21,1.21,0,0,1-.73,1.1A.94.94,0,0,1,633.44,420.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M656.34,399.56a1,1,0,0,0-.39-.23c-.43-.09-.75.4-1.17.54a1,1,0,0,1-1.16-.5c-1.18-1.92,1.64-3.24,3.18-2.46S658.76,401.37,656.34,399.56Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M653.71,410.29a9.52,9.52,0,0,1-.4-2.18,3,3,0,0,1,.28-1.73,3.18,3.18,0,0,1,2.64-1.2,4.21,4.21,0,0,1,2.53.44,8.35,8.35,0,0,1,1.26,1.12c.69.63,1.52,1.11,2.21,1.73a3.92,3.92,0,0,1,1.12,1.59,7.85,7.85,0,0,1,1.2,5,2.91,2.91,0,0,1-.89,2c-1.09.88-2.82.25-4,.95-1.06.62-1.47,2.13-2.65,2.5s-2.24-.59-3-1.51c-1.07-1.29-2.05-3-1.45-4.57.4-1,1.46-1.85,1.46-3A4.12,4.12,0,0,0,653.71,410.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M664.33,407.58c-.53-.34-1.06-.68-1.58-1a1.07,1.07,0,0,1-.4-.36.73.73,0,0,1,.43-1,1.23,1.23,0,0,1,1.16.29,3.64,3.64,0,0,1,.72,1l-.38-.45A1.43,1.43,0,0,1,664.33,407.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M666.37,411.54c-.09.32-.48.59-.77.41a.84.84,0,0,1-.3-.45l-.5-1.35a.68.68,0,0,1-.06-.44.43.43,0,0,1,.49-.25.92.92,0,0,1,.49.33,3.73,3.73,0,0,1,.62,1.59l-.11-.83A1.71,1.71,0,0,1,666.37,411.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M636.54,407.05a.6.6,0,0,1,.62-1A.6.6,0,0,1,636.54,407.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M638.54,403.57a.77.77,0,0,1-.79,1.31A.77.77,0,0,1,638.54,403.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M639,409.91a3.42,3.42,0,0,1,.34-4.22c.69-.7,1.81-1.05,2.48-.13a2.78,2.78,0,0,1-.2,2.93c-.39.75-.2,1.09,0,1.86a2.62,2.62,0,0,1,0,1.36,1.25,1.25,0,0,1-1.95.72C639.07,411.91,639.05,410.82,639,409.91Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M634.19,414.37a3.65,3.65,0,0,1,1.71.61l.18.11a1.31,1.31,0,0,1,.6,1.63,1.07,1.07,0,0,1-1.5.37,2.44,2.44,0,0,1-.58-.62,3.46,3.46,0,0,0-.79-.74C633.26,415.37,633.42,414.26,634.19,414.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M637.49,415.13a.72.72,0,0,1-.21-.38.52.52,0,0,1,.76-.56.62.62,0,0,1,.29.73A.5.5,0,0,1,637.49,415.13Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M650.16,413c-1-.33-1.13-1.49-1.25-2.4s-.36-2,.46-2.65a1.71,1.71,0,0,1,2.43.55,3.57,3.57,0,0,1,.43,2.76,1.43,1.43,0,0,1-.21.45,1.14,1.14,0,0,1-.06.25A1.48,1.48,0,0,1,650.16,413Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M649.85,415.48a.7.7,0,0,1-.05-.25v-.05a.82.82,0,0,1,.21-.81.69.69,0,0,1,1,0,1,1,0,0,1,0,1.44A.73.73,0,0,1,649.85,415.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M647.75,415.65c-.76-.08-1-.78-1.27-1.4a12.35,12.35,0,0,1-.74-2,1.47,1.47,0,0,1,.51-1.56,1,1,0,0,1,1.4.33,4.88,4.88,0,0,1,.47,1.89c0,.09,0,.18.07.27l0,0C649,413.86,649.25,415.83,647.75,415.65Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M668.77,410.85a4.31,4.31,0,0,1-2.4-2,5.26,5.26,0,0,1-.24-4.37,2.09,2.09,0,0,1,.17-1A21.86,21.86,0,0,1,668.77,410.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M660.24,424.1l-.13,0a2.52,2.52,0,0,1-2,.93.59.59,0,0,1-.89,0,1.37,1.37,0,0,1-.35-.95,1.59,1.59,0,0,1,.09-1.13c.31-.68.88-.9,1.45-1.29l0,0a7.89,7.89,0,0,0,.7-.85,3.25,3.25,0,0,1,.37-.52,1.32,1.32,0,0,1,1.78.2,1.63,1.63,0,0,1,.17.2c.3.08.38.46.39.79s.15.54.21.82l-.22-.56a3.7,3.7,0,0,1-.27,1.55A1.43,1.43,0,0,1,660.24,424.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M653.39,402.94a.87.87,0,0,1,.66,1.38,2.14,2.14,0,0,1-.66.53l-.19.11a1.18,1.18,0,0,0-.06.13,1.5,1.5,0,0,1-.44.64c-.46.38-1.35.14-1.29-.56a1.82,1.82,0,0,1,.51-1.12L652,404A1.48,1.48,0,0,1,653.39,402.94Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M655.33,429.11c.23-1.1,1.52-1.14,2.33-1.58s1-1.81,2.12-1.87a1.15,1.15,0,0,1,1.14,1.45,3.77,3.77,0,0,1-1.26,2.15,3.08,3.08,0,0,1-3.15,1.55A1.52,1.52,0,0,1,655.33,429.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M662.46,423.62a.61.61,0,0,1,1.11.17,2.76,2.76,0,0,1-.05,1.37c-.13.42-.48.94-1,.93l-.1,0a1.08,1.08,0,0,1-1.27-1.48,1.21,1.21,0,0,1,.57-.61C662,423.87,662.29,423.87,662.46,423.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M662.73,421.47A.51.51,0,0,1,663,421a.4.4,0,0,1,.48.08.5.5,0,0,1,.14.53.45.45,0,0,1-.5.32A.46.46,0,0,1,662.73,421.47Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M664.88,426.16c.79-1.54.55-2.71.25-4.31a4.25,4.25,0,0,1,.15-2.59c.62-1.38,2.09-1.91,3.51-2.2a21.67,21.67,0,0,1-2.93,8.28c-.32.53-.67,1-1,1.54A.91.91,0,0,1,664.88,426.16Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M667,416.28a.88.88,0,0,1-1.16-.35l0,0a.69.69,0,0,1-.17-.26.82.82,0,0,1,.36-1,2.09,2.09,0,0,1,.57-.26,5.46,5.46,0,0,1,2.43-.61c0,.71,0,1.43-.08,2.14A5,5,0,0,0,667,416.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M667.18,411.7a.49.49,0,0,1,.86,0,1.07,1.07,0,0,1,.07.19l0,.05a.6.6,0,0,1,0,.47.91.91,0,0,1-.16.4.8.8,0,0,1-.13.13.27.27,0,0,0-.07.08.44.44,0,0,1-.61,0,1,1,0,0,1-.31-.84A.84.84,0,0,1,667.18,411.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M664.77,418.49a.87.87,0,0,1-.52.3c-.36.69-1.21,1.27-1.79.64a.79.79,0,0,1,.2-1.16,6,6,0,0,1,1.48-.65A.54.54,0,0,1,664.77,418.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M630.43,407.18a1.23,1.23,0,0,1,1.24-.5,2.72,2.72,0,0,0,1.41-.21.62.62,0,0,1,.82.86,2.07,2.07,0,0,1-1.44,1,1.7,1.7,0,0,1-1.48-.21,2.09,2.09,0,0,1-.36-.19A.56.56,0,0,1,630.43,407.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M629.45,402.29a2.72,2.72,0,0,1-1.42.81l.22-.38a21.74,21.74,0,0,1,2.2-3,.19.19,0,0,1,0,.07A2.89,2.89,0,0,1,629.45,402.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M635.47,425.94c-.14-.78.69-1.34,1.35-1.52,1-.26,1.85,0,2.73-.59a3.83,3.83,0,0,1,2.29-1,1.44,1.44,0,0,1,1.32,1.11,1.77,1.77,0,0,1-.52,1.54,2.88,2.88,0,0,1-1,1.41,3.53,3.53,0,0,1-3.54.4C637,427.45,635.67,427.09,635.47,425.94Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M638.39,423.3a.84.84,0,0,1-.06-1,1,1,0,0,1,1.11-.46.61.61,0,0,1,.5.21c.51.54-.05,1.31-.66,1.43A1,1,0,0,1,638.39,423.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M643.34,427.13a.56.56,0,0,1-.4-.4,1.36,1.36,0,0,1,.39-1.21.58.58,0,0,1,.95.27.74.74,0,0,1,.14.87A.92.92,0,0,1,643.34,427.13Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M640.7,393.12a21.95,21.95,0,0,0,18.43,39.33,21.94,21.94,0,1,1-18.43-39.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M674.49,407.67a2.31,2.31,0,1,1-.14.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.08,402.52a1.23,1.23,0,1,1-.09,0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.75,410.62A38.53,38.53,0,1,0,468.65,377,38.53,38.53,0,0,0,425.75,410.62Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.29,427.37a8.38,8.38,0,1,0,9.33-7.31A8.39,8.39,0,0,0,455.29,427.37Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M455.29,427.37a8.38,8.38,0,1,0,9.33-7.31A8.39,8.39,0,0,0,455.29,427.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M454.37,427.34a8.12,8.12,0,0,0,7,9.28c4.58.56,8.51-3.05,9.07-7.64a7.84,7.84,0,0,0-7.05-8.93A8.1,8.1,0,0,0,454.37,427.34Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M455.82,377.15A38.6,38.6,0,0,0,435.53,400a4.77,4.77,0,0,1,1.28,3.56c-.23,1.61-2,2.08-2.67,2.19-.1.56-.19,1.12-.26,1.68a38.5,38.5,0,0,0-.08,8.51c.11.09,3.28,2.46,3.46,4.68a7.25,7.25,0,0,1-1.42,4.44c.24.65.48,1.3.75,1.94a38.75,38.75,0,0,0,9.59,13.56,6,6,0,0,1,4.71,0c2.23,1.13,1.49,4.39,1.49,4.39l-.28.09a38.41,38.41,0,0,0,27.77,4.83,38.52,38.52,0,1,1-24.05-72.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M435.66,408.08a.92.92,0,0,0,.81,1,.94.94,0,0,0,1-.81.92.92,0,0,0-.81-1A.94.94,0,0,0,435.66,408.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M478.09,432.45a13,13,0,0,1,2.35-4.8c.67-.94,1.62-1.94,2.77-1.79l1,.16a3.74,3.74,0,0,1,4.06,1,4.55,4.55,0,0,1,.89,3.88,8.79,8.79,0,0,1-1.83,3.66,16.89,16.89,0,0,1-3.32,3.22,4.3,4.3,0,0,1-2.34,1,3.27,3.27,0,0,1-2.48-1.23A6,6,0,0,1,478.09,432.45Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M478,432.43a13,13,0,0,1,2.35-4.8c.67-.94,1.62-1.94,2.77-1.79l1,.16a3.74,3.74,0,0,1,4.06,1,4.57,4.57,0,0,1,.89,3.88,8.79,8.79,0,0,1-1.83,3.66,16.61,16.61,0,0,1-3.32,3.22,4.3,4.3,0,0,1-2.34,1,3.26,3.26,0,0,1-2.48-1.23A6,6,0,0,1,478,432.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M477.18,432.34a13,13,0,0,1,2.35-4.8,4.3,4.3,0,0,1,2.77-1.79l1.51-.25a4.28,4.28,0,0,1,3.53,1.39,4.55,4.55,0,0,1,.89,3.88,8.69,8.69,0,0,1-1.83,3.65,16.94,16.94,0,0,1-3.32,3.23,3.7,3.7,0,0,1-2.2.85,2.89,2.89,0,0,1-2.21-1.34A5.68,5.68,0,0,1,477.18,432.34Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.42,446.07a11.7,11.7,0,0,1-4.13-.52c-.85-.23-1.8-.63-1.91-1.39l-.07-.65a2.16,2.16,0,0,1-.06-2.78,4.09,4.09,0,0,1,2.78-1.35,7.79,7.79,0,0,1,3.15.42,12.65,12.65,0,0,1,3.11,1.45,2.71,2.71,0,0,1,1.23,1.28,2,2,0,0,1-.45,1.82A5.33,5.33,0,0,1,466.42,446.07Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M466.58,446.09a11.7,11.7,0,0,1-4.13-.52c-.85-.23-1.8-.63-1.91-1.39l-.07-.65a2.16,2.16,0,0,1-.06-2.78,4.09,4.09,0,0,1,2.78-1.35,7.79,7.79,0,0,1,3.15.42,12.65,12.65,0,0,1,3.11,1.45,2.71,2.71,0,0,1,1.23,1.28,2,2,0,0,1-.45,1.82A5.33,5.33,0,0,1,466.58,446.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M465.61,446.26a11.7,11.7,0,0,1-4.13-.51,3.07,3.07,0,0,1-1.91-1.39l-.49-.91a2.5,2.5,0,0,1,.36-2.52,4.06,4.06,0,0,1,2.78-1.36,8.15,8.15,0,0,1,3.15.42,13.62,13.62,0,0,1,3.11,1.45,2.38,2.38,0,0,1,1.09,1.22c.21.6-.16,1.13-.58,1.68A4.91,4.91,0,0,1,465.61,446.26Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.1,391.29a13.23,13.23,0,0,1,4.39-3.05c1.05-.49,2.36-.91,3.29-.22l.78.62a3.71,3.71,0,0,1,3.07,2.83,4.6,4.6,0,0,1-1.1,3.82,8.8,8.8,0,0,1-3.38,2.31,16.8,16.8,0,0,1-4.47,1.2,4.27,4.27,0,0,1-2.53-.26,3.26,3.26,0,0,1-1.57-2.28A6,6,0,0,1,446.1,391.29Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M446.1,391.29a13.23,13.23,0,0,1,4.39-3.05c1.05-.49,2.36-.91,3.29-.22l.78.62a3.71,3.71,0,0,1,3.07,2.83,4.6,4.6,0,0,1-1.1,3.82,8.8,8.8,0,0,1-3.38,2.31,16.8,16.8,0,0,1-4.47,1.2,4.27,4.27,0,0,1-2.53-.26,3.26,3.26,0,0,1-1.57-2.28A6,6,0,0,1,446.1,391.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M444.67,391.7a13.09,13.09,0,0,1,4.38-3.05,4.36,4.36,0,0,1,3.29-.22l1.44.52a4.28,4.28,0,0,1,2.41,2.93,4.6,4.6,0,0,1-1.1,3.82,8.8,8.8,0,0,1-3.38,2.31,16.8,16.8,0,0,1-4.47,1.2,3.77,3.77,0,0,1-2.34-.32,2.93,2.93,0,0,1-1.28-2.25A5.65,5.65,0,0,1,444.67,391.7Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.63,419.25a1.88,1.88,0,0,1,.72-1,2.53,2.53,0,0,1,1.74-.21,1.83,1.83,0,0,1,1.22,1,2.65,2.65,0,0,1,.44,2,2.19,2.19,0,0,1-1.29,1.57,2.21,2.21,0,0,1-2.43-.72A2.8,2.8,0,0,1,482.63,419.25Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M482.5,419.23a1.94,1.94,0,0,1,.73-1A2.65,2.65,0,0,1,485,418a1.88,1.88,0,0,1,1.22,1,2.62,2.62,0,0,1,.43,2,2.14,2.14,0,0,1-1.28,1.56,2.19,2.19,0,0,1-2.43-.72A2.77,2.77,0,0,1,482.5,419.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M482.23,419.27a1.8,1.8,0,0,1,.67-1,2.31,2.31,0,0,1,1.6-.19,1.68,1.68,0,0,1,1.12.89,2.41,2.41,0,0,1,.4,1.84,2,2,0,0,1-1.18,1.44,2,2,0,0,1-2.23-.66A2.58,2.58,0,0,1,482.23,419.27Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M482.23,419.27a1.8,1.8,0,0,1,.67-1,2.31,2.31,0,0,1,1.6-.19,1.68,1.68,0,0,1,1.12.89,2.41,2.41,0,0,1,.4,1.84,2,2,0,0,1-1.18,1.44,2,2,0,0,1-2.23-.66A2.58,2.58,0,0,1,482.23,419.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M486.17,396.13a1.52,1.52,0,0,1,.58-.84,2.09,2.09,0,0,1,1.4-.17,1.49,1.49,0,0,1,1,.78,2.15,2.15,0,0,1,.35,1.61,1.74,1.74,0,0,1-1,1.26,1.78,1.78,0,0,1-2-.58A2.23,2.23,0,0,1,486.17,396.13Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M486.07,396.11a1.49,1.49,0,0,1,.58-.83,2,2,0,0,1,1.4-.17,1.49,1.49,0,0,1,1,.78,2.15,2.15,0,0,1,.35,1.61,1.66,1.66,0,0,1-3,.68A2.25,2.25,0,0,1,486.07,396.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M485.85,396.14a1.42,1.42,0,0,1,.54-.77,1.89,1.89,0,0,1,1.29-.15,1.36,1.36,0,0,1,.9.71,2,2,0,0,1,.32,1.49,1.53,1.53,0,0,1-2.75.62A2,2,0,0,1,485.85,396.14Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M485.85,396.14a1.42,1.42,0,0,1,.54-.77,1.89,1.89,0,0,1,1.29-.15,1.36,1.36,0,0,1,.9.71,2,2,0,0,1,.32,1.49,1.53,1.53,0,0,1-2.75.62A2,2,0,0,1,485.85,396.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M465.67,384.51a2,2,0,0,1,.77-1.09,2.66,2.66,0,0,1,1.83-.22,2,2,0,0,1,1.29,1,2.83,2.83,0,0,1,.45,2.11,2.27,2.27,0,0,1-1.35,1.65,2.31,2.31,0,0,1-2.56-.76A2.94,2.94,0,0,1,465.67,384.51Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M465.54,384.5a2,2,0,0,1,.77-1.1,2.72,2.72,0,0,1,1.83-.22,2,2,0,0,1,1.29,1,2.85,2.85,0,0,1,.45,2.12,2.25,2.25,0,0,1-1.35,1.64,2.31,2.31,0,0,1-2.56-.75A3,3,0,0,1,465.54,384.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M465.26,384.53a1.86,1.86,0,0,1,.7-1,2.57,2.57,0,0,1,1.69-.2,1.8,1.8,0,0,1,1.18.94,2.58,2.58,0,0,1,.42,1.94,2.11,2.11,0,0,1-1.24,1.52,2.14,2.14,0,0,1-2.36-.7A2.7,2.7,0,0,1,465.26,384.53Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M465.26,384.53a1.86,1.86,0,0,1,.7-1,2.57,2.57,0,0,1,1.69-.2,1.8,1.8,0,0,1,1.18.94,2.58,2.58,0,0,1,.42,1.94,2.11,2.11,0,0,1-1.24,1.52,2.14,2.14,0,0,1-2.36-.7A2.7,2.7,0,0,1,465.26,384.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M473.21,385.86a1,1,0,0,1,.39-.55,1.35,1.35,0,0,1,.91-.11,1,1,0,0,1,.65.51,1.43,1.43,0,0,1,.22,1.06,1.12,1.12,0,0,1-.67.82,1.16,1.16,0,0,1-1.28-.38A1.48,1.48,0,0,1,473.21,385.86Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M473.15,385.85a1,1,0,0,1,.38-.55,1.37,1.37,0,0,1,.92-.11,1,1,0,0,1,.64.51,1.43,1.43,0,0,1,.23,1.06,1.13,1.13,0,0,1-.68.82,1.15,1.15,0,0,1-1.28-.38A1.45,1.45,0,0,1,473.15,385.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M473,385.87a.91.91,0,0,1,.35-.51,1.26,1.26,0,0,1,.84-.1.91.91,0,0,1,.59.47,1.29,1.29,0,0,1,.21,1,1,1,0,0,1-.62.76,1.07,1.07,0,0,1-1.18-.35A1.34,1.34,0,0,1,473,385.87Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M473,385.87a.91.91,0,0,1,.35-.51,1.26,1.26,0,0,1,.84-.1.91.91,0,0,1,.59.47,1.29,1.29,0,0,1,.21,1,1,1,0,0,1-.62.76,1.07,1.07,0,0,1-1.18-.35A1.34,1.34,0,0,1,473,385.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M454.37,427.34a8.12,8.12,0,0,0,7,9.28c4.58.56,8.51-3.05,9.07-7.64a7.84,7.84,0,0,0-7.05-8.93A8.1,8.1,0,0,0,454.37,427.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M477.18,432.34a13,13,0,0,1,2.35-4.8,4.3,4.3,0,0,1,2.77-1.79l1.51-.25a4.28,4.28,0,0,1,3.53,1.39,4.55,4.55,0,0,1,.89,3.88,8.69,8.69,0,0,1-1.83,3.65,16.94,16.94,0,0,1-3.32,3.23,3.7,3.7,0,0,1-2.2.85,2.89,2.89,0,0,1-2.21-1.34A5.68,5.68,0,0,1,477.18,432.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M465.61,446.26a11.7,11.7,0,0,1-4.13-.51,3.07,3.07,0,0,1-1.91-1.39l-.49-.91a2.5,2.5,0,0,1,.36-2.52,4.06,4.06,0,0,1,2.78-1.36,8.15,8.15,0,0,1,3.15.42,13.62,13.62,0,0,1,3.11,1.45,2.38,2.38,0,0,1,1.09,1.22c.21.6-.16,1.13-.58,1.68A4.91,4.91,0,0,1,465.61,446.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M444.67,391.7a13.09,13.09,0,0,1,4.38-3.05,4.36,4.36,0,0,1,3.29-.22l1.44.52a4.28,4.28,0,0,1,2.41,2.93,4.6,4.6,0,0,1-1.1,3.82,8.8,8.8,0,0,1-3.38,2.31,16.8,16.8,0,0,1-4.47,1.2,3.77,3.77,0,0,1-2.34-.32,2.93,2.93,0,0,1-1.28-2.25A5.65,5.65,0,0,1,444.67,391.7Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.83,
    cy: 391.25,
    rx: 29.85,
    ry: 28.35,
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M72.86,366.69a19.2,19.2,0,0,0,6,5c.55.33,1-.42.75-.85-1.28-1.89-2.43-3.73-3.88-5.51-.4-.49-.78-1-1.19-1.56a30.72,30.72,0,0,0-3.11.91A24.67,24.67,0,0,0,72.86,366.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.94,371.65a44,44,0,0,0,14.13,11.67,51.15,51.15,0,0,0,18.09,5.61,43.47,43.47,0,0,0,8.43.24,26.23,26.23,0,0,0-.39-2.92,32,32,0,0,1-7.06,0,49.78,49.78,0,0,1-15.27-4A45.12,45.12,0,0,1,76.18,374c-2.34-2.19-5.41-5.23-6.8-8.51-.6.27-1.19.55-1.78.85A26.57,26.57,0,0,0,70.94,371.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93,370.52c2.58,1.58,8,3.58,11.58,2.31q-1-1.12-2.13-2.13a6,6,0,0,1-.63.08,13.67,13.67,0,0,1-6.38-1.46c-2.3-1-5.88-3.21-7.6-5.84q-.93-.18-1.86-.3C87,366.25,90.42,369,92.93,370.52Z",
    style: {
      fill: "#fff"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M65.93,380.92c5,5.48,11.35,9.4,18.12,12.62A53,53,0,0,0,103.77,399a41.83,41.83,0,0,0,6.8-.11,26.86,26.86,0,0,0,1.08-6.53,43.61,43.61,0,0,1-9.14-.27,54.58,54.58,0,0,1-16.39-5.26,54.84,54.84,0,0,1-14.87-10,42.46,42.46,0,0,1-5.5-6.79c-.42-.63-.8-1.28-1.17-1.92a30,30,0,0,0-4.74,4A38,38,0,0,0,65.93,380.92Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M61.92,400.78A97.82,97.82,0,0,1,52,392.85c0,.75.12,1.5.23,2.25,6.82,6.78,15.65,12.1,24.17,16.14a97.55,97.55,0,0,0,16.84,6.19c.56-.22,1.12-.46,1.67-.71a95.62,95.62,0,0,1-17.43-6.6A110.3,110.3,0,0,1,61.92,400.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91,374.63a26.76,26.76,0,0,0,12.11,4,22.61,22.61,0,0,0,5.27-.3,25.76,25.76,0,0,0-1.38-2.29,16.15,16.15,0,0,1-4.39.27,24.8,24.8,0,0,1-10.29-3.28c-4.48-2.5-8.94-5.88-11.7-10.13-.7,0-1.39.08-2.09.15C81.26,368,86.81,372.12,91,374.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,412.76a74.5,74.5,0,0,1-7.94-1.07A64.88,64.88,0,0,1,63.91,398c-4.06-3.21-8.64-6.78-11.58-11.09-.1.67-.19,1.33-.25,2,2.34,3.25,6,6,8.84,8.46a75.15,75.15,0,0,0,15.18,10.3,71.89,71.89,0,0,0,22.67,6.87l.22-.14C99.79,413.91,100.54,413.35,101.27,412.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,404.43a73.81,73.81,0,0,0,22.07,6.46c.84.1,1.67.18,2.51.25a28.11,28.11,0,0,0,6.27-8.95,46.71,46.71,0,0,1-8.6-.44A66.59,66.59,0,0,1,82,396a57.83,57.83,0,0,1-16.68-11.37,47.26,47.26,0,0,1-6.64-8.45c-.32-.52-.63-1.08-.94-1.63A27.57,27.57,0,0,0,53,384.08a46.37,46.37,0,0,0,5,6.16A67.39,67.39,0,0,0,78.51,404.43Z",
    style: {
      fill: "#fff"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99.77,380.36c-2.36-.75-4.76-.85-7.07-1.92s-4.47-2.83-7-3.46a1.16,1.16,0,0,0-1,2c2.06,1.84,5.34,3.09,7.92,4.21,2.09.9,4.93,1.58,7.09.57C100.26,381.53,100.52,380.6,99.77,380.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.72,411.79a7.61,7.61,0,0,0-1.63-.4c-.6-.07-.93.77-.33,1A5.71,5.71,0,0,1,68,413a5.64,5.64,0,0,0,1.32.54.46.46,0,0,0,.58-.65A2.36,2.36,0,0,0,68.72,411.79Z",
    style: {
      fill: "#fff"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1,416.44c-3.1-1.14-6.15-3.17-9.43-3.71-.74-.12-1.45.77-.91,1.37,2.31,2.61,6.34,3.88,9.61,5l.82.28a30.49,30.49,0,0,0,5.64-1.14C88.89,417.73,87,417.13,85.1,416.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.35,408.45c1,.24,1.27-.95.73-1.49-1.89-1.88-4.63-3-6.79-4.68-1.42-1.08-2.82-2.18-4.19-3.33a26.78,26.78,0,0,0,1.52,3.95C57.18,405.44,60.17,407.68,63.35,408.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,414.7a4.62,4.62,0,0,1-.87-.35,19.67,19.67,0,0,1-2.24-1.2,26,26,0,0,1-6.35-5.51,27.38,27.38,0,0,1-2.64-3.82,23.36,23.36,0,0,1-1.58-3.44c-.2-.5-.33-1-.46-1.38a10.36,10.36,0,0,1-.27-1.06A3.89,3.89,0,0,1,54,397c.08,0,.37,1.28,1.17,3.26a28.46,28.46,0,0,0,1.65,3.36,30.87,30.87,0,0,0,2.62,3.74,28.76,28.76,0,0,0,6.18,5.52C67.43,414.06,68.64,414.62,68.6,414.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,395.52c0,.15-.77.31-2.2.45l-1.19.11c-.44,0-.91,0-1.42,0a28.61,28.61,0,0,1-3.47-.13l-2-.19c-.7-.08-1.42-.23-2.16-.36a45.64,45.64,0,0,1-4.73-1.07,53.8,53.8,0,0,1-10.27-4.19,54.61,54.61,0,0,1-9.12-6.33A46.75,46.75,0,0,1,70,380.44c-.51-.56-1-1.07-1.47-1.62l-1.26-1.58a32,32,0,0,1-2-2.83c-.27-.43-.54-.82-.76-1.2l-.56-1.06c-.65-1.28-.95-2-.82-2.09s.67.52,1.53,1.64l.7.93c.26.34.57.68.89,1.07.65.76,1.32,1.67,2.19,2.56l1.33,1.45c.46.5,1,1,1.51,1.48,1,1.05,2.24,2,3.49,3.11a56.35,56.35,0,0,0,18.68,10.14c1.57.46,3.07.94,4.5,1.22.72.16,1.4.35,2.07.46l1.93.33c1.23.25,2.36.31,3.35.44.5.06,1,.13,1.38.16l1.17.08C109.24,395.24,110,395.38,110,395.52Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,417.2s.06-.05.18-.12l.57-.31,2.21-1.17h.05s-.09,0-.08.07l0-.06.35-.22h0a28.79,28.79,0,0,0,7.16-6.3l.13-.06s-.18.07-.16.13l0-.07A28,28,0,0,0,108.9,383l.18.15h-.14l0-.14a24.28,24.28,0,0,0-1.46-3.76A27.26,27.26,0,0,0,95.3,367a31.14,31.14,0,0,0-13.77-3.46A29.48,29.48,0,0,0,72,365c-1.09.37-1.92.68-2.47.93l-.63.26-.23.08a21.17,21.17,0,0,1,3.27-1.42,28.32,28.32,0,0,1,9.59-1.57,31,31,0,0,1,14,3.41,29,29,0,0,1,7,5,25.77,25.77,0,0,1,5.38,7.42,24.51,24.51,0,0,1,1.48,3.83l-.18-.16h0l.14,0,0,.13a28.19,28.19,0,0,1-5,26.41l0-.08c0,.07-.12.17-.17.14l.13-.06a28,28,0,0,1-7.3,6.26l0,0h0l-.36.21,0-.06s-.07.09-.09.07h0l-2.26,1.1-.59.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,377c.17-.3.36-.58.53-.87C43.21,370.78,36.13,369.27,34,370a.71.71,0,0,0-.34.19l0,.08c0,.09,0,.28,0,.36.48,1.49,5,7.78,42.93,26.28C99.41,408,117.7,413.8,124,414.49a.79.79,0,0,0,.69-1.33c-2.21-2.14-7.29-5.89-15.4-10.8-.12.23-.22.47-.34.69,6.66,4.07,10.5,7.09,10,8.09-1.08,2-19.41-4.86-40.94-15.34s-38.09-20.6-37-22.61C41.53,372.09,47.32,373.66,56,377Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.47,399.56c-.07.21-.16.4-.24.6,10.38,6.22,17.25,11.39,18.06,13.91a1.85,1.85,0,0,1-.61,2.13c-.66.53-2.69,2.14-18.43-3.15A291.39,291.39,0,0,1,75.44,399c-4.91-2.39-10.09-5-15.11-7.63-14.48-7.61-27.62-15.57-29-20.05a2.61,2.61,0,0,1,.16-2.14,2.84,2.84,0,0,1,1.75-1.39c3.82-1.25,14,2.09,24.64,6.41.09-.12.16-.24.25-.35-18-7.14-30.75-10.07-32.77-7.35-4.35,5.87,19,20.62,48.82,35.16s57,21.73,59.33,17.48C135,416.29,125.64,408.64,110.47,399.56Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,407.24c.17.17-1.81,0-1.86,0a20,20,0,0,1-2.17-.63c-1.93-.59-3.83-1.28-5.7-2-2.64-1.05-5.19-2.44-8-3.14a.26.26,0,0,0-.19.47c4.43,3.05,11,5.37,16.32,6.42.76.15,1.94.48,2.42-.35a.84.84,0,0,0-.44-1.27.35.35,0,0,0-.42.54Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M56,377c.17-.3.36-.58.53-.87C43.21,370.78,36.13,369.27,34,370a.71.71,0,0,0-.34.19l0,.08c0,.09,0,.28,0,.36.48,1.49,5,7.78,42.93,26.28C99.41,408,117.7,413.8,124,414.49a.79.79,0,0,0,.69-1.33c-2.21-2.14-7.29-5.89-15.4-10.8-.12.23-.22.47-.34.69,6.66,4.07,10.5,7.09,10,8.09-1.08,2-19.41-4.86-40.94-15.34s-38.09-20.6-37-22.61C41.53,372.09,47.32,373.66,56,377Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M112.47,407.24c.17.17-1.81,0-1.86,0a20,20,0,0,1-2.17-.63c-1.93-.59-3.83-1.28-5.7-2-2.64-1.05-5.19-2.44-8-3.14a.26.26,0,0,0-.19.47c4.43,3.05,11,5.37,16.32,6.42.76.15,1.94.48,2.42-.35a.84.84,0,0,0-.44-1.27.35.35,0,0,0-.42.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M110.47,399.56c-.07.21-.16.4-.24.6,10.38,6.22,17.25,11.39,18.06,13.91a1.85,1.85,0,0,1-.61,2.13c-.66.53-2.69,2.14-18.43-3.15A291.39,291.39,0,0,1,75.44,399c-4.91-2.39-10.09-5-15.11-7.63-14.48-7.61-27.62-15.57-29-20.05a2.61,2.61,0,0,1,.16-2.14,2.84,2.84,0,0,1,1.75-1.39c3.82-1.25,14,2.09,24.64,6.41.09-.12.16-.24.25-.35-18-7.14-30.75-10.07-32.77-7.35-4.35,5.87,19,20.62,48.82,35.16s57,21.73,59.33,17.48C135,416.29,125.64,408.64,110.47,399.56Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Numbers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.68,269h-4.81v6.21H365V269H346.25v-7.75L361.61,239h12.51l-13.65,20.53h4.92V254h11.48v5.53h4.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39,257.12c0-12,6.82-18.93,16.39-18.93s16.39,6.93,16.39,18.93-6.83,18.93-16.39,18.93S383.39,269.12,383.39,257.12Zm20.52,0c0-7-1.75-9.15-4.13-9.15s-4.14,2.17-4.14,9.15,1.76,9.15,4.14,9.15S403.91,264.1,403.91,257.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.28,269h-4.8v6.21H437.63V269H418.86v-7.75L434.22,239h12.51l-13.65,20.53H438V254h11.48v5.53h4.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-2--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.76,222.46v4.31H370.67v-17h13.77v4.31h-8.16v2h7.17v4.11h-7.17v2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.29,213.28v4.85a6.93,6.93,0,0,0-1.21-.1c-1.65,0-2.81.75-2.81,2.86v5.88H386.8V213.53H392V215A5.47,5.47,0,0,1,396.29,213.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.33,213.28v4.85a6.78,6.78,0,0,0-1.21-.1c-1.65,0-2.81.75-2.81,2.86v5.88h-5.47V213.53h5.21V215A5.43,5.43,0,0,1,407.33,213.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06,220.14c0-4,3.22-6.86,7.7-6.86s7.7,2.84,7.7,6.86-3.2,6.87-7.7,6.87S408.06,224.16,408.06,220.14Zm9.86,0c0-1.72-.95-2.59-2.16-2.59s-2.15.87-2.15,2.59.94,2.61,2.15,2.61S417.92,221.86,417.92,220.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.68,213.28v4.85a7,7,0,0,0-1.22-.1c-1.64,0-2.8.75-2.8,2.86v5.88h-5.48V213.53h5.21V215A5.47,5.47,0,0,1,434.68,213.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Satellite--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.75,456l-12.48-2.74a.51.51,0,0,0-.21,1L352.54,457a.51.51,0,0,0,.21-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.34,453.33l-12.48-2.75a.51.51,0,0,0-.21,1l12.48,2.75a.51.51,0,0,0,.21-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.28 465.42 372.23 452.01 352.26 447.62 349.38 460.69 349.33 461.03 369.28 465.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.9,
    y: 447.3,
    width: 11.77,
    height: 18.44,
    transform: "translate(-162.67 710.63) rotate(-77.57)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.77,
    y: 450.82,
    width: 0.86,
    height: 12.84,
    transform: "translate(626.34 979.74) rotate(-168.1)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.36,
    y: 446.87,
    width: 0.86,
    height: 19.29,
    transform: "translate(881.89 197.62) rotate(101.9)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.39,
    y: 449.48,
    width: 0.86,
    height: 12.84,
    transform: "translate(613.98 975.76) rotate(-168.1)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.34,448.21,336.82,451a.51.51,0,0,0,.21-1l-12.48-2.74a.5.5,0,0,0-.21,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,450.91l12.48,2.74a.51.51,0,0,0,.21-1L324,449.92a.51.51,0,0,0-.2,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.93 427.79 336.99 437.47 348.14 440.13 356.59 433.32 331.93 427.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.76,
    y: 429.26,
    width: 9.1,
    height: 0.94,
    transform: "translate(-143.67 684.86) rotate(-78.9)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,426.44a2.06,2.06,0,1,1,.62-2.84A2.06,2.06,0,0,1,346.45,426.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.99 437.47 336.62 439.16 333.53 441.14 329.46 459.65 331.08 462.18 330.78 463.52 342.85 466.16 343.19 464.63 345.65 463.05 349.56 444.49 347.76 441.62 348.11 440.12 336.99 437.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.81 438.82 304.86 452.23 324.83 456.62 327.7 443.55 327.75 443.2 307.81 438.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.42,
    y: 438.5,
    width: 11.77,
    height: 18.44,
    transform: "translate(-188.99 660.27) rotate(-77.57)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.45,
    y: 440.57,
    width: 0.86,
    height: 12.84,
    transform: "translate(98.91 -54.92) rotate(11.9)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.87,
    y: 438.08,
    width: 0.86,
    height: 19.29,
    transform: "translate(-187.01 664.94) rotate(-78.1)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.84,
    y: 441.92,
    width: 0.86,
    height: 12.84,
    transform: "translate(99.26 -56.18) rotate(11.89)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.49,444.7a79,79,0,0,1-8.07-1.48c-4.43-.94-8-1.79-8-1.9a80.31,80.31,0,0,1,8.07,1.49A80.82,80.82,0,0,1,349.49,444.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53,441.14a10.43,10.43,0,0,1-.21,1.37c-.19.95-.43,2.2-.73,3.71-.63,3.13-1.52,7.45-2.54,12.21-.09.41-.17.82-.25,1.2l-.17-.25c4.49.95,8.5,1.82,11.39,2.46l3.4.79a7.51,7.51,0,0,1,1.23.34,8.55,8.55,0,0,1-1.27-.19l-3.42-.66c-2.9-.57-6.92-1.39-11.41-2.33l-.21-.05.05-.2c.08-.38.16-.79.25-1.2,1-4.76,2-9.07,2.66-12.18l.86-3.68A8.58,8.58,0,0,1,333.53,441.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,464.76a43.27,43.27,0,0,1-6.09-1.07,46.63,46.63,0,0,1-6-1.47,44.31,44.31,0,0,1,6.09,1.06A48.15,48.15,0,0,1,343.16,464.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,441.62a40.12,40.12,0,0,1-5.68-1,37.74,37.74,0,0,1-5.59-1.39,41.41,41.41,0,0,1,5.68,1A38.9,38.9,0,0,1,347.76,441.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.25,440.05a40.63,40.63,0,0,1-5.67-1,41.06,41.06,0,0,1-5.58-1.39,37.79,37.79,0,0,1,5.67,1A38.23,38.23,0,0,1,348.25,440.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,459.3a31.51,31.51,0,0,1,4.23-3,34.53,34.53,0,0,1,4.45-2.61,31,31,0,0,1-4.22,3A31.66,31.66,0,0,1,358.38,459.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.42,458.29a9.41,9.41,0,0,1,2.25-1.78,9.56,9.56,0,0,1,2.49-1.43,10.31,10.31,0,0,1-2.25,1.78A10.52,10.52,0,0,1,355.42,458.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.63,451.08a102,102,0,0,1,11.68-5.59,49.31,49.31,0,0,1-5.75,3A49.5,49.5,0,0,1,311.63,451.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.38,450.31a21.21,21.21,0,0,1,3-1.61,21.9,21.9,0,0,1,3-1.53,10.18,10.18,0,0,1-2.81,1.9A10.33,10.33,0,0,1,309.38,450.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocks--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370,368.73s3.05,8.34-1.59,19.46-6.85,18.17-14,19-19.46.42-19.46.42l-.61-20.24Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M370,368.73s3.05,8.34-1.59,19.46-6.85,18.17-14,19-19.46.42-19.46.42l-.61-20.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M321.53,372.37s9.54,13.66,12.17,15.7l1.5,2c2.1-.81,24.12-7.51,25.23-9.35a4.39,4.39,0,0,0,.4-3.64l3.36,1.15,5.8-9.53-25,3s2.65-2.31,1.05-3.16S321.53,372.37,321.53,372.37Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,407.61a59,59,0,0,1-7.21-14.83c-3.22-9.45-6.24-20.41-6.24-20.41L335.2,390.1Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M360.43,380.75l1.1,11.46,2.66-13.95-3.36-1.15S361.37,379.4,360.43,380.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M609.18,151.92s1.75,4.79-.92,11.18-3.93,10.43-8,10.91a98.36,98.36,0,0,1-11.18.24l-.35-11.63Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M609.18,151.92s1.75,4.79-.92,11.18-3.93,10.43-8,10.91a98.36,98.36,0,0,1-11.18.24l-.35-11.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M581.35,154s5.47,7.85,7,9l.86,1.16c1.2-.46,13.85-4.31,14.49-5.37a2.51,2.51,0,0,0,.23-2.09l1.93.66,3.33-5.47-14.38,1.73-9.89-2Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.07,174.25a33.81,33.81,0,0,1-4.14-8.52c-1.85-5.42-3.58-11.72-3.58-11.72l7.85,10.18Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M603.69,158.82l.63,6.59,1.53-8-1.93-.66A3.08,3.08,0,0,1,603.69,158.82Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "250.58 177.89 255.9 169.63 268.13 177.87 279.57 173.09 267.43 181.36 258.29 183.19 250.58 177.89",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.9 156.86 250.58 164.31 250.58 177.89 255.9 169.63 255.9 156.86",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "255.9 156.86 250.58 164.31 250.58 177.89 255.9 169.63 255.9 156.86"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.55,154.2a69,69,0,0,0-6.65,2.66v12.77l12.23,8.24,11.44-4.79c.48-1.17,1.06-7,1.06-7Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.03 454.89 577.61 443.68 594.51 440.4 600 427.02 596.81 443.87 590.77 452.91 580.03 454.89",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.09 433.14 568.84 443.68 580.03 454.89 577.61 443.68 567.09 433.14",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "567.09 433.14 568.84 443.68 580.03 454.89 577.61 443.68 567.09 433.14"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M570.38,425.47a80.47,80.47,0,0,0-3.29,7.67l10.52,10.54,16.9-3.28L600,427c-.57-1.36-4.93-6.69-4.93-6.69Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.77 464.27 157.64 461.54 155.51 455.31 147.06 442.26 136.79 449.43 138.85 457.45 147.77 464.27",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.79 449.43 149.55 456.75 155.51 455.31 147.06 442.26 136.79 449.43",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.77 464.27 149.55 456.75 155.51 455.31 157.64 461.54 147.77 464.27",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M565,130.45l6.65-1.84a1,1,0,0,0,.71-1.33l-1.38-4a.91.91,0,0,0-.11-.22l-6.37-9.85a1,1,0,0,0-1.47-.28l-7.06,4.93a1,1,0,0,0-.41,1.11l1.44,5.62a1,1,0,0,0,.38.57l6.72,5.14A1,1,0,0,0,565,130.45Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.76,119.07l8.83,5.06a1.06,1.06,0,0,0,.76.11l3.12-.75a1,1,0,0,0,.63-1.58l-5.64-8.72a1,1,0,0,0-1.47-.28l-6.3,4.4A1,1,0,0,0,556.76,119.07Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.87,128.88l.93-3.93a1.06,1.06,0,0,1,.77-.77l3.41-.82a1.05,1.05,0,0,1,1.23.68l1.11,3.24a1,1,0,0,1-.71,1.33l-5.45,1.51A1,1,0,0,1,564.87,128.88Z",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "247.15 127.22 251.56 133.27 255.79 130.17 263.73 120.97 255.85 115.83 250.24 119.33 247.15 127.22",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.85 115.83 253.3 126.47 255.79 130.17 263.73 120.97 255.85 115.83",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.15 127.22 253.3 126.47 255.79 130.17 251.56 133.27 247.15 127.22",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "199.74 434.57 199.79 430.53 194.27 426.54 191.34 432.43 192.93 437.1 196.19 437.19 199.74 434.57",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.93 437.1 197.09 433.07 194.27 426.54 191.34 432.43 192.93 437.1",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.74 434.57 197.09 433.07 194.27 426.54 199.79 430.53 199.74 434.57",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "700.06 107.33 700.1 103.3 694.58 99.31 691.65 105.2 693.25 109.86 696.51 109.96 700.06 107.33",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "693.25 109.86 697.41 105.83 694.58 99.31 691.65 105.2 693.25 109.86",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "700.06 107.33 697.41 105.83 694.58 99.31 700.1 103.3 700.06 107.33",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "113.21 59.78 113.26 55.74 107.74 51.75 104.81 57.64 106.4 62.31 109.66 62.41 113.21 59.78",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.4 62.31 110.56 58.28 107.74 51.75 104.81 57.64 106.4 62.31",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "113.21 59.78 110.56 58.28 107.74 51.75 113.26 55.74 113.21 59.78",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.91,327l-12.38,1.73-.75,1.33s-4.89.76-5.32.91L342.05,338l8,1.05,7.9-6.57Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.05,338c.22.15,3.06,4.92,7.6,7.16a43.87,43.87,0,0,0,7.7,3l-10.26-10.67Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.18 327.71 356.83 330.4 350.3 330.92 349.47 334.45 347.09 337.56 357.35 348.23 361.91 341.29 361.91 326.98 358.18 327.71",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "350.3 330.92 343.46 330.95 342.05 338.03 347.09 337.56 349.47 334.45 350.3 330.92"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dog--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.67,270.74c4-5.38,6.54-15.72,5.31-22.28s-3.65-12.91-4.28-19.56c-.25-2.73.12-6.05,2.57-7.29,2-1,4.56,0,6,1.71a12.81,12.81,0,0,1,2.29,6.23,22.71,22.71,0,0,0,1.57,6.51c0-1.64,2-2.76,3.59-2.3a4.57,4.57,0,0,1,2.94,3.64c.32,1.61.9,2.72.88,4.62a55.9,55.9,0,0,1-3.68,17.57c-2.05,5-8,11.55-13.91,13.29",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.12,258.74a15.31,15.31,0,0,1-1.52-1.2A13,13,0,0,0,651,254.9a15.23,15.23,0,0,1-1.93.14,4.73,4.73,0,0,1,1.89-.51,11.55,11.55,0,0,1,8.88,2.72A4.92,4.92,0,0,1,661.12,258.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.29,245.09c0,.08-.81-.5-2.18-1.17a15.14,15.14,0,0,0-5.7-1.47,14.87,14.87,0,0,0-5.81.86c-1.43.52-2.25,1-2.29.95s.16-.18.52-.43a10.85,10.85,0,0,1,1.63-.87,13.47,13.47,0,0,1,6-1,13.68,13.68,0,0,1,5.84,1.66,9.9,9.9,0,0,1,1.53,1C664.14,244.9,664.32,245.06,664.29,245.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.85,231.44a20.79,20.79,0,0,0-5.48.25,20.46,20.46,0,0,0-5,2.17s.38-.52,1.23-1.1a11.24,11.24,0,0,1,7.68-1.77A4,4,0,0,1,655.85,231.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.29,302.89c-.82.51-7.2,7.66-16.44,6.6s-14.15-5-18-4.13-20.7,14.41-20.06,19.3,2.82,3.81,2.82,3.81,3.51,3.09,6.33.75c0,0,.45,1.86,3.35-.82s1.92-6.1,2.88-8,8.34-5.47,8.34-5.47,10.61,10.18,21.9,10S580,317.39,580,317.39Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.41,307.14c.36.21,2.76,7.35,6.67,10.27s6.19,4.11,4.9,6.77S642.21,341.7,641.45,345s1.84,9-3.27,9.59c0,0-1.49,3.56-4.15,2.28,0,0-1.55,2.06-2.88.82s-4.11-3.23-2.71-8.16,13.08-17.18,12.36-19.9-9.68-10-9.68-10Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "631.12 319.61 634.81 322.79 648.29 312.85 646.19 308.72 631.12 319.61"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M579,311l2.62,17-1.41,1.65s-12.67,2.22-16.52,5.28-17.37,16.51-11.91,21.9c0,0,6,7.27,10,2.28,0,0,4.37,1.2,4.71-2.86a10.3,10.3,0,0,0-1.29-6.4l5.35-7.05s32.71-1.76,34.36-5.52,1.58-18.95,1.58-18.95L608.23,303s-6.3-3.41-16.48-2A15.46,15.46,0,0,0,579,311Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.83,296.73c.52.32,10,11.35,17.16,12.79s27-5.43,31.37-3.65,8.72,7,11.3,10.86c1.74,2.59,2.61,4.94,6.37,4,0,0,3.09,4.51,6.42.37,0,0,3.39-1.65,2.2-4.94s-13.35-15.73-20.09-18.73-7,1.31-11.37-.22S671.87,283,666,280a39.7,39.7,0,0,0-14.48,1.79C643.53,284.24,637.83,296.73,637.83,296.73Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M564.62,308.52s1.75,10.48,7.41,15c0,0,2.58-.7,6.39-4.16L570.83,305A27.29,27.29,0,0,1,564.62,308.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M567.05,291.8c0,.87-1,22.95,13.56,29.64,12.92,5.93,40.56,1,40.56,1s9.09-1.07,15.23-5.12c9.61-6.34,12.3-12.29,12.3-12.29L667,280.78s-9.95-11.59-21.59-12.15-12.4,9.64-21.21,11.31-17.34,5.87-21.69.31l-4.34-5.57Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.64,330.58s9.89,6.1,9.54,11.05l4.27-.47a17.47,17.47,0,0,0-9.24-11.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.79,309a26.22,26.22,0,0,1,5,9.7c1,4.42.94,5.76.94,5.76a16.24,16.24,0,0,0,4.61.45,26.87,26.87,0,0,0-5.12-15.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.28,282.86a57.93,57.93,0,0,1-2.82,40.88l4.31-.33s12.43-22.2,2.18-41.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.51,309.38s-.3,0-.8-.17a16.34,16.34,0,0,1-2.08-.84,24.44,24.44,0,0,1-6-4.27,46.49,46.49,0,0,1-4.85-5.52,16.75,16.75,0,0,1-1.74-2.49,18.18,18.18,0,0,1,2,2.26,65.21,65.21,0,0,0,4.92,5.37,28.16,28.16,0,0,0,5.8,4.32C653.43,308.94,654.54,309.3,654.51,309.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.13,306.07a6.2,6.2,0,0,1-.63,1.08,13.42,13.42,0,0,1-.83,1.19c-.35.45-.73,1-1.21,1.51a32.91,32.91,0,0,1-3.55,3.57,41.1,41.1,0,0,1-5,3.64,42.19,42.19,0,0,1-5.49,2.82,37.35,37.35,0,0,1-4.76,1.62c-.68.21-1.32.33-1.88.45s-1,.2-1.43.25a6.25,6.25,0,0,1-1.24.12c0-.1,1.74-.36,4.45-1.17a42.1,42.1,0,0,0,4.68-1.71,46.09,46.09,0,0,0,5.39-2.82,44.86,44.86,0,0,0,4.93-3.56,37.72,37.72,0,0,0,3.58-3.45C647.09,307.51,648,306,648.13,306.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.13,301.73s-.45-.05-1.24,0a6.5,6.5,0,0,0-3.08,1.1c-2.43,1.51-4.24,5.26-5.11,9.46a42,42,0,0,0-.53,11.08c.11,1.42.25,2.57.34,3.36a5.75,5.75,0,0,1,.11,1.24,5.5,5.5,0,0,1-.31-1.2c-.15-.79-.35-1.94-.5-3.37a38,38,0,0,1,.38-11.21,22.23,22.23,0,0,1,2-5.86,9.71,9.71,0,0,1,3.37-3.81,6.31,6.31,0,0,1,3.28-1,4.09,4.09,0,0,1,.93.1C591,301.68,591.13,301.71,591.13,301.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606,328.42a21.48,21.48,0,0,1,.07-3.09c.08-1.9.22-4.53.08-7.42a29.87,29.87,0,0,0-1.2-7.27c-.56-1.81-1.09-2.86-1-2.91a2.94,2.94,0,0,1,.45.71,15.59,15.59,0,0,1,.91,2.08,22.4,22.4,0,0,1,.89,3.26,32.75,32.75,0,0,1,.48,4.1,52.47,52.47,0,0,1-.23,7.47A16.83,16.83,0,0,1,606,328.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.53,320.76a3.37,3.37,0,0,1-.84-.51,18.13,18.13,0,0,1-2.06-1.69,24.75,24.75,0,0,1-2.68-2.92,28.14,28.14,0,0,1-2.59-4.11,27.5,27.5,0,0,1-1.77-4.52,25.53,25.53,0,0,1-.77-3.89,18.43,18.43,0,0,1-.13-2.66,3.4,3.4,0,0,1,.08-1c.1,0,.08,1.39.42,3.59a28.74,28.74,0,0,0,.86,3.8,30.49,30.49,0,0,0,1.78,4.42,29.86,29.86,0,0,0,2.51,4.05,27,27,0,0,0,2.54,2.95C577.46,319.87,578.58,320.68,578.53,320.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.53,273.46c0,.06-1-.78-2.91-1.74a23.4,23.4,0,0,0-7.71-2.5,21.58,21.58,0,0,0-8.06.63,32,32,0,0,0-3.15,1.23s.24-.24.75-.54a11.8,11.8,0,0,1,2.29-1.05,20.14,20.14,0,0,1,8.23-.79,21.39,21.39,0,0,1,7.83,2.7,14.6,14.6,0,0,1,2.07,1.41C658.33,273.19,658.56,273.43,658.53,273.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.92,297.43a9.51,9.51,0,0,1-.83,7.73c-.15-.06.5-1.7.72-3.83S679.77,297.46,679.92,297.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,297.65a7.58,7.58,0,0,1,.74,3.93,7.44,7.44,0,0,1-.91,3.9c-.15,0,.35-1.75.39-3.91S685.59,297.69,685.74,297.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.25,332a12.9,12.9,0,0,0-3.25-1.4,13.06,13.06,0,0,0-3.54,0c0-.06.33-.29,1-.46a6,6,0,0,1,5.07,1C647.05,331.55,647.29,331.9,647.25,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656,320.1a9.91,9.91,0,0,1-1.91,1.71,40.27,40.27,0,0,1-10.83,5.94,10.43,10.43,0,0,1-2.46.7,16.91,16.91,0,0,1,2.33-1,61.13,61.13,0,0,0,5.52-2.67,59.73,59.73,0,0,0,5.22-3.23A16,16,0,0,1,656,320.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.1,344.51a42.05,42.05,0,0,0-3.13-4.27c-2-2.18-3.86-3.63-3.76-3.76a13.81,13.81,0,0,1,4.15,3.41A10.61,10.61,0,0,1,569.1,344.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.17,342.63a53.58,53.58,0,0,0-1.55-5.24c-1.14-2.78-2.73-4.7-2.59-4.8a11.78,11.78,0,0,1,3.07,4.6A11.66,11.66,0,0,1,572.17,342.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.54,305.44a12,12,0,0,1,2.89,4.46,12.21,12.21,0,0,1,1.16,5.2c-.16,0-.52-2.33-1.64-5S538.41,305.54,538.54,305.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.18,306.92a10.26,10.26,0,0,1-.65,9.05,37.3,37.3,0,0,0,.86-4.49A37.84,37.84,0,0,0,545.18,306.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.15,284.41a2.18,2.18,0,0,1-.3.39,9.64,9.64,0,0,1-1,1,17.79,17.79,0,0,1-4.22,3,25.11,25.11,0,0,1-7.31,2.37,34.67,34.67,0,0,1-9.4.27,23.31,23.31,0,0,1-9-2.77,16.24,16.24,0,0,1-5.61-5.24,13.24,13.24,0,0,1-2-4.8,9.28,9.28,0,0,1-.15-1.4,1.68,1.68,0,0,1,0-.49c.06,0,.07.67.34,1.85a13.92,13.92,0,0,0,2,4.64,16.4,16.4,0,0,0,5.55,5,23.34,23.34,0,0,0,8.81,2.67,35.4,35.4,0,0,0,9.26-.22,25.72,25.72,0,0,0,7.22-2.23A22.28,22.28,0,0,0,670.15,284.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.05,300.53a10.8,10.8,0,0,1-1.13,1.14,17.57,17.57,0,0,1-1.4,1.26c-.57.47-1.2,1-2,1.56s-1.56,1.15-2.49,1.73-1.93,1.17-3,1.78a50,50,0,0,1-7.31,3.18,50.58,50.58,0,0,1-7.75,1.89c-1.22.16-2.37.33-3.47.39s-2.1.12-3,.13-1.77,0-2.5-.06a17.27,17.27,0,0,1-1.88-.15,9.45,9.45,0,0,1-1.59-.23,9.28,9.28,0,0,1,1.6,0c.52,0,1.14.07,1.88.06s1.56,0,2.48,0,1.92-.07,3-.19,2.22-.26,3.42-.44a53.08,53.08,0,0,0,7.66-1.9,53.72,53.72,0,0,0,7.25-3.12c1.06-.59,2.08-1.12,3-1.72s1.75-1.13,2.5-1.66,1.41-1,2-1.48,1.07-.85,1.46-1.19A9.05,9.05,0,0,1,643.05,300.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.65,
    cy: 254.56,
    rx: 41.64,
    ry: 38.64,
    transform: "translate(-17.79 44.21) rotate(-4.38)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.17,263s0-.22.1-.64.19-1.07.34-1.88c.08-.41.16-.87.26-1.38s.08-1.08.13-1.69.1-1.27.16-2,0-1.46,0-2.26a37.78,37.78,0,0,0-.52-5.26,40.34,40.34,0,0,0-1.69-6,38,38,0,0,0-8.08-12.89l-.73-.79c-.25-.25-.53-.49-.8-.73L596.66,226a20.06,20.06,0,0,0-1.77-1.39c-.62-.44-1.23-.9-1.86-1.36a43.66,43.66,0,0,0-8.62-4.31c-.78-.27-1.57-.58-2.37-.84l-2.49-.64-1.26-.32c-.42-.1-.86-.14-1.29-.22l-2.61-.41a44.56,44.56,0,0,0-10.94.08,48.14,48.14,0,0,0-5.59,1.05l-2.76.86a21.06,21.06,0,0,0-2.74,1L551,220l-.68.29-.66.35L547,222.07a44.75,44.75,0,0,0-5,3.44,38.81,38.81,0,0,0-13.63,20.7A35.84,35.84,0,0,0,531,270.78a37.86,37.86,0,0,0,6.89,9.77c.65.73,1.43,1.33,2.13,2l1.08,1,1.16.86c.78.56,1.51,1.18,2.32,1.68l2.43,1.45a41.44,41.44,0,0,0,10.15,4A46.37,46.37,0,0,0,567.39,293a44.92,44.92,0,0,0,18.1-3.52,42,42,0,0,0,12.77-8.33,37.13,37.13,0,0,0,7.12-9.08c.38-.7.78-1.33,1.08-2s.55-1.25.79-1.81l.68-1.56.43-1.34c.26-.78.45-1.38.59-1.81s.22-.62.22-.62,0,.22-.17.63-.3,1-.54,1.84c-.12.4-.26.85-.4,1.35s-.43,1-.66,1.57l-.78,1.83c-.29.64-.69,1.29-1.07,2a37,37,0,0,1-7.09,9.19,42.16,42.16,0,0,1-12.82,8.46,45.26,45.26,0,0,1-18.26,3.61A46.62,46.62,0,0,1,557.06,292a42,42,0,0,1-10.28-4.06l-2.46-1.47c-.81-.5-1.56-1.12-2.35-1.69l-1.17-.87-1.1-1c-.71-.68-1.5-1.28-2.16-2a38.42,38.42,0,0,1-7-9.89,36.33,36.33,0,0,1-2.67-24.93,39.28,39.28,0,0,1,13.83-21,45.3,45.3,0,0,1,5-3.48l2.67-1.4.67-.35.69-.29,1.38-.58a23.05,23.05,0,0,1,2.77-1l2.8-.86a47.11,47.11,0,0,1,5.65-1.06,44.94,44.94,0,0,1,11.05-.06l2.64.43c.44.07.88.12,1.3.22l1.27.33,2.51.65c.82.26,1.61.58,2.4.86a43.65,43.65,0,0,1,8.69,4.38l1.87,1.38a17.85,17.85,0,0,1,1.79,1.4l1.65,1.5c.27.24.55.48.81.73l.72.81a37.79,37.79,0,0,1,8.09,13,38.45,38.45,0,0,1,1.66,6.11,36.28,36.28,0,0,1,.48,5.3c0,.8,0,1.55,0,2.26s-.12,1.37-.18,2-.11,1.18-.15,1.7-.2,1-.29,1.38l-.39,1.87C609.23,262.75,609.17,263,609.17,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.85,277.49l-10.18,8.26s-14.5,4.83-14.87,4.24-6.21-9.63-10.28-9.49c-7.15.25-7.44.84-12.6.07-8.74-1.31-10.77-11-10.59-12.6s7.3-3.53,10.35-4.73,4.31-1.58,8.71-10.22a14.77,14.77,0,0,1,13.07-8.12s8.16-23.54,11.89-20.39,3.85,23.91,3.85,23.91l4.15,3.66a10.46,10.46,0,0,0,3.09,3.77c2.1,1.54,4.94,2.14,3.72,2.93s-3.69,2.09-3.69,2.09l3.67.72-2.39,3.73,3.22-.24-2.22,4.21,4.37,5.25Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.85,295.88a49.48,49.48,0,0,0,35.31-11.27,48.54,48.54,0,0,0,7.46-7.77,4.07,4.07,0,0,0-.43-5.62c-1.62-1.27-4.29-1.35-5.63.43-.86,1.14-1.76,2.24-2.73,3.29-.45.48-.91,1-1.38,1.43l-.77.74-.33.31c-.41.4.51-.44.08-.07a48.49,48.49,0,0,1-6.9,5c-.57.34-1.15.67-1.73,1l-.41.21c-.41.22.22-.1.24-.12a4.89,4.89,0,0,1-1.1.54c-1.29.6-2.61,1.15-3.95,1.64s-2.71.91-4.09,1.27l-.89.22c-.15,0-1.24.26-.67.15l-.52.1-1.21.21a45.89,45.89,0,0,1-4.7.48c-.81,0-1.63.05-2.44.05-.36,0-.72,0-1.07,0l-.61,0c-.59,0,1,.06,0,0-2.07-.15-4.34.85-4.68,3.15-.29,1.93.93,4.52,3.15,4.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.56,229.11c-1.56,1.82-4.13,7.4-2.5,14.78s7.53,14.71,7.53,14.71l11.3-9Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.13,265.32s-6.55.68-4.46,5.08l2,3.19s3.51-2.56,3.69-5.66c.16-2.73-1.18-2.61-1.18-2.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.46,244.9a28.61,28.61,0,0,0-4,.9,18.41,18.41,0,0,0-4,1.92,13.93,13.93,0,0,0-3.85,3.68,51.19,51.19,0,0,0-2.64,4.75,23.84,23.84,0,0,1-2.42,3.78,8.55,8.55,0,0,1-2.26,2,3,3,0,0,1-1,.42,9.53,9.53,0,0,0,3-2.68,27,27,0,0,0,2.29-3.78,44.23,44.23,0,0,1,2.63-4.81,13.67,13.67,0,0,1,4-3.79,17.3,17.3,0,0,1,4.1-1.87,13.69,13.69,0,0,1,3-.56A3.69,3.69,0,0,1,570.46,244.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.42,230.13a29.27,29.27,0,0,0-4.85,15.57,6.49,6.49,0,0,1,2.21-3c.26,1.42.53,2.83.79,4.24a4.64,4.64,0,0,1,1.89-3,9.75,9.75,0,0,1,1.67,3.11,30.34,30.34,0,0,0-1.91-16.63",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.72,258.16c-1.06.32-1.53,2.2-1.05,3.2a2.13,2.13,0,0,0,2.83.89,2.25,2.25,0,0,0,.89-2.88,2.42,2.42,0,0,0-2.82-1.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.19,255.29c-.31.66-1.32.86-2.36,1s-2.07,0-2.47-.59c-.18-.31-.09-.75.32-1.17a3,3,0,0,1,2-.84,3.13,3.13,0,0,1,2.06.53C568.16,254.54,568.32,255,568.19,255.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.21,269.75s0,.11,0,.31a4.81,4.81,0,0,1,0,.87,7,7,0,0,1-1.1,3,12.31,12.31,0,0,1-3.34,3.41,24.87,24.87,0,0,1-2.38,1.51,10.65,10.65,0,0,1-2.88,1.05,10.06,10.06,0,0,1-5.84-.34,8.06,8.06,0,0,1-3.45-3.33,19.22,19.22,0,0,1-1.41-2.87,4.77,4.77,0,0,1-.37-1.12c.1,0,.67,1.54,2.09,3.8a7.84,7.84,0,0,0,3.32,3.07,9.83,9.83,0,0,0,5.55.28,13.61,13.61,0,0,0,5.09-2.44,12.43,12.43,0,0,0,3.31-3.22A7.4,7.4,0,0,0,560,270.9,9.71,9.71,0,0,1,560.21,269.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.42,236.24c-4-8.7-16.71-16.79-23.74-15.25-3.56.57-3.59,3.75-2.61,5.64a7.88,7.88,0,0,0,5.11,3.54c2.05.56,4.21.69,6.26,1.27a15.16,15.16,0,0,1,8.48,6.18,15.46,15.46,0,0,0,2.36,3.28,3.2,3.2,0,0,0,3.71.64C600.63,240.49,600.22,238,599.42,236.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.72,246.21a2.22,2.22,0,1,0,.68-.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.52,197.9a5.67,5.67,0,0,1,3-.5c.09,0,.8.09.34,0a8.2,8.2,0,0,1,.86.18q.44.12.84.27c.66.23-.27-.2.33.15a6.45,6.45,0,0,1,2.16,1.72,6,6,0,0,1,1.14,2.45c.06.24.11.48.15.73-.08-.48,0,.46,0,.56s0,.49,0,.73-.09.75,0,.31a7.14,7.14,0,0,1-.46,1.64c.18-.43-.1.19-.15.27-.15.29-.33.55-.49.82s.17-.14-.2.26c-.16.18-.31.36-.48.53a8.67,8.67,0,0,1-.72.64c.35-.28-.25.17-.27.18q-.35.22-.72.42c-.09.05-.81.35-.38.2a10.18,10.18,0,0,1-1.62.43,2.5,2.5,0,1,0,1.33,4.82,11.26,11.26,0,0,0,2.06-21.54,11.23,11.23,0,0,0-8.09-.11,2.58,2.58,0,0,0-1.75,3.08,2.52,2.52,0,0,0,3.08,1.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.49,382.51l22.85,22.69,4,23.13A9.14,9.14,0,0,0,225.87,435a4.18,4.18,0,0,0,1.07-.35h0c1-.53,2.84-3.62,3-4.72,1.92-12.38,5-28.77,1.83-32.65-1.81-2.2-20.47-29.82-20.47-29.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.7,389a2,2,0,0,1,.4.31c.24.21.6.52,1.05.94.89.84,2.2,2.05,3.66,3.69a25,25,0,0,1,4.29,6.44,16.38,16.38,0,0,1,1.24,4.42,37.72,37.72,0,0,1,.25,4.91c-.07,3.34.43,6.48.36,9.42a11.6,11.6,0,0,1-2.36,7.32,6.65,6.65,0,0,1-4.6,2.36,4.8,4.8,0,0,1-1.42-.14c-.31-.09-.47-.16-.46-.18a7.77,7.77,0,0,0,1.87.12,6.56,6.56,0,0,0,4.33-2.4,11.32,11.32,0,0,0,2.16-7.09c.05-2.86-.47-6-.4-9.41a40.06,40.06,0,0,0-.23-4.84,16.31,16.31,0,0,0-1.18-4.3,24.94,24.94,0,0,0-4.13-6.38c-1.41-1.67-2.67-2.92-3.52-3.79A15.32,15.32,0,0,1,213.7,389Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.09,402.22c0,.16-2.1.41-4.57,1.22s-4.32,1.84-4.4,1.7a14.66,14.66,0,0,1,9-2.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,409.8c0,.16-1.85,0-4.06.43s-3.9,1.08-4,.94a11.07,11.07,0,0,1,8-1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,417.06c0,.15-1.84-.28-4.08-.27s-4,.41-4.08.26a11,11,0,0,1,8.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.71,433.09a8.9,8.9,0,0,0,1.65,0,6.76,6.76,0,0,0,3.89-2,12.72,12.72,0,0,0,2.95-5.85c.62-2.45,1.18-5.18,1.65-8.07a98.83,98.83,0,0,0,1.23-14.9c0-1.91,0-3.46,0-4.54a9,9,0,0,1,0-1.67,12.27,12.27,0,0,1,.2,1.66c.08,1.08.19,2.63.21,4.55a87.16,87.16,0,0,1-1.08,15c-.48,2.9-1.05,5.63-1.71,8.1a12.73,12.73,0,0,1-3.15,6,6.73,6.73,0,0,1-4.14,1.92,4.74,4.74,0,0,1-1.25-.09A1.23,1.23,0,0,1,218.71,433.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.78,399.39a15.85,15.85,0,0,1-1.44-2.05c-.86-1.29-2.07-3-3.5-4.92s-2.81-3.49-3.83-4.66a14.28,14.28,0,0,1-1.61-1.93,10.72,10.72,0,0,1,1.88,1.68,51.31,51.31,0,0,1,4,4.6,49.49,49.49,0,0,1,3.39,5A10.53,10.53,0,0,1,229.78,399.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,333.76l6.86,31.62,17.41,15.9a9.18,9.18,0,0,1-.07,12.5,3.76,3.76,0,0,1-.87.71h0c-1,.54-4.6.45-5.63,0-11.52-5.07-27.06-11.32-28.62-16.1-.89-2.73-14.18-33.46-14.18-33.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.67,358.64a1.71,1.71,0,0,1,.15.48l.32,1.38c.29,1.19.66,2.93,1.31,5a25.64,25.64,0,0,0,3.16,7,16.7,16.7,0,0,0,3,3.32,40,40,0,0,0,4,2.81c2.89,1.76,5.31,3.92,7.75,5.43a11.43,11.43,0,0,0,7.18,2,6.63,6.63,0,0,0,4.37-2.38,8,8,0,0,0,.91-1.64,1.44,1.44,0,0,1-.1.49,5.07,5.07,0,0,1-.65,1.27,6.63,6.63,0,0,1-4.48,2.62,11.63,11.63,0,0,1-7.48-2c-2.52-1.53-4.91-3.66-7.78-5.4a37.44,37.44,0,0,1-4-2.86,16,16,0,0,1-3.08-3.45,25,25,0,0,1-3.13-7.11c-.6-2.12-.92-3.88-1.15-5.09-.1-.61-.18-1.08-.23-1.4A1.89,1.89,0,0,1,254.67,358.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,371.18a11.19,11.19,0,0,1,3.17-3.61,11.31,11.31,0,0,1,4.16-2.41c.07.14-1.82,1.14-3.83,2.81S262.51,371.27,262.38,371.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.91,375.09a11.07,11.07,0,0,1,5.5-6c.09.13-1.44,1.18-2.94,2.85S269.05,375.17,268.91,375.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,380.78a11,11,0,0,1,4.4-6.91c.1.12-1.23,1.41-2.43,3.31S274.09,380.83,273.94,380.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.26,386.7s0,.15-.1.43a4.91,4.91,0,0,1-.61,1.1,6.69,6.69,0,0,1-3.85,2.46,12.68,12.68,0,0,1-6.78-.56c-2.44-.78-5.07-1.78-7.78-2.94A86.72,86.72,0,0,1,256.87,380c-1.62-1.06-2.88-2-3.74-2.63a11.14,11.14,0,0,1-1.3-1.07,9.7,9.7,0,0,1,1.42.9c.89.6,2.18,1.48,3.82,2.49a100.24,100.24,0,0,0,13.28,7c2.69,1.16,5.3,2.17,7.71,3a12.62,12.62,0,0,0,6.55.66,6.72,6.72,0,0,0,3.78-2.22A8.74,8.74,0,0,0,289.26,386.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.75,377.85a10.31,10.31,0,0,1-1.3-2.17,50.09,50.09,0,0,1-2.42-5.6,48.27,48.27,0,0,1-1.74-5.85,9.89,9.89,0,0,1-.41-2.5,15.66,15.66,0,0,1,.76,2.41c.44,1.49,1.07,3.54,1.88,5.76s1.64,4.2,2.27,5.62A16.86,16.86,0,0,1,254.75,377.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,241.13a14.07,14.07,0,0,0-8.77,9.05c-1.55,4.67-.78,10,1.22,14.42a11.53,11.53,0,0,0,10.56,7.14c4.84.06,9.64-2,14.17-3.45l17.6-5.61c3.05-1,1.75-5.81-1.33-4.83l-13.32,4.26c-4.17,1.33-8.32,2.82-12.55,3.94-3.17.85-6.94,1.38-9.31-1.42s-3.06-6.92-2.8-10.34,2.37-7.17,5.85-8.34c3-1,1.74-5.85-1.32-4.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.37,145.57c-4.24.86-6.81,5-7,9.12-.19,4.53,2.27,8.51,4.7,12.12a2.56,2.56,0,0,0,3.42.9,2.53,2.53,0,0,0,.9-3.42c-1.77-2.63-3.86-5.62-4-8.69a6.07,6.07,0,0,1,.16-2c0-.15.32-.93.19-.64a9.33,9.33,0,0,1,.48-.88c.06-.1.22-.32.06-.11a3.9,3.9,0,0,1,.33-.38c.14-.15.29-.29.44-.44s-.24.16.09-.07l.41-.26s.45-.24.26-.15.23-.08.28-.09l.6-.15a2.52,2.52,0,0,0,1.75-3.07,2.55,2.55,0,0,0-3.08-1.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 151.34,
    width: 91.86,
    height: 95.68,
    rx: 14.35,
    transform: "translate(-58 51.74) rotate(-19)",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 151.34,
    width: 91.86,
    height: 95.68,
    rx: 14.35,
    transform: "translate(-58 51.74) rotate(-19)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 91.94,
    y: 147.11,
    width: 91.86,
    height: 95.68,
    rx: 14.35,
    transform: "translate(-55.96 55.51) rotate(-19)",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,172.14S82,179.59,79.76,187.48s-9.39,32.44-9.39,32.44a132.53,132.53,0,0,0-5.66,13c-1,3.26-9.19,21.37-7.37,27.12.18.54-4,10.11-4,10.11L73,276.77l4.08-10.3,1.67-1a8.08,8.08,0,0,0,3.48-4.14L93,232.63l8.49-23.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.51,175.58a8.82,8.82,0,0,1,1.15,1.07c.36.36.79.8,1.26,1.36s1,1.15,1.56,1.88a43.79,43.79,0,0,1,3.53,5.3,47.64,47.64,0,0,1,3.24,7.09,48.55,48.55,0,0,1,2,7.55,44.07,44.07,0,0,1,.6,6.34c.05.91,0,1.73,0,2.45s-.07,1.34-.12,1.84a8.89,8.89,0,0,1-.22,1.56,10,10,0,0,1,0-1.57c0-.51,0-1.12,0-1.84s0-1.53-.06-2.42a47.73,47.73,0,0,0-.71-6.27,50.91,50.91,0,0,0-2-7.46,51.81,51.81,0,0,0-3.17-7,47,47,0,0,0-3.41-5.31c-.51-.74-1-1.35-1.49-1.92s-.84-1-1.18-1.4A9.49,9.49,0,0,1,87.51,175.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46,183.15a7.38,7.38,0,0,1,1.13.8c.72.54,1.7,1.38,2.87,2.47a52.56,52.56,0,0,1,3.87,4.07,56.55,56.55,0,0,1,4.1,5.54,56.78,56.78,0,0,1,3.32,6,49.2,49.2,0,0,1,2.09,5.22c.5,1.51.86,2.76,1,3.63a7.65,7.65,0,0,1,.26,1.37,6.43,6.43,0,0,1-.46-1.31c-.25-.86-.65-2.08-1.2-3.57s-1.27-3.24-2.17-5.14A63.29,63.29,0,0,0,93,196.31a60.14,60.14,0,0,0-4-5.51,54.24,54.24,0,0,0-3.76-4.11c-1.12-1.12-2.07-2-2.74-2.58A7.43,7.43,0,0,1,81.46,183.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.45,223.94c6.64,6,15.62,9.92,24.48,8.89L94.37,229a28,28,0,0,1-24.14-8.92Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.13,226.81a3.85,3.85,0,0,1-1,.13,20,20,0,0,1-2.84,0,28,28,0,0,1-9.06-2.21,39,39,0,0,1-8.07-4.69c-1-.71-1.71-1.32-2.21-1.76a4.87,4.87,0,0,1-.75-.72c0-.07,1.22.84,3.17,2.18a44.79,44.79,0,0,0,8.06,4.51,30.9,30.9,0,0,0,8.89,2.32C93.65,226.81,95.12,226.71,95.13,226.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.18,236.06a3.75,3.75,0,0,1-1,.13,19.89,19.89,0,0,1-2.83,0A28.08,28.08,0,0,1,78.25,234a39,39,0,0,1-8.07-4.69c-1-.71-1.71-1.32-2.21-1.76a4,4,0,0,1-.74-.72c0-.07,1.21.84,3.16,2.18a45.5,45.5,0,0,0,8.06,4.51,31,31,0,0,0,8.9,2.32C89.7,236.06,91.18,236,91.18,236.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,196a7,7,0,0,0-2.21-1.69,2.37,2.37,0,0,0-2.6.41,3.56,3.56,0,0,0-.65,1.44L74.15,206.3a4.47,4.47,0,0,0-.23,1.73A2.73,2.73,0,0,0,75.37,210a4.51,4.51,0,0,0,5-.9,9.78,9.78,0,0,0,2.57-4.63C83.75,201.6,84.29,198,82.4,196Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7,269.29a3.49,3.49,0,0,1-.87-.22l-2.34-.77c-2-.67-4.74-1.63-7.86-2.75l-.24-.09.09-.24.71-2c.1-.26.19-.52.28-.76l.09-.24.24.08c3.45,1.1,6.54,2.1,8.75,2.85,1.11.38,2,.69,2.62.92l.7.27c.07,0,.15,0,.14.1s.08,0,.09,0,0,0,0,0-.14,0-.22,0l-.73-.18c-.63-.16-1.54-.42-2.66-.75-2.25-.67-5.35-1.62-8.81-2.71l.32-.16c-.09.25-.18.51-.28.77-.24.68-.49,1.35-.72,2l-.15-.32c3.11,1.13,5.84,2.16,7.8,2.91l2.29.92A2.89,2.89,0,0,1,74.7,269.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,265.1c0-.13,4.39,1.32,9.7,3.24s9.58,3.6,9.53,3.73a97.37,97.37,0,0,1-9.7-3.24A97.87,97.87,0,0,1,55.5,265.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,272.35,71,278.7a1.33,1.33,0,0,0,1.69-.8h0a1.32,1.32,0,0,0-.79-1.69l-17.5-6.34a1.31,1.31,0,0,0-1.69.79h0A1.31,1.31,0,0,0,53.5,272.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,278s3.27,6.44,3.43,10.67.14,7.39-1.73,8.73-3.72,1.06-3.91-1.05.58-3.41-.53-5.91-1.91-2.85-1.91-2.85-3.23,6.88-2.41,8.92,5.38,6.78,2.4,8.17-6-1.62-6-1.62-2.85,2.76-6-.64a7.4,7.4,0,0,1-5.88-5.93s-3.92-.57-3.65-4.07a46,46,0,0,1,3.58-13.31,40.61,40.61,0,0,1,2.75-4.54c0-.19,1.9-3.21,1.9-3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.31,292.08a16.4,16.4,0,0,0,3.39,10.77s-.56-.37-1.22-1.21a11.92,11.92,0,0,1-1.93-3.71,12.12,12.12,0,0,1-.55-4.14A4.33,4.33,0,0,1,57.31,292.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.43,288.77a22.77,22.77,0,0,0-.19,7,23.4,23.4,0,0,0,2.4,6.51,5.65,5.65,0,0,1-1.24-1.67,14.58,14.58,0,0,1-1.67-4.76,14.35,14.35,0,0,1,.06-5A5.42,5.42,0,0,1,52.43,288.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.73,286.6c.15,0-.42,2.27-.64,5.06s0,5.08-.17,5.1a13.28,13.28,0,0,1-.35-5.14A13.12,13.12,0,0,1,49.73,286.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.92,282c0-.07,1.11,1,3.2,2.24a43.83,43.83,0,0,0,8.94,3.93l-.32.15a37.13,37.13,0,0,1,1.57-3.72,35.76,35.76,0,0,1,2.23-3.89l.12.38a63.73,63.73,0,0,1-8.68-4c-1-.57-1.85-1.06-2.4-1.41a4.44,4.44,0,0,1-.82-.59,4.2,4.2,0,0,1,.91.44l2.46,1.28a78.81,78.81,0,0,0,8.7,3.8l.3.11L64,281a37.52,37.52,0,0,0-3.75,7.51l-.08.23-.24-.08a39.26,39.26,0,0,1-9-4.14,18.61,18.61,0,0,1-2.3-1.76A4.39,4.39,0,0,1,47.92,282Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.35,295.19s.12-.34.57-.64a2.83,2.83,0,0,1,2-.38,2.79,2.79,0,0,1,1.75,1.11c.32.44.36.77.3.8s-.23-.24-.57-.56a3,3,0,0,0-3.34-.64C69.65,295.06,69.4,295.25,69.35,295.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.24,304.71c-.06,0-.25-.32-.33-.93a4.21,4.21,0,0,1,.44-2.35A4.13,4.13,0,0,1,65,299.71c.54-.29.93-.33,1-.27a7.73,7.73,0,0,0-2.16,2.23A7.6,7.6,0,0,0,63.24,304.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.84,278.85a18.08,18.08,0,0,1-2.84-.94l-6.77-2.45-6.75-2.52a19.49,19.49,0,0,1-2.76-1.16,15.35,15.35,0,0,1,2.88.82c1.76.57,4.17,1.4,6.81,2.37s5,1.89,6.72,2.6A14.37,14.37,0,0,1,71.84,278.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,213c.21.34,17.7,34.23,17.7,34.23s7.2,23.14,12.24,30.07l68.9-41.45-12.4-24.27-21.32-67.26-10.15,2s-48.91,17.55-55.37,20a28.67,28.67,0,0,0-9.8,5.88S93.4,200.46,101.3,213Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.43,
    y: 187.73,
    width: 50.32,
    height: 42.56,
    rx: 6.77,
    transform: "translate(-63.58 63.65) rotate(-20.34)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95.81,168.74c12.14,3.7,18.41,15.94,23.79,26.42,1.46,2.86,5.78.33,4.31-2.53-6-11.78-13.23-24.59-26.77-28.71-3.08-.94-4.4,3.88-1.33,4.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.16,
    y: 185.88,
    width: 50.32,
    height: 42.56,
    rx: 6.77,
    transform: "translate(-62.89 63.78) rotate(-20.34)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,220.72a11.44,11.44,0,0,0,1.53-.87,6.7,6.7,0,0,0,2.64-4.12,6.45,6.45,0,0,0-.25-3.55l-1.53-4.08-3.73-10-4.51-12.06a9.29,9.29,0,0,0-1.54-3.08,6.55,6.55,0,0,0-6.42-2.22,12,12,0,0,0-1.78.59l-1.82.67-31.76,11.8a6.53,6.53,0,0,0-4.22,6.75,7.06,7.06,0,0,0,.53,2l.75,2,1.49,4c2,5.32,3.86,10.44,5.66,15.33.46,1.22.9,2.43,1.34,3.62a13.45,13.45,0,0,0,1.5,3.35,6.55,6.55,0,0,0,6.06,2.67,14.47,14.47,0,0,0,3.21-1l3.08-1.14,5.8-2.13L164.5,223l4.78-1.71,1.24-.44.43-.13a4.22,4.22,0,0,1-.41.18l-1.23.48-4.74,1.81-17.46,6.57-5.79,2.16-3.08,1.15a14.78,14.78,0,0,1-3.3,1,7,7,0,0,1-6.48-2.83,7.23,7.23,0,0,1-.91-1.69l-.66-1.77c-.44-1.19-.89-2.39-1.35-3.61-1.81-4.89-3.72-10-5.69-15.32l-1.49-4-.76-2a7.86,7.86,0,0,1-.55-2.17,6.9,6.9,0,0,1,1-4.39,7.05,7.05,0,0,1,3.53-2.9l31.77-11.76,1.82-.67a12.25,12.25,0,0,1,1.86-.6,7,7,0,0,1,6.86,2.4,9.76,9.76,0,0,1,1.6,3.21L170,198l3.66,10c.53,1.47,1,2.84,1.49,4.1a6.76,6.76,0,0,1,.21,3.67,6.66,6.66,0,0,1-2.78,4.16A5.49,5.49,0,0,1,171,220.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,212.18,131,217.53a2,2,0,0,1-2.61-1.2h0a2,2,0,0,1,1.2-2.61l14.44-5.35a2,2,0,0,1,2.61,1.19h0A2,2,0,0,1,145.47,212.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,221.14a1.7,1.7,0,1,1-2.18-1A1.7,1.7,0,0,1,133.65,221.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,219.13a1.7,1.7,0,1,1-2.18-1A1.7,1.7,0,0,1,139.08,219.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.33,217.18a1.7,1.7,0,1,1-2.18-1A1.7,1.7,0,0,1,144.33,217.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,215.24a1.69,1.69,0,1,1-2.18-1A1.68,1.68,0,0,1,149.58,215.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,199.57l-14.44,5.35a2,2,0,0,1-2.61-1.2h0a2,2,0,0,1,1.2-2.61l14.44-5.35a2,2,0,0,1,2.61,1.2h0A2,2,0,0,1,140.69,199.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.86,208.53a1.69,1.69,0,1,1-2.17-1A1.69,1.69,0,0,1,128.86,208.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,206.52a1.7,1.7,0,1,1-2.18-1A1.7,1.7,0,0,1,134.3,206.52Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55,204.57a1.7,1.7,0,1,1-2.18-1A1.7,1.7,0,0,1,139.55,204.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8,202.63a1.69,1.69,0,1,1-2.18-1A1.69,1.69,0,0,1,144.8,202.63Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.15,250.44s22.14-3.09,43.34-13.49,27.71-18.59,27.71-18.59l3.89,7.6S174.4,248,122.53,258.34C122.53,258.34,119.59,252.69,120.15,250.44Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.13,184.9a3.14,3.14,0,0,1,.29.63c.18.47.42,1.07.72,1.83l2.55,6.75c2.12,5.78,5,13.66,8.23,22.36.25.68.49,1.36.72,2l.09.24-.24.09-21.1,7.58-6.34,2.21-1.73.58a2.7,2.7,0,0,1-.61.17,2.3,2.3,0,0,1,.57-.26l1.7-.67,6.29-2.37,21-7.73-.16.33c-.23-.62-.47-1.3-.72-2l-8.09-22.41c-1-2.83-1.81-5.15-2.39-6.81l-.63-1.86A4.2,4.2,0,0,1,145.13,184.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.4 218.55 156.91 219.88 128.22 230.72 127.71 229.33 157.4 218.55"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 187.8,
    width: 12.06,
    height: 12.06,
    rx: 1.66,
    transform: "translate(-57.56 66.85) rotate(-20.34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.62,203l-9.32,3.21a1.55,1.55,0,0,1-2-1h0a1.54,1.54,0,0,1,1-2l9.32-3.21a1.55,1.55,0,0,1,2,1h0A1.55,1.55,0,0,1,166.62,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,207.15a79.71,79.71,0,0,1-8.55,3.38,83.16,83.16,0,0,1-8.72,2.89,78.67,78.67,0,0,1,8.55-3.38A82.3,82.3,0,0,1,172.8,207.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,217.05a1.64,1.64,0,1,1-1.34-1.89A1.64,1.64,0,0,1,164.08,217.05Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.87,215.15a1.64,1.64,0,1,1-3.24-.55,1.64,1.64,0,0,1,3.24.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.22 248.53 132.32 257.08 137.66 255.63 134.46 246.07 129.22 248.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.8 226.93 185.28 234.19 189.95 231.23 184.09 223.03 179.8 226.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,214.84a5,5,0,0,1-.59.52c-.43.36-1,.83-1.75,1.42s-1.7,1.37-2.82,2.19-2.38,1.8-3.82,2.79-3,2.11-4.75,3.22-3.6,2.28-5.58,3.49c-4,2.36-8.47,4.81-13.29,7.14s-9.55,4.25-13.89,5.88c-2.19.79-4.25,1.55-6.22,2.16s-3.8,1.2-5.49,1.68-3.22.88-4.57,1.24-2.51.62-3.47.83l-2.21.47a4.4,4.4,0,0,1-.77.13,3.5,3.5,0,0,1,.75-.23l2.18-.57c1-.23,2.11-.53,3.45-.91s2.87-.78,4.54-1.31,3.51-1.06,5.45-1.74,4-1.4,6.19-2.19c4.32-1.66,9-3.62,13.83-5.91s9.28-4.75,13.27-7.08c2-1.2,3.88-2.31,5.59-3.45s3.33-2.17,4.78-3.16,2.72-1.91,3.86-2.71,2.09-1.52,2.87-2.12l1.81-1.34A3.55,3.55,0,0,1,189,214.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,246c-.12.07-5.57-9.15-12.17-20.6s-11.85-20.78-11.72-20.85,5.57,9.14,12.17,20.59S125.6,245.91,125.47,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,175a10.91,10.91,0,0,1,.4,1.74c.24,1.21.56,2.82.95,4.76.81,4,2,9.55,3.61,15.6s3.26,11.46,4.53,15.36c.62,1.89,1.13,3.44,1.52,4.61a10.05,10.05,0,0,1,.5,1.71,12.48,12.48,0,0,1-.7-1.64c-.42-1.07-1-2.63-1.67-4.56-1.36-3.88-3.08-9.29-4.68-15.35s-2.75-11.62-3.48-15.66c-.36-2-.63-3.66-.78-4.79A11.37,11.37,0,0,1,173.46,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.91,
    y: 243.73,
    width: 7.42,
    height: 8.47,
    transform: "translate(-65.99 53.93) rotate(-16.98)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,134.51c-3.4,20-21.94,30.85-41.94,27.45s-33.91-19.77-30.51-39.78a36.75,36.75,0,0,1,72.45,12.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,134.51s0-.2,0-.59.1-1,.17-1.71c0-.38.09-.8.14-1.26s0-1,0-1.53a28.18,28.18,0,0,0-.1-3.81c-.07-.71-.12-1.47-.22-2.26s-.3-1.6-.46-2.45a19.36,19.36,0,0,0-.68-2.64,20.4,20.4,0,0,0-.93-2.8,36.3,36.3,0,0,0-7.19-11.69,35.8,35.8,0,0,0-22.67-11.63,35.72,35.72,0,0,0-9.84.13l-2.51.46c-.83.17-1.65.46-2.48.68l-1.25.36-1.22.48c-.81.34-1.64.62-2.44,1a38,38,0,0,0-9,5.95l-2,1.91c-.6.7-1.22,1.4-1.83,2.1a24.92,24.92,0,0,0-1.69,2.25l-.82,1.15c-.25.4-.47.82-.71,1.23-.44.84-1,1.62-1.36,2.51L80.45,115a39.6,39.6,0,0,0-1.65,5.57,33,33,0,0,0,2.56,22.13,35,35,0,0,0,14.75,14.75A41.69,41.69,0,0,0,105.3,161l2.33.5,1.16.25,1.16.14,2.29.3c.76.06,1.52.07,2.27.11a42.37,42.37,0,0,0,8.67-.58l2-.47a15.22,15.22,0,0,0,2-.52,31.49,31.49,0,0,0,3.69-1.33,33.08,33.08,0,0,0,11.27-7.8,30.67,30.67,0,0,0,5.79-8.62,19.12,19.12,0,0,0,.81-1.86c.21-.6.4-1.16.58-1.69s.36-1,.48-1.45.2-.86.29-1.23c.17-.72.3-1.28.4-1.67s.15-.57.15-.57,0,.2-.1.58-.2,1-.35,1.68c-.08.38-.17.79-.26,1.25s-.3.93-.46,1.46-.36,1.1-.56,1.7a18.22,18.22,0,0,1-.8,1.88,30.47,30.47,0,0,1-5.75,8.74A33.29,33.29,0,0,1,131,159.73a32.77,32.77,0,0,1-3.72,1.37,14.81,14.81,0,0,1-2,.53l-2,.48a41.82,41.82,0,0,1-8.76.62c-.76,0-1.53,0-2.3-.1l-2.32-.29-1.17-.15-1.17-.24-2.35-.51a41.61,41.61,0,0,1-9.3-3.59,35.32,35.32,0,0,1-15-14.94,33.49,33.49,0,0,1-2.61-22.47A40.3,40.3,0,0,1,80,114.79c.4-.89.8-1.77,1.19-2.66a28.49,28.49,0,0,1,1.39-2.54c.24-.42.46-.84.72-1.25l.83-1.17a24.05,24.05,0,0,1,1.71-2.27l1.86-2.14,2-1.93a38.38,38.38,0,0,1,9.11-6c.81-.4,1.66-.68,2.47-1l1.24-.48,1.27-.37c.84-.22,1.67-.52,2.52-.68l2.54-.47a36.58,36.58,0,0,1,10-.11,36.25,36.25,0,0,1,22.89,11.84,36.47,36.47,0,0,1,7.2,11.84,20.05,20.05,0,0,1,.91,2.82,20.23,20.23,0,0,1,.66,2.66c.16.87.31,1.69.45,2.48s.13,1.56.19,2.28a26.37,26.37,0,0,1,.06,3.83c0,.55,0,1.06-.06,1.53s-.11.88-.16,1.26c-.1.74-.18,1.31-.23,1.71S150.62,134.51,150.62,134.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M125.73,93.37s-41.32-1.93-34.38,42.89h0a26.39,26.39,0,0,0,13.79,12.22c11.76,4.49,31.52,8,44.68-11.28l.55-1.2S157.38,105.25,125.73,93.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109.1,143.56a73.68,73.68,0,0,1-8.16-9.92,26,26,0,0,1-4.39-11.93c0-.65,0-5.16.59-5.38.44-.15,1,3.81,1.34,4.07A22,22,0,0,1,106.13,131a58.56,58.56,0,0,1,3,12.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.87,150.12s8.93-2.94,10.37-6.85a11.31,11.31,0,0,0-.28-8.14c-1.79-4.64-6.25-13.92-10.39-22.26a19.2,19.2,0,0,0-24.33-9.3l-.92.36c-9.73,4.56-11.29,15.37-6.47,25l11,21.81s6.87,1.74,11.38,1.26A76.53,76.53,0,0,0,133.87,150.12Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,123.07A1.46,1.46,0,0,1,134,125a1.41,1.41,0,0,1-1.9-.67,1.47,1.47,0,0,1,.77-1.9A1.39,1.39,0,0,1,134.76,123.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22,117.91c-.09.25-1.44-.11-2.91.48s-2.25,1.76-2.48,1.65-.07-.44.27-1a4,4,0,0,1,1.9-1.54,3.86,3.86,0,0,1,2.4-.16C133,117.54,133.28,117.8,133.22,117.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7,128.86a1.48,1.48,0,0,1-.77,1.91,1.41,1.41,0,0,1-1.9-.67,1.48,1.48,0,0,1,.77-1.91A1.41,1.41,0,0,1,121.7,128.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.94,124c-.1.24-1.44-.11-2.91.48s-2.26,1.76-2.49,1.64-.07-.44.27-1a4.06,4.06,0,0,1,1.9-1.53,3.88,3.88,0,0,1,2.41-.16C118.71,123.63,119,123.89,118.94,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.73,133.21a10.37,10.37,0,0,1,2.21-1.39c.37-.19.69-.4.65-.68s-.34-.65-.69-1l-2.26-2.42c-3.16-3.45-5.62-6.36-5.48-6.48s2.82,2.57,6,6c.78.85,1.51,1.67,2.22,2.45a2.34,2.34,0,0,1,.78,1.4,1,1,0,0,1-.4.79,3,3,0,0,1-.6.35A10.7,10.7,0,0,1,128.73,133.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58,119.22c0,.45-1.64.63-3.39,1.28s-3.1,1.51-3.43,1.19c-.15-.16,0-.61.5-1.16a6.29,6.29,0,0,1,5.19-1.88C117.18,118.75,117.59,119,117.58,119.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,113.56c-.17.46-1.51.61-2.94,1.19s-2.56,1.32-3,1.09c-.19-.12-.14-.53.26-1.06a5.06,5.06,0,0,1,2.15-1.54,4.87,4.87,0,0,1,2.61-.3C131.32,113.07,131.63,113.34,131.57,113.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,135.68c-.19,0-7.35.68-4.53,7.14s9.14,2,9.07,1.81S105.46,135.68,105.46,135.68Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,143.34s-.08.13-.23.3a1.25,1.25,0,0,1-.83.38,3,3,0,0,1-2.38-1.93,3.92,3.92,0,0,1-.39-1.75,1.42,1.42,0,0,1,.47-1.24.63.63,0,0,1,.8,0c.16.14.18.29.22.29s.09-.17-.08-.42a.8.8,0,0,0-.43-.29.91.91,0,0,0-.69.11,1.68,1.68,0,0,0-.74,1.51,4.2,4.2,0,0,0,.39,2c.61,1.28,1.81,2.21,2.86,2.07a1.32,1.32,0,0,0,1-.62C106.6,143.5,106.57,143.34,106.54,143.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64,104.07c.78-1-3.85-3-6.93-3-4.65,0-11,1.54-14.16,4.15-3.75,3.14-6.37,6.87-6.77,11.74a27.72,27.72,0,0,0,2.93,14.2,8.47,8.47,0,0,0,2.67,3.53c1.53,1,3.66,1.14,4.46,3.14a3,3,0,0,0,1.55,1.67c1.74.72,2.65-1.1,2.79-2.57.29-3.16-.9-6.24-2.07-9.18a20.49,20.49,0,0,0-3.14-5.94c-.8-.94-1.76-1.72-2.5-2.7a4.24,4.24,0,0,1-1-3.42,4.11,4.11,0,0,1,.28-.76,7.35,7.35,0,0,1,6.1-4.24c4.2-.34,11.24-1.19,12.31-3.15a11.06,11.06,0,0,0,1.58-4.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M150.09,149.65,108,167.48a23,23,0,0,0,12.17,1.46,63.18,63.18,0,0,0,12-3.1,50.05,50.05,0,0,0,9.32-3.87,17.71,17.71,0,0,0,7.07-7A15.44,15.44,0,0,0,150.09,149.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M102.91,163.3l-.61-1.43,1.07-1.21s7.78,2.53,23.55-2.28c16.57-5,19.55-12.71,19.55-12.71l1.8-.53L150,149s-3.36,11.28-23,16.42c-9.58,2.5-15.29,2.63-18.62,2.1A7,7,0,0,1,102.91,163.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.91,163.3s.16.35.56,1a7.11,7.11,0,0,0,2.25,2.2,7.22,7.22,0,0,0,2.11.85,18.23,18.23,0,0,0,2.73.3,38.39,38.39,0,0,0,6.69-.4,79.21,79.21,0,0,0,8-1.58,60.67,60.67,0,0,0,8.88-2.9,35.66,35.66,0,0,0,8.87-5.21,27.37,27.37,0,0,0,3.87-3.82,17.24,17.24,0,0,0,2.83-4.76v.18l-.35-.81L148,145.24l.31.14-1.8.54.17-.15a13.36,13.36,0,0,1-2.49,3.44,23.79,23.79,0,0,1-3.1,2.7,37.54,37.54,0,0,1-6.77,3.92,67.67,67.67,0,0,1-13.15,4.28c-8.14,1.8-14.63,1.58-17.86.63l.09,0-1.08,1.19v-.06l.43,1.09a2.37,2.37,0,0,1,.12.36,2,2,0,0,1-.18-.34c-.12-.26-.28-.61-.48-1.07l0,0,0,0,1-1.22,0,0,0,0c3.2.84,9.65,1,17.72-.88a68.42,68.42,0,0,0,13-4.31,38.25,38.25,0,0,0,6.66-3.89,23.67,23.67,0,0,0,3-2.65,13,13,0,0,0,2.39-3.28l.05-.12.11,0,1.8-.53.22-.07.1.21c.43,1,.88,2,1.33,3.08l.35.8,0,.1,0,.08a22,22,0,0,1-6.88,8.83,35.8,35.8,0,0,1-9,5.25,60.66,60.66,0,0,1-9,2.88,76.74,76.74,0,0,1-8,1.52,38.59,38.59,0,0,1-6.76.33,17.31,17.31,0,0,1-2.76-.35,7,7,0,0,1-4.4-3.23A4.7,4.7,0,0,1,102.91,163.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,93.37s1.31.43,3.65,1.47l1.94.91L133.57,97c.8.48,1.63,1,2.52,1.61s1.8,1.25,2.68,2.05a33.4,33.4,0,0,1,9.93,13.73,37.79,37.79,0,0,1,2.4,10.16,40.28,40.28,0,0,1-.5,11.52v0l-.55,1.2v0l0,0a34.72,34.72,0,0,1-14.09,12.22,35.4,35.4,0,0,1-20.13,2.11,54.64,54.64,0,0,1-9.37-2.46A26.56,26.56,0,0,1,92.07,138c-.2-.31-.4-.63-.57-.95l-.27-.49-.07-.12,0,0s-.06-.17,0-.11v-.07l0-.28c-.09-.72-.17-1.45-.25-2.17-.2-1.44-.25-2.87-.33-4.29s0-2.82,0-4.2.18-2.74.29-4.08c.11-.66.21-1.32.31-2l.16-1,.22-1q.23-1,.45-1.89c.2-.61.4-1.22.59-1.82.11-.3.19-.6.3-.89l.37-.87c.25-.56.46-1.14.74-1.69A28.54,28.54,0,0,1,95.67,107a31,31,0,0,1,2-2.77,30.4,30.4,0,0,1,2.31-2.36,29.45,29.45,0,0,1,2.42-2c.85-.57,1.66-1.16,2.51-1.62a33.12,33.12,0,0,1,4.92-2.35,40,40,0,0,1,8.44-2.16,41.13,41.13,0,0,1,5.49-.44c.63,0,1.11,0,1.43,0l.49,0h-.49l-1.43,0a46.85,46.85,0,0,0-5.46.54A40.39,40.39,0,0,0,110,96.18a33.74,33.74,0,0,0-4.86,2.36c-.84.46-1.63,1.06-2.47,1.62a27.27,27.27,0,0,0-2.38,2A29.68,29.68,0,0,0,98,104.49a30.15,30.15,0,0,0-2,2.74,29.47,29.47,0,0,0-1.75,3.07c-.26.54-.47,1.12-.72,1.68l-.36.85c-.1.29-.19.59-.29.88-.19.6-.38,1.19-.58,1.8s-.29,1.24-.43,1.87l-.22.94-.15,1-.3,2c-.11,1.32-.25,2.67-.28,4s-.09,2.76,0,4.16.13,2.83.33,4.26c.09.71.17,1.43.25,2.16l0,.27v.07c0,.08,0-.08,0-.05v0l.07.12.27.47c.17.32.37.63.56.94a26.15,26.15,0,0,0,14.1,11,54.07,54.07,0,0,0,9.28,2.43,34.88,34.88,0,0,0,19.84-2.06,34.21,34.21,0,0,0,13.91-12l0,0c.2-.42.39-.84.55-1.2v0a39.55,39.55,0,0,0,.52-11.37,37.22,37.22,0,0,0-2.32-10.06,33.41,33.41,0,0,0-9.75-13.65c-.87-.8-1.82-1.41-2.64-2.07s-1.71-1.13-2.49-1.62l-2.23-1.26-1.91-1c-1.14-.58-2.07-.9-2.67-1.18l-.69-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,135.71c.9,3-.48,6.12-3.09,6.89s-5.47-1-6.37-4.07.49-6.11,3.1-6.89S93.62,132.69,94.52,135.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,135.71s-.18-.44-.59-1.16a5.89,5.89,0,0,0-2.48-2.39,4.68,4.68,0,0,0-2.3-.47,4.14,4.14,0,0,0-2.44,1,5.86,5.86,0,0,0,2.91,9.78,4.25,4.25,0,0,0,2.61-.47,4.77,4.77,0,0,0,1.66-1.65,6.09,6.09,0,0,0,.78-3.37c-.06-.83-.2-1.28-.15-1.3s.07.11.14.32a5.69,5.69,0,0,1,.21,1,5.9,5.9,0,0,1-.66,3.56,4.92,4.92,0,0,1-1.77,1.84,4.57,4.57,0,0,1-2.88.57,6.29,6.29,0,0,1-3.17-10.61,4.55,4.55,0,0,1,2.73-1.1,5,5,0,0,1,2.49.57,5.84,5.84,0,0,1,2.5,2.62,5.21,5.21,0,0,1,.35.93C94.52,135.59,94.54,135.71,94.52,135.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,112.31c-2.54-8-9.45-14.71-17.73-16.09a1.94,1.94,0,0,0-1.42.19,1.71,1.71,0,0,0-.83,1.59c.37,3,7.59,3.31,10.39,6.4s4.68,6.56,6.8,10.15c.32.55.71,1.15,1.33,1.28a1.58,1.58,0,0,0,1.7-1.24A4.17,4.17,0,0,0,143.19,112.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,145.44a2.72,2.72,0,0,1-.18.5c-.14.32-.35.78-.67,1.36a19.88,19.88,0,0,1-3.37,4.46,19.21,19.21,0,0,1-3,2.41,40.8,40.8,0,0,1-3.81,2.27,53,53,0,0,1-9.36,3.9,77.4,77.4,0,0,1-9.89,2.24,46.34,46.34,0,0,1-8.25.77,20.42,20.42,0,0,1-5.54-.74,13.17,13.17,0,0,1-1.43-.51,1.89,1.89,0,0,1-.48-.23c0-.05.7.23,2,.55a22.62,22.62,0,0,0,5.48.57,49.87,49.87,0,0,0,8.17-.88,83.23,83.23,0,0,0,9.81-2.27A54.47,54.47,0,0,0,137,156q2.06-1.08,3.8-2.21a19.18,19.18,0,0,0,3-2.31,21.37,21.37,0,0,0,3.45-4.3C148,146.08,148.27,145.42,148.32,145.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.27,136.74a1.45,1.45,0,0,0-1.6,0,1.53,1.53,0,0,0-.64,1.47,1.63,1.63,0,0,0,1,1.26,1.51,1.51,0,0,0,1.75-.44A1.86,1.86,0,0,0,130.27,136.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.86,138.92s-.07.44-.65.8a1.48,1.48,0,0,1-1.2.15,2.08,2.08,0,0,1-1-1,2.22,2.22,0,0,1-.22-1.43,1.74,1.74,0,0,1,.72-1,1.32,1.32,0,0,1,.77-.16c.17,0,.27,0,.27.08s-.42.09-.83.39a1.56,1.56,0,0,0-.46.76,2.07,2.07,0,0,0,.22,1.09,1.74,1.74,0,0,0,.76.8,1.13,1.13,0,0,0,.85,0C130.56,139.18,130.79,138.87,130.86,138.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,146.27c.35-.29,13.27-4.49,23.33-.32,6.31,2.61,20.11,10.31,29.63,19.65s25.93,28.6,26.42,31.11a8.75,8.75,0,0,1-.37,4.56l4.95,9-13.44,10.92-6.39-6.45s-3.53,0-8.08-4.69-14-20.62-19.81-24.64-24.79-11.68-26.46-12.06S156.27,146.27,156.27,146.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.82,216.14a20.9,20.9,0,0,1,2.35-2.12c1.5-1.28,3.61-3,6-5l0,.36-1.26-1.55-.48-.59.36,0c-2.74,2-5.21,3.84-7,5.12-.9.64-1.63,1.15-2.14,1.49l-.59.39c-.08,0-.1.09-.2.07s0,0,0,0,0,0,.08,0,0-.07.09-.14l.54-.45c.47-.4,1.16-1,2-1.62,1.74-1.36,4.17-3.21,6.9-5.25l.2-.15.16.19.48.6c.43.53.85,1.05,1.26,1.54l.16.2-.2.16c-2.43,2-4.58,3.67-6.14,4.88A19.88,19.88,0,0,1,221.82,216.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.13,206.06a82,82,0,0,1-7.08,6.09,83.69,83.69,0,0,1-7.42,5.69,83.42,83.42,0,0,1,7.09-6.09A85.14,85.14,0,0,1,238.13,206.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,161.11a18,18,0,0,1-1.74,2.35c-1.11,1.42-2.64,3.38-4.25,5.6-1.16,1.59-2.21,3.1-3.08,4.36l-.11.16-.16-.08c-1.26-.6-2.3-1.11-3-1.48a5.53,5.53,0,0,1-1.1-.64,4.86,4.86,0,0,1,1.21.41c.75.3,1.82.75,3.09,1.31l-.27.08c.82-1.3,1.85-2.83,3-4.43,1.62-2.23,3.2-4.16,4.39-5.53A14.8,14.8,0,0,1,204.26,161.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.15,157.53a12.27,12.27,0,0,1-1.32,2c-.84,1.19-2,2.85-3.21,4.72s-2.23,3.62-3,4.89a13.12,13.12,0,0,1-1.26,2,9.93,9.93,0,0,1,.93-2.2,56.48,56.48,0,0,1,6.21-9.66A9.74,9.74,0,0,1,199.15,157.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,156.13a4.7,4.7,0,0,1-.61,1c-.43.6-1,1.48-1.76,2.57a84.26,84.26,0,0,0-5.19,8.83,85.64,85.64,0,0,0-4.06,9.41c-.45,1.24-.79,2.24-1,2.94a4.15,4.15,0,0,1-.42,1.07,5.34,5.34,0,0,1,.23-1.13c.17-.72.47-1.74.87-3a68.13,68.13,0,0,1,4-9.52,67.1,67.1,0,0,1,5.34-8.81c.78-1.07,1.43-1.92,1.91-2.48A4.85,4.85,0,0,1,198,156.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.58,154.62c.07,0-1,1.27-2.44,3.34A66.14,66.14,0,0,0,181,175.59c-.82,2.41-1.23,3.94-1.32,3.92a5.37,5.37,0,0,1,.19-1.1c.15-.7.41-1.71.78-2.94a55.74,55.74,0,0,1,9.18-17.73c.79-1,1.46-1.81,1.95-2.34S192.55,154.59,192.58,154.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M189.05,150.78c-2.41,5.06-4.15,8.06-6.56,13.12a1.09,1.09,0,0,1-1.79.59l-5.58-2.55a3,3,0,0,1-1.23-.83,2.88,2.88,0,0,1-.33-2.05,31.82,31.82,0,0,1,5-13.5s2,.72,5.19,2.29A58.53,58.53,0,0,1,189.05,150.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M241.61,212.33l-13.59,11a1.23,1.23,0,0,1-1.75-.18h0a1.24,1.24,0,0,1,.18-1.75l13.6-11a1.24,1.24,0,0,1,1.75.19h0A1.24,1.24,0,0,1,241.61,212.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.75,222.92s-.32,6.25,1,9.66,2.49,5.89,4.45,6.3,3.31-.47,2.72-2.21-1.66-2.5-1.66-4.87.51-2.93.51-2.93,5,4.31,5.05,6.22-1.88,7.26,1,7.31S245,239,245,239s3.23,1.17,4.52-2.62a6.42,6.42,0,0,0,2.57-6.77s2.9-1.84,1.46-4.51a40.07,40.07,0,0,0-7.53-9.28,36.6,36.6,0,0,0-3.78-2.63c-.11-.13-1.15-1.51-1.15-1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.83,229.1a9.46,9.46,0,0,1,1.11,9.72,14.67,14.67,0,0,0-1.11-9.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,224.76s.57.41,1.22,1.33a12.39,12.39,0,0,1,2.18,8.34,4.36,4.36,0,0,1-.42,1.77,20.75,20.75,0,0,0-.43-6A21.37,21.37,0,0,0,246.54,224.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,222.09a10.5,10.5,0,0,1,2.71,3.55,10.69,10.69,0,0,1,1.51,4.21c-.15,0-.8-1.83-2-4S247.79,222.19,247.91,222.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.73,217.83a2.75,2.75,0,0,1-.29.86,17.19,17.19,0,0,1-1.19,2.21,34.38,34.38,0,0,1-5.63,6.45l-.19.16-.17-.17a32,32,0,0,0-2.53-2.35,33.26,33.26,0,0,0-3.07-2.28l-.27-.17.23-.22a68.81,68.81,0,0,0,5.56-6.07c1.3-1.59,2-2.57,2.08-2.53a3.73,3.73,0,0,1-.44.75c-.3.48-.77,1.15-1.39,2a55.11,55.11,0,0,1-5.46,6.23l0-.39a30.9,30.9,0,0,1,3.14,2.3,35,35,0,0,1,2.56,2.39h-.36a38.1,38.1,0,0,0,5.7-6.25C247.18,219,247.66,217.8,247.73,217.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.4,235.8c0,.14-1.14-.19-2.15.51s-1.09,1.86-1.23,1.83-.16-.28-.07-.74a2.46,2.46,0,0,1,1-1.52,2.49,2.49,0,0,1,1.77-.41C235.19,235.56,235.42,235.74,235.4,235.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.59,241.19c-.15,0-.39-1.26-1.55-2.18a7.34,7.34,0,0,0-2.47-1c0-.07.32-.18.85-.15a3.57,3.57,0,0,1,3.12,2.5C243.69,240.84,243.65,241.18,243.59,241.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.05,212.14a81.18,81.18,0,0,1-7,5.85,80.2,80.2,0,0,1-7.33,5.44,81.18,81.18,0,0,1,7-5.85A79.54,79.54,0,0,1,242.05,212.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43,191.74c8.35-3.15,16-9.31,19.16-17.65l-2.73-3a28,28,0,0,1-19,17.33Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.25,169.37a4.52,4.52,0,0,1-.36,1,19.94,19.94,0,0,1-1.3,2.51,27.92,27.92,0,0,1-6.13,7,39.11,39.11,0,0,1-7.87,5c-1.07.52-2,.91-2.58,1.15a4.28,4.28,0,0,1-1,.33c0-.08,1.31-.69,3.4-1.81a45.31,45.31,0,0,0,7.71-5.08,31.12,31.12,0,0,0,6.15-6.83C212.56,170.68,213.16,169.33,213.25,169.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.65,177.13a4.37,4.37,0,0,1-.36,1,20.63,20.63,0,0,1-1.3,2.52,27.92,27.92,0,0,1-6.13,7,39.39,39.39,0,0,1-7.87,5c-1.08.52-2,.91-2.58,1.15a4.64,4.64,0,0,1-1,.33c0-.08,1.31-.69,3.4-1.81a46.57,46.57,0,0,0,7.71-5.08,31.34,31.34,0,0,0,6.15-6.83C219,178.44,219.56,177.09,219.65,177.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.41,145.38a8.42,8.42,0,0,1,.25,1.5c.11,1,.33,2.35.67,4.05a46.36,46.36,0,0,0,1.58,5.86,45.62,45.62,0,0,0,3,6.8,46.09,46.09,0,0,0,4.13,6.18,44.46,44.46,0,0,0,4.12,4.46c1.26,1.18,2.32,2.1,3.09,2.7a9.35,9.35,0,0,1,1.14,1,8.06,8.06,0,0,1-1.27-.82,34.61,34.61,0,0,1-3.21-2.59,40.81,40.81,0,0,1-4.25-4.43,44.2,44.2,0,0,1-4.21-6.23,43.49,43.49,0,0,1-3-6.9A41.48,41.48,0,0,1,160,151a33.74,33.74,0,0,1-.51-4.1A8.74,8.74,0,0,1,159.41,145.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,144.13a8.94,8.94,0,0,1,.06,1.41c0,.9,0,2.21.15,3.81s.32,3.52.65,5.62a65.61,65.61,0,0,0,1.53,6.74,67.11,67.11,0,0,0,2.32,6.52c.85,2,1.68,3.68,2.46,5.09s1.43,2.54,1.92,3.3a7,7,0,0,1,.69,1.23,9,9,0,0,1-.86-1.11c-.54-.73-1.25-1.84-2.07-3.24a50.47,50.47,0,0,1-2.58-5.08,57.78,57.78,0,0,1-2.38-6.56,58.83,58.83,0,0,1-1.5-6.82,51.18,51.18,0,0,1-.55-5.67,35.86,35.86,0,0,1,0-3.83A6.47,6.47,0,0,1,168,144.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,241.32s5-2.81,8-1.21,15.61,10.64,15,12.26-1.47,5.28-1.47,5.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,354.05c-.14-.49-12.05-16-12.05-16l-9.62-21-5-14.34s2.79-3.15-1.8-6L177,288.86l-54.27-30.48s-.86,20.14,7.56,28.53c2.53,2.53,6.26,20.76,12,31.14s19.21,28.06,20.93,31.46S180,371.65,186,377.58c7.15,7,20.16,22.15,20.16,22.15l19.29-15S207.27,354.54,207.12,354.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.79,241.92c1.08,0,30.53,21.31,35.76,28.11s11.37,26.84,12.33,30.64,11.73,52.16,12,53.51-10.66,12.44-22.5,10.28L236.78,348s-9.57-17.66-11.5-22.95l-1.94-5.29-7.67-18-8.45-8.9a4.64,4.64,0,0,1-3-3.19l-5.36-5.65-11.34-2.84s-4.82-7.81-2.47-22,14.42-24.71,14.42-24.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2,335a4.47,4.47,0,0,1,.92-1.17,24.09,24.09,0,0,1,3-2.7,49.13,49.13,0,0,1,11.75-6.37c1.23-.44,2.41-.92,3.6-1.27a33,33,0,0,1,3.47-.85,41.32,41.32,0,0,1,6-.66A38,38,0,0,1,186,322a5.61,5.61,0,0,1,1.48.19s-.53,0-1.49,0-2.33,0-4,.11a45,45,0,0,0-5.91.76,39.85,39.85,0,0,0-7,2.14,53.8,53.8,0,0,0-11.72,6.17,33.34,33.34,0,0,0-3.12,2.55C153.57,334.58,153.23,335,153.2,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.05,339a46.33,46.33,0,0,1,16.22-10.19,67,67,0,0,1,16.88-3.6l1.26,2.74s-11.54,2.27-16.29,4c-5.92,2.2-16.23,9.65-16.23,9.65Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,289.82a9.87,9.87,0,0,1,.18-1.68,15.92,15.92,0,0,1,.35-1.94c.18-.75.34-1.62.64-2.55a30.63,30.63,0,0,1,1-3c.37-1.08.91-2.19,1.45-3.36a44.59,44.59,0,0,1,4.42-7.1,45.47,45.47,0,0,1,5.77-6.06c1-.81,1.93-1.61,2.88-2.24a29.29,29.29,0,0,1,2.67-1.74,25,25,0,0,1,2.3-1.26,16.41,16.41,0,0,1,1.79-.83,11.1,11.1,0,0,1,1.58-.6,9.93,9.93,0,0,1-1.49.78c-.49.23-1.09.52-1.75.91s-1.45.77-2.24,1.31-1.71,1.08-2.61,1.78-1.84,1.44-2.82,2.25a47.87,47.87,0,0,0-5.67,6,47.27,47.27,0,0,0-4.4,7c-.55,1.15-1.09,2.23-1.48,3.3s-.77,2-1.07,3-.5,1.76-.7,2.5a16.09,16.09,0,0,0-.44,1.92A13.45,13.45,0,0,1,204,289.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.55,293a9.78,9.78,0,0,1,.18-1.68,16.18,16.18,0,0,1,.36-1.94,24.34,24.34,0,0,1,.64-2.55,30.42,30.42,0,0,1,1-3c.38-1.09.92-2.19,1.45-3.36a45.42,45.42,0,0,1,4.43-7.1,44.21,44.21,0,0,1,5.76-6.06c1-.81,1.93-1.61,2.89-2.24a26.08,26.08,0,0,1,2.66-1.74c.82-.53,1.62-.9,2.3-1.26a15.64,15.64,0,0,1,1.8-.83,10.79,10.79,0,0,1,1.57-.6,10.46,10.46,0,0,1-1.49.78c-.49.23-1.08.52-1.74.91s-1.45.77-2.25,1.31a31.2,31.2,0,0,0-2.6,1.78c-.93.64-1.84,1.44-2.82,2.25a42.86,42.86,0,0,0-10.08,13c-.54,1.15-1.09,2.23-1.47,3.29a31.17,31.17,0,0,0-1.07,3c-.33.91-.51,1.76-.71,2.5s-.34,1.39-.44,1.92A9.93,9.93,0,0,1,207.55,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "131.29 276.58 127.48 268.82 172.34 246.17 197.59 234.17 200.14 235.85 187.49 281.22 179.89 284.86 177.68 289.69 130.75 278.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54,238a16.18,16.18,0,0,1-1.44,1.12,39.08,39.08,0,0,0-3.76,3.26,35.86,35.86,0,0,0-10.52,29.84,41.06,41.06,0,0,0,.88,4.9,15.51,15.51,0,0,1,.43,1.78s-.08-.14-.19-.44-.27-.72-.43-1.29a31.38,31.38,0,0,1-1-4.9,34.92,34.92,0,0,1,10.62-30.15A32.34,32.34,0,0,1,201,239c.48-.35.88-.57,1.14-.74S202.53,238,202.54,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89,287a1.88,1.88,0,0,1-.42-.24l-1.15-.76c-.49-.34-1.09-.75-1.83-1.17s-1.53-1-2.49-1.44-2-1.05-3.11-1.54-2.39-1-3.7-1.52a56.87,56.87,0,0,0-8.83-2.36,56,56,0,0,0-9.1-.74c-1.41,0-2.75.05-4,.19s-2.41.25-3.46.41-2,.36-2.83.51-1.54.34-2.11.49l-1.34.33a1.9,1.9,0,0,1-.47.09s.14-.08.44-.19l1.31-.42a20.19,20.19,0,0,1,2.11-.58c.83-.19,1.77-.45,2.83-.6s2.22-.37,3.48-.47,2.6-.19,4-.24a53.75,53.75,0,0,1,9.2.71,54.34,54.34,0,0,1,8.91,2.42c1.32.53,2.58,1,3.71,1.58a34.35,34.35,0,0,1,3.11,1.61c.95.5,1.75,1.06,2.47,1.51a20.35,20.35,0,0,1,1.79,1.25l1.09.85C178.78,286.85,178.9,287,178.89,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,309.33a12.41,12.41,0,0,1,1.09-1.35,16,16,0,0,1,1.39-1.5c.57-.55,1.19-1.22,2-1.85l1.2-1c.42-.35.9-.67,1.37-1,.93-.73,2-1.37,3.14-2.08a40.61,40.61,0,0,1,16.27-5.42c1.33-.11,2.58-.24,3.76-.22.59,0,1.16,0,1.71,0l1.57.1a25.92,25.92,0,0,1,2.69.3,16.91,16.91,0,0,1,2,.36,12.88,12.88,0,0,1,1.68.43,10.53,10.53,0,0,1-1.72-.23c-.55-.1-1.22-.21-2-.28s-1.67-.21-2.67-.21l-1.56-.06c-.54,0-1.1,0-1.69,0-1.16,0-2.4.15-3.71.27a46.24,46.24,0,0,0-8.32,1.86,45.72,45.72,0,0,0-7.77,3.5c-1.12.68-2.2,1.31-3.13,2-.47.34-.95.65-1.37,1l-1.21,1c-.79.6-1.42,1.25-2,1.78a19.6,19.6,0,0,0-1.44,1.42A9.74,9.74,0,0,1,138.76,309.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.42,316.5a9.62,9.62,0,0,1,1.1-1.28l.61-.67.78-.74c.57-.52,1.2-1.14,2-1.73.39-.31.79-.62,1.2-1l1.36-.95c.93-.68,2-1.27,3.11-1.93a48.9,48.9,0,0,1,7.66-3.39,52.52,52.52,0,0,1,8.15-2c1.28-.16,2.49-.35,3.64-.41s2.21-.13,3.18-.14,1.86,0,2.63.06a19.2,19.2,0,0,1,2,.15,10.36,10.36,0,0,1,1.68.25,11.42,11.42,0,0,1-1.69,0c-.54,0-1.2-.07-2-.07s-1.65,0-2.61,0-2,.08-3.16.2-2.33.28-3.59.46a54.93,54.93,0,0,0-8.06,2,52.59,52.59,0,0,0-7.6,3.31c-1.1.66-2.17,1.23-3.1,1.88l-1.36.92-1.21.92c-.78.56-1.43,1.16-2,1.66l-.81.7-.64.63A9,9,0,0,1,141.42,316.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.05,325.67a20.09,20.09,0,0,1,1.58-2.83c1-1.72,2.49-4.06,4.12-6.64l3.31-5.13v.22c-.65-1.35-1.17-2.46-1.53-3.25a5.56,5.56,0,0,1-.49-1.27,5.54,5.54,0,0,1,.72,1.15c.42.76,1,1.85,1.69,3.17l.05.11-.07.11-3.23,5.17c-1.63,2.58-3.14,4.89-4.25,6.55A19.54,19.54,0,0,1,148.05,325.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,366.76a7.48,7.48,0,0,1,.39-1.29A12.21,12.21,0,0,1,177,364c.26-.56.52-1.22.91-1.9a23.25,23.25,0,0,1,1.3-2.2c.48-.78,1.09-1.56,1.71-2.38a33.69,33.69,0,0,1,4.72-4.79,34.08,34.08,0,0,1,5.62-3.67,27.83,27.83,0,0,1,2.68-1.2,21.85,21.85,0,0,1,2.41-.84,20.46,20.46,0,0,1,2-.52,12,12,0,0,1,1.57-.28,6.08,6.08,0,0,1,1.34-.13c0,.11-1.9.33-4.84,1.28a24.53,24.53,0,0,0-2.36.89c-.85.32-1.7.77-2.62,1.22a36.25,36.25,0,0,0-5.51,3.66,35.64,35.64,0,0,0-4.68,4.68c-.62.8-1.23,1.56-1.72,2.32a23.37,23.37,0,0,0-1.33,2.14C176.67,365,176.08,366.8,176,366.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,371a5.71,5.71,0,0,1,.4-1.22,13.59,13.59,0,0,1,.59-1.4c.25-.53.52-1.15.89-1.79a33.12,33.12,0,0,1,2.85-4.39,37.45,37.45,0,0,1,4.36-4.69,37.86,37.86,0,0,1,5.16-3.79,31.5,31.5,0,0,1,4.68-2.32c.68-.3,1.33-.49,1.89-.69a13.23,13.23,0,0,1,1.45-.42,5.66,5.66,0,0,1,1.26-.26c0,.1-1.76.54-4.46,1.71a35.88,35.88,0,0,0-4.57,2.39,40.43,40.43,0,0,0-5.07,3.77,38.86,38.86,0,0,0-4.32,4.6,34.49,34.49,0,0,0-2.9,4.27C180.69,369.33,180.05,371.05,180,371Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.23,303.53a7,7,0,0,1-1.44.18c-.46,0-1,.09-1.69.18s-1.4.16-2.22.32a49.77,49.77,0,0,0-5.7,1.27,55.06,55.06,0,0,0-6.7,2.47,52.83,52.83,0,0,0-6.26,3.43,48.8,48.8,0,0,0-4.71,3.45c-.66.51-1.2,1-1.7,1.47s-.91.83-1.24,1.16a6.83,6.83,0,0,1-1.09,1,9.56,9.56,0,0,1,.94-1.11c.31-.35.71-.77,1.19-1.22s1-1,1.66-1.54A42.57,42.57,0,0,1,232,311a48.48,48.48,0,0,1,6.32-3.5,49.35,49.35,0,0,1,6.78-2.46,45,45,0,0,1,5.78-1.18c.82-.13,1.58-.18,2.24-.24s1.24-.08,1.71-.09A8.53,8.53,0,0,1,256.23,303.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.45,308.79a7.47,7.47,0,0,1-1.42.3c-.92.14-2.24.4-3.86.77s-3.52.9-5.6,1.59a63.52,63.52,0,0,0-6.6,2.7,65.48,65.48,0,0,0-6.21,3.51,57.84,57.84,0,0,0-4.72,3.41c-1.29,1-2.32,1.92-3,2.55a7.27,7.27,0,0,1-1.11.93,7.53,7.53,0,0,1,1-1.08,38.11,38.11,0,0,1,2.9-2.68,49.8,49.8,0,0,1,4.7-3.53A51.85,51.85,0,0,1,246.41,311a50.24,50.24,0,0,1,5.68-1.5,37.23,37.23,0,0,1,3.91-.61A8.2,8.2,0,0,1,257.45,308.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,275.43c-7.37-2-15.75.68-21.28,5.95s-8.71,12.62-10.22,20.11l-2.9-3.21c1.51-7.49,5.15-15.44,10.68-20.71s14.16-8.12,21.53-6.11A23.9,23.9,0,0,1,246.73,275.43Z",
    style: {
      fill: "#738CA2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M142.61,315.24c.94.89,3.31.63,4.59-.3,1.61-1.18,3.31-3.86,4.62-4.73,7.61-5,15.2-2.33,25.2-6.4.19-.07.44-.06.57-.23a.55.55,0,0,0-.18-.75,1.45,1.45,0,0,0-.82-.23c-12.37-1.09-24.71,4.08-34,12.64"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M208.07,292.42c3.36-5.93,4-13.33,8.39-18.53,3.77-4.47,9.87-6.71,13-11.65a40.54,40.54,0,0,0-22,29.57"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,367.52a28.58,28.58,0,0,0,25.55-12.16,2.5,2.5,0,1,0-4.32-2.52,23.57,23.57,0,0,1-21.23,9.68,2.52,2.52,0,0,0-2.5,2.5,2.55,2.55,0,0,0,2.5,2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56,228.7a3.71,3.71,0,0,1-.59.53l-1.77,1.44c-.77.63-1.72,1.38-2.86,2.2s-2.4,1.82-3.87,2.8-3.06,2.12-4.82,3.22-3.66,2.28-5.67,3.48c-4.06,2.33-8.62,4.74-13.54,7s-9.74,4.1-14.16,5.63c-2.23.73-4.34,1.45-6.35,2s-3.87,1.1-5.59,1.53-3.28.78-4.65,1.09-2.56.54-3.54.71l-2.25.4a4.55,4.55,0,0,1-.78.1,4,4,0,0,1,.77-.21l2.22-.49c1-.2,2.15-.45,3.51-.79s2.93-.68,4.63-1.17,3.58-1,5.56-1.58,4.09-1.3,6.31-2c4.4-1.56,9.19-3.43,14.11-5.65s9.44-4.64,13.51-7c2-1.18,3.93-2.29,5.68-3.42s3.37-2.17,4.84-3.16,2.76-1.92,3.91-2.73,2.12-1.53,2.9-2.13l1.83-1.36C195.33,228.85,195.55,228.69,195.56,228.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,242.13a7.06,7.06,0,0,1-1,.84c-.69.52-1.72,1.23-3,2.07A92,92,0,0,1,167.31,251a93.26,93.26,0,0,1-11.19,4.5c-1.47.48-2.67.83-3.51,1a6.06,6.06,0,0,1-1.31.29,7.62,7.62,0,0,1,1.25-.48c.82-.27,2-.68,3.45-1.2a116.81,116.81,0,0,0,11.08-4.62,118.29,118.29,0,0,0,10.54-5.75c1.32-.8,2.37-1.46,3.09-1.93A6.66,6.66,0,0,1,181.87,242.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.64,402.16Q217,394.3,227,387.3a2.56,2.56,0,0,0,.9-3.42,2.52,2.52,0,0,0-3.42-.9q-10.55,7.36-20.4,15.65a2.5,2.5,0,0,0,0,3.53,2.54,2.54,0,0,0,3.53,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.85,314s7.39,4,8.1,6.87,3.4,24.51,3.4,24.51l-2.58,3.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,348.91c-.14,0-2.13-8.4-4.45-18.84s-4.08-18.94-3.93-19,2.13,8.41,4.44,18.85S266.73,348.88,266.59,348.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.72,380.67a3.17,3.17,0,0,1-.49-3.61c1.7-3.27,5.21-9.21,7.13-8.5s10.87,12.57,14.41,17.39a3.1,3.1,0,0,1-.17,3.9l-4.06,4.64a2.57,2.57,0,0,1-3.82.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.72,380.67s.2.15.54.49l1.46,1.5,5.32,5.55,3.65,3.86,2,2.15a2.38,2.38,0,0,0,2.58.8,2.41,2.41,0,0,0,1.2-.86l1.1-1.25,2.25-2.59a5.41,5.41,0,0,0,1-1.35,2.78,2.78,0,0,0,.22-1.61,3.12,3.12,0,0,0-.71-1.52l-1.1-1.48c-3-4-5.81-7.73-8.53-11A31.17,31.17,0,0,0,190.6,369c-.69-.6-1.55.11-2.15.65a13.77,13.77,0,0,0-1.64,1.9,42.85,42.85,0,0,0-2.38,3.66l-.88,1.56a3.78,3.78,0,0,0-.54,1.36,3.16,3.16,0,0,0,.33,2c.22.42.4.6.38.62a2.11,2.11,0,0,1-.47-.56,3.15,3.15,0,0,1-.44-2.06,4.1,4.1,0,0,1,.52-1.45l.85-1.59a38.87,38.87,0,0,1,2.33-3.73,14.83,14.83,0,0,1,1.66-2,4.68,4.68,0,0,1,1.14-.84,1.65,1.65,0,0,1,.77-.18,1.51,1.51,0,0,1,.76.3A29.9,29.9,0,0,1,195.1,373c2.76,3.31,5.63,7.06,8.59,11l1.1,1.48a3.61,3.61,0,0,1,.8,1.75,3.33,3.33,0,0,1-.26,1.9,3.25,3.25,0,0,1-.51.81l-.58.66L202,393.23l-1.1,1.26a3,3,0,0,1-1.42,1,2.86,2.86,0,0,1-3.06-1l-2-2.16c-1.29-1.4-2.49-2.71-3.6-3.9-2.16-2.37-3.93-4.29-5.19-5.68l-1.4-1.56A5.3,5.3,0,0,1,183.72,380.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,276.32a11.07,11.07,0,0,1-1.59.34,40.17,40.17,0,0,0-4.3,1.1,35.59,35.59,0,0,0-21.46,18.56,38.4,38.4,0,0,0-1.71,4.09,11.68,11.68,0,0,1-.57,1.53,1.87,1.87,0,0,1,.07-.42c.07-.27.15-.67.31-1.17a29.62,29.62,0,0,1,1.56-4.19,34.34,34.34,0,0,1,21.7-18.75,31.42,31.42,0,0,1,4.36-1c.52-.08.93-.1,1.21-.13A1.9,1.9,0,0,1,245.5,276.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.83,281.05a8.46,8.46,0,0,1-1.5.44c-.49.12-1.09.27-1.77.48s-1.47.41-2.31.71a58.81,58.81,0,0,0-5.87,2.29,63.61,63.61,0,0,0-6.77,3.66,61.14,61.14,0,0,0-6.22,4.55,55.35,55.35,0,0,0-4.58,4.31c-.64.63-1.16,1.25-1.64,1.78s-.88,1-1.19,1.39a11.61,11.61,0,0,1-1,1.17,8.6,8.6,0,0,1,.88-1.3c.29-.41.66-.9,1.13-1.45s1-1.19,1.59-1.84a51.08,51.08,0,0,1,4.54-4.43,53.13,53.13,0,0,1,13.11-8.28,52.08,52.08,0,0,1,5.95-2.2c.85-.28,1.65-.46,2.35-.64s1.29-.31,1.79-.4A8.18,8.18,0,0,1,248.83,281.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.14,345.19a7.69,7.69,0,0,1,.8-1.16,15,15,0,0,1,1.05-1.29c.44-.49.9-1.06,1.5-1.62a34.8,34.8,0,0,1,4.35-3.75,37,37,0,0,1,12.65-6,36.21,36.21,0,0,1,5.65-1c.81-.11,1.56-.11,2.2-.14a15.11,15.11,0,0,1,1.67,0,6.37,6.37,0,0,1,1.41.11c0,.11-2,0-5.24.39a38.94,38.94,0,0,0-5.57,1.09,39.16,39.16,0,0,0-12.49,5.93,39.61,39.61,0,0,0-4.37,3.63C161.42,343.63,160.22,345.26,160.14,345.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.25,331.51a6.1,6.1,0,0,1-1.21.59l-3.35,1.47c-2.82,1.26-6.68,3.09-10.81,5.36s-7.74,4.55-10.31,6.25l-3,2a5.9,5.9,0,0,1-1.15.71,6.73,6.73,0,0,1,1-.87c.68-.54,1.69-1.29,3-2.18a109.87,109.87,0,0,1,21.18-11.65c1.44-.59,2.61-1,3.43-1.32A6.92,6.92,0,0,1,192.25,331.51Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagenot);
export default __webpack_public_path__ + "static/media/pagenot.ab9bdaa089bd2a6a0f17b1930c462816.svg";
export { ForwardRef as ReactComponent };